export const english = {
    NAZEV: 'Name',
    ZDE: 'here',
    EMP_POTVRZENI_EMAIL_NADPIS: 'Confirm email address change',
    EMP_POTVRZENI_EMAIL_200: 'The password was successfully changed. You can now sign in using your new password.',
    EMP_POTVRZENI_EMAIL_401: 'The sent link has expired. Send a new request to change your e-mail.',
    EMP_POTVRZENI_EMAIL_404: 'Invalid email or password.',
    EMP_AKTIVACE_OK: 'The account was successfully activated. You can sign up.',
    EMP_AKTIVACE_401: 'The page has expired. Please register again to open an account.',
    EMP_INFO_ZMENA_LOGIN_ZADEJTE: 'Please enter your user name and password.',
    EMP_INFO_ZMENA_OBNOVENI_HESLO: 'Password succesfull changed',
    NEVALIDNI_POVINNA_POLOZKA: 'Value must be filled in.',
    NEVALIDNI_EMAIL: 'Invalid email',
    NEVALIDNI_EMAIL_TWO: 'Fill in only 1 email address',
    NEVALIDNI_EMAIL_SHODA: 'The e-mail addresses you entered do not match',
    NEVALIDNI_NACE: 'Non-existent NACE code',
    NEVALIDNI_RC: 'Non-aliased birth number',
    NEVALIDNI_ICO: 'Invalid Business Registry Identifier',
    NEVALIDNI_PROCENTA_100: 'The entry may only contain numbers (s max. 2 decimal places) less than or equal to 100',
    NEVALIDNI_CISLO_DESETINNE_2: 'The entry may only contain numbers (s max. 2 decimal places)',
    NEVALIDNI_NUM: 'Item may only contain digits',
    NEVALIDNI_NENI_FO: 'Subject is not a natural person',
    FORMULARE_RODNE_CISLO: 'birth number',
    FORMULARE_ZEME_PUVODU: 'country of origin',
    FORMULARE_ZEME_SIDLA: 'country of residence',
    FORMULARE_CEKANI_NA_ZPRACOVANI_AMLZ:
        'Waiting for the AMLZ application to be processed. They will be informed of this possibility by e-mail.',
    FORMULARE_LEI_ZRUSENE: 'Your LEI is cancelled.',
    FORMULARE_LEI_VEDENO_PRO_JINOU_SPOL: 'Your LEI is registered to another company. Correct the specified LEI.',
    EMITENTSKA_AUTOMATICKE_ODHLASEN:
        "Automatic checkout is imminent for security reasons. Press 'OK' to extend the interval.",
    EMP_REGISTRACE_OK:
        'To successfully complete your registration, you need to activate a referral account that has been sent to the e-mail listed at registration.',
    EMP_AMLZ_DLAZDICE_NADPIS_DOTAZNIK: 'Questionnaire to check issuer by AMLZ',
    EMP_ISIN_DLAZDICE_NADPIS_SEZNAM: 'ISIN list',
    EMP_PODANE_ZADOSTI_SEZNAM_ZADOSTI: 'List of selected requests',
    EMP_PODANE_ZADOSTI_ICO: 'Identification number (ID No/NID)',
    EMP_PODANE_ZADOSTI_NAZEV_SPOLECNOSTI: 'Company Name',
    EMP_PODANE_ZADOSTI_DATUM_PODANI: 'Date of administration',
    EMP_PODANE_ZADOSTI_CHYBA_SMAZANI: 'Failed to cancel selected request',
    EMP_PODANE_ZADOSTI_POTVRDIT_SMAZANI: 'Do you really want to cancel the selected request?',
    EMP_PODANE_ZADOSTI_ZADOST_BYLA_ZRUSENA: 'The selected request has been canceled.',
    EMP_PODANE_ZADOSTI_ZADOST_BYLA_ZAMITNUTA: 'The selected request was rejected.',
    EMP_PODANE_ZADOSTI_ODESLANA: 'Received to CDCP',
    EMP_PODANE_ZADOSTI_ROZPRACOVANA: 'Processed',
    EMP_PODANE_ZADOSTI_ZNEPLATNENO: 'Deflated',
    EMP_PODANE_ZADOSTI_ZRUSENA: 'Cancelled',
    EMP_PODANE_ZADOSTI_AKCEPTOVANO: 'Accepted',
    EMP_PODANE_ZADOSTI_ZAMITNUTO: 'Denied',
    EMP_PODANE_ZADOSTI_K_DOPLNENI: 'To be completed',
    EMP_PODANE_ZADOSTI_AKTUALIZOVAT: 'To update',
    EMP_PODANE_ZADOSTI_BYLA_ZNEPLATNENA: 'The selected request has been invalidated.',
    EMP_PODANE_ZADOSTI_409_ZRUSENA: 'The selected request has been canceled.',
    EMP_PODANE_ZADOSTI_409_ZNEPLANTNENA: 'The selected request has been invalidated.',

    EMP_LOGIN_PODNADPIS_MOZNOSTI: 'Select one of the following options to log in:',
    EMP_LOGIN_CERTIFIKAT_VYSTAVITEL: 'Certificate Issuer',
    EMP_VYBER_PROFIL_VYBERTE_SUBJEKT: 'Select subject',
    EMP_VYBER_PROFIL_RESP_401_CHYBI: 'Your system does not have a certificate to communicate with Confidential Area.',
    EMP_VYBER_PROFIL_RESP_401_NENALEZEN:
        'When you attempted to log in, you proved yourself with a certificate that is not registered in the Confidential Area.',

    ISIN_ROZCESTNIK_HELP:
        'In the event of a change of form, indicate the new form, e.g. tick "book entry" when converting from paper to book entry',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT: 'Issuer requesting ISIN',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_UI:
        'Is a credit or financial institution based in EU countries or applying equivalent AMLZ requirements',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_UO:
        'Is a central organ of the state administration, the CNB or a higher territorial self-governing entity',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_EM:
        'It is the issuer whose securities are admitted to trading on a regulated market based in EU countries or in a country applying equal AMLZ requirements',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_FO: 'Is a natural person',
    ISIN_ROZCESTNIK_PRIDELENI_EMITENT_NA: 'They do not belong to either of the above groups',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN: 'Issuer requests ISIN allocation',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_LIST: 'Documentary',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_ZAKN: 'Feathered',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_IMOB: 'Immobilized',
    ISIN_ROZCESTNIK_PRIDELENI_ISIN_SBER: 'Documentary - collection form',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA: 'The person in charge of the book entry CP, immobilised CP or collection bond is',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CDCP: 'CDCP',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_CNB: 'CNB',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_MF: 'MF',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY: 'Other person',
    ISIN_IDENTIFIKACE_IDENTIFIKACE_EMITENTA: 'Issuer identification',
    ISIN_IDENTIFIKACE_FIRMA: 'Trading name or other issuer name',
    ISIN_IDENTIFIKACE_PRAVNI_FORMA: 'Legal form',
    ISIN_IDENTIFIKACE_ADRESA_SIDLA: 'Issuer Residence Address',
    ISIN_IDENTIFIKACE_KAPITAL: 'Share capital',
    ISIN_IDENTIFIKACE_MENA: 'Capital currency',
    ISIN_IDENTIFIKACE_SPLACENO: 'Paid in %',
    ISIN_IDENTIFIKACE_PLATCE: 'VAT Payer',
    ISIN_IDENTIFIKACE_DIC: 'VAT Tax Exempt Number',
    LEI_AKTUALIZACE_SIDLO_CENTRAL_SAME: 'The same change applies to the Headquarter Address',
    ISIN_IDENTIFIKACE_EMAIL_FAKTURY: 'Email to Send invoices',
    ISIN_IDENTIFIKACE_EMAIL_FAKTURY_HELP:
        'Email to send invoices - indicate the general email of your finance department or the person to whose email the CDCP will send tax documents for all services provided to issuers.',
    ISIN_IDENTIFIKACE_EMAIL_OSOBY: 'The email of the person filling out this ISIN request',
    ISIN_IDENTIFIKACE_TELEFON: 'Phone of the person filling out this ISIN request',
    ISIN_IDENTIFIKACE_VLASTNIK_HELP:
        'Banking connection (IBAN) - Specify the bank account that is held in the name of the issuer from which the CDCP fees (in IBAN format) will be paid. Fill the account with no spaces. To verify the accuracy of IBAN, you can use the IBAN-Czech Republic Calculator, which can be found on the website www.cnb.cz',
    ISIN_ZMENA_NADPIS_DOPLNENI:
        'Here you enter the ISIN for which you require a change of data (e.g. change of form, change of form, merger).',
    ISIN_DUVOD_ZMENA_PODNADPIS:
        'When you change your ISIN, fill in the ISINU number for which you are requesting the change and always indicate the value you are requesting to change. Always state the original value and the new value. Enter the reason for the change or (e.g. change of form, change of form, merger) in the justification. In case of incomplete information, your request will not be accepted for processing. The CDCP staff will inform the person you have in the CDCP listed as the contact person for your company.',
    ISIN_DUVOD_ZRUSENI_PODNADPIS:
        'In the request for cancellation of the ISIN, indicate the reason for cancelling the ISIN.',
    ISIN_DUVOD_ISIN: 'ISIN to date',
    ISIN_DUVOD_ISIN_NESHODA_AREM: 'The company is not listed as issuer or issuer administrator',
    ISIN_DUVOD_ZMENA_DUVODY:
        'Write here the original and new values affected by the change and the reason for the change',
    ISIN_DUVOD_ZRUSENI_DUVODY: 'Cancellation reason',
    ISIN_ZASTUPUJE_NADPIS: 'Issuer represents',
    ISIN_ZASTUPUJE_OSOBA_FODVR: 'Natural person by public record',
    ISIN_ZASTUPUJE_OSOBA_FOZPM: 'A natural person by proxy',
    ISIN_ZASTUPUJE_OSOBA_FOZJO: 'Individual on other authority',
    ISIN_ZASTUPUJE_OSOBA_PODVR: 'Legal person as extracted from public register',
    ISIN_ZASTUPUJE_OSOBA_POZPM: 'Legal person under power of attorney',
    ISIN_ZASTUPUJE_OSOBA_PRIDAT_FO: 'Add a natural person',
    ISIN_ZASTUPUJE_OSOBA_PRIDAT_PO: 'Add legal entity',
    ISIN_ZASTUPUJE_OSOBA_VYPLNTE:
        'Complete in accordance with the registration of the representation form in the Commercial Register or in accordance with the attached power of attorney.',
    ISIN_ZASTUPUJE_FO_CHYBA_RC_DATUM: 'The birth number, date of birth or both must be filled in.',
    ISIN_EMISE_UDAJ: 'Indication of planned admission of the issue to trading on a regulated market',
    ISIN_EMISE_UDAJ_NADPIS: 'Issue data',
    ISIN_EMISE_UDAJ_HELP:
        "If the issue is not traded in one of the markets and you only ask to register (book) it in a CDCP, select 'Unlisted'.",
    ISIN_EMISE_UDAJ_BCPP: 'Stock Exchange Prague, a.s.',
    ISIN_EMISE_UDAJ_RMS: 'RM-SYSTEM',
    ISIN_EMISE_UDAJ_NEKOT: 'Unlisted',
    ISIN_EMISE_UDAJ_JINY: 'Another organizer',
    ISIN_EMISE_DRUH: 'CP Type',
    ISIN_EMISE_DRUH_AKCIE: 'Shares',
    ISIN_EMISE_DRUH_DLUHOPIS: 'Debt security',
    ISIN_EMISE_DRUH_PODILLIST: 'Share Certificate (OPF, UPF)',
    ISIN_EMISE_DRUH_INVCERT: 'Investment certification',
    ISIN_EMISE_DRUH_WARRANT: 'Warrant',
    ISIN_EMISE_DRUH_NASTROJKOLINV: 'Collective investment vehicles (IFPZK, SICAV)',
    ISIN_EMISE_DRUH_JINYINVNASTROJ: 'Other Investment Facility',
    ISIN_EMISE_AKCIE_DRUH: 'Type of share',
    ISIN_EMISE_AKCIE_DRUH_KMEN: 'Tribal',
    ISIN_EMISE_AKCIE_DRUH_PRIOR: 'Priority',
    ISIN_EMISE_AKCIE_DRUH_JINA: 'Cross',
    ISIN_EMISE_AKCIE_DRUH_HELP: 'If the shares are also of a piece, then add 0 to the nominal value.',
    ISIN_EMISE_AKCIE_ODKUP: 'Share buy-back rules',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP: 'With redemption option',
    ISIN_EMISE_AKCIE_ODKUP_PRODLOUZENI: 'With Extension Option',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_PRODLOUZENI: 'With buyout option/renewal option',
    ISIN_EMISE_AKCIE_ODKUP_VYMENITELNE: 'Removable',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE: 'With buy-in/removable',
    ISIN_EMISE_AKCIE_ODKUP_ODKUP_VYMENITELNE_PRODLOUZENI: 'With Buy-Out/Removable/Renewable',
    ISIN_EMISE_AKCIE_ODKUP_VECNE: 'Eternal',
    ISIN_EMISE_AKCIE_VYNOS: 'Type of yield',
    ISIN_EMISE_AKCIE_VYNOS_P: 'Fixed',
    ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_P: 'Cumulative Fixed',
    ISIN_EMISE_AKCIE_VYNOS_PC: 'Participative',
    ISIN_EMISE_AKCIE_VYNOS_KUMULATIVNI_PC: 'Cumulative participatory',
    ISIN_EMISE_AKCIE_VYNOS_PR: 'Variable',
    ISIN_EMISE_AKCIE_VYNOS_N: 'Normal',
    ISIN_EMISE_AKCIE_VYNOS_A: 'Auction',
    ISIN_EMISE_AKCIE_HODNOTA_ZA_CP: 'Nominal value per piece of CP',
    ISIN_EMISE_AKCIE_KUSU: 'Number of Units',
    ISIN_EMISE_AKCIE_KUSU_HELP: 'Include the same number of units that you reported for the parent ISIN.',
    ISIN_EMISE_AKCIE_CELKOVA_HODNOTA: 'Total rated emission',
    ISIN_EMISE_AKCIE_PODOBA: 'Form of security',
    ISIN_EMISE_AKCIE_OSOBA: 'The person in charge of the book entry CP, immobilised CP or collection bond is',
    ISIN_EMISE_AKCIE_FORMA: 'Form of security',
    ISIN_EMISE_AKCIE_FORMA_HELP:
        'Form of the security - specify according to the articles of association or other document.',
    ISIN_EMISE_AKCIE_FORMA_NADORUCITELE: 'To bearer',
    ISIN_EMISE_AKCIE_FORMA_NAJMENO: 'In Name',
    ISIN_EMISE_AKCIE_FORMA_NARAD: 'To series',
    ISIN_EMISE_AKCIE_FORMA_NEURCENO: 'Unspecified',
    ISIN_EMISE_AKCIE_SEZNAM: 'The list of shareholders is kept by the charter of the company CDCP',
    ISIN_EMISE_AKCIE_PREVODITELNOST: 'Limited transferability of the security',
    ISIN_EMISE_AKCIE_HLASOVACI: 'Voting rights attached to shares',
    ISIN_EMISE_AKCIE_HLASOVACI_S: 'With voting rights',
    ISIN_EMISE_AKCIE_HLASOVACI_B: 'No voting rights',
    ISIN_EMISE_AKCIE_HLASOVACI_O: 'Limited vote share',
    ISIN_EMISE_AKCIE_HLASOVACI_Z: 'Increased share of votes',
    ISIN_EMISE_DLUHOPIS_SAZBA: 'Interest rate',
    ISIN_EMISE_DLUHOPIS_SAZBA_F: 'Fixed',
    ISIN_EMISE_DLUHOPIS_SAZBA_V: 'Variable',
    ISIN_EMISE_DLUHOPIS_SAZBA_Z: 'Zero bond',
    ISIN_EMISE_DLUHOPIS_SAZBA_K: 'Payments in kind',
    ISIN_EMISE_DLUHOPIS_SAZBA_VYSE: 'Rate Amount',
    ISIN_EMISE_DLUHOPIS_SAZBA_HELP: 'If the parent ISIN has a fixed interest rate, fill in 0.00 here.',
    ISIN_EMISE_DLUHOPIS_EMISNI_PODMINKY_DATUM: 'Issue terms include maturity date',
    ISIN_EMISE_DLUHOPIS_SPLATNOST: 'Due Date',
    ISIN_EMISE_DLUHOPIS_SPLATNOST_HELP2: 'Enter the coupon due date.',
    ISIN_EMISE_DLUHOPIS_DRUH: 'Type of debt CP',
    ISIN_EMISE_DLUHOPIS_DRUH_SD: 'State',
    ISIN_EMISE_DLUHOPIS_DRUH_BO: 'Banking',
    ISIN_EMISE_DLUHOPIS_DRUH_HZL: 'Mortgage pledge',
    ISIN_EMISE_DLUHOPIS_DRUH_KO: 'Communal',
    ISIN_EMISE_DLUHOPIS_DRUH_PO: 'Corporate',
    ISIN_EMISE_DLUHOPIS_DRUH_OK: 'Separated coupon',
    ISIN_EMISE_DLUHOPIS_DRUH_OJ: 'Detached principal',
    ISIN_EMISE_DLUHOPIS_DRUH_HELP: 'If you apply as a natural person, select a corporate bond.',
    ISIN_EMISE_DLUHOPIS_TYP: 'Type of debt CP for CFI',
    ISIN_EMISE_DLUHOPIS_TYP_DL: 'Bonds',
    ISIN_EMISE_DLUHOPIS_TYP_VD: 'Removable Bonds',
    ISIN_EMISE_DLUHOPIS_TYP_DS: 'Bonds linked to warrants',
    ISIN_EMISE_DLUHOPIS_TYP_NP: 'Money market instruments',
    ISIN_EMISE_DLUHOPIS_TYP_HZL: 'Mortgage Loan Sheets',
    ISIN_EMISE_DLUHOPIS_TYP_CP: 'Asset-backed securities',
    ISIN_EMISE_DLUHOPIS_TYP_KD: 'Municipal bonds',
    ISIN_EMISE_DLUHOPIS_TYP_OD: 'Other debt CP (perpetuity etc.)',
    ISIN_EMISE_DLUHOPIS_TYP_NEVHODNE_ZVOLENY: 'Inappropriately chosen type of debt CP for CFI',
    ISIN_EMISE_DLUHOPIS_ZAHRANICNI_EMITENT: 'Foreign issuer',
    ISIN_EMISE_DLUHOPIS_PRIORITNI: 'Priority',
    ISIN_EMISE_DLUHOPIS_PODRIZENY: 'Child',
    ISIN_EMISE_DLUHOPIS_VYMENITELNY: 'Removable',
    ISIN_EMISE_DLUHOPIS_ODDELENI_KUPONU: 'Right to separate coupons from principal',
    ISIN_EMISE_DLUHOPIS_ODDELENI_KUPONU_HELP: 'Provide the same as the figure in the ISIN of the parent bond.',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN:
        'The issuer requires an ISIN to be assigned to all coupons to maturity and to separate principal',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN_KUPONY: 'Number of coupons to maturity',
    ISIN_EMISE_DLUHOPIS_PRIDELIT_ISIN_KUPONY_HELP:
        'Indicate the number of coupons for which an ISIN will be allocated.',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM: 'Issue conditions',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NPS: 'They do not allow prepayment',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS: 'Allow prepayment',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_EM: 'The issuer may require a repurchase (full principal)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_DRZ: 'The holder may require redemption (full principal)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPS_PEVNA:
        'Fixed maturity — both issuer and holder may require redemption (full principal)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE: 'They allow for a gradual repayment of the issue',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_UMOR: 'Gradual repayment - amortisation of principal',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_EM:
        'staged repayment - the issuer may require redemption (principal outstanding)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_DRZ:
        'Gradual repayment - the holder may require redemption (principal outstanding)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UPSE_OBA:
        'Phased repayment - both issuer and holder may require redemption (principal outstanding)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS: 'They do not include a due date',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_VEC: 'Eternal (perpetual)',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_EM: 'Perpetual - an issuer may require a buy-back',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_NDS_DRZ: 'Eternal (perpetual) - holder can demand buy-out',
    ISIN_EMISE_DLUHOPIS_EMIS_PODM_UMP: 'Allow for extension',
    ISIN_EMISE_DLUHOPIS_FREKVENCE: 'Coupon payout frequency',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_A: 'Yearly',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_S: 'Half-yearly',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_Q: 'Quarterly',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_M: 'Monthly',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_W: 'Weekly',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_D: 'Daily',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_B: 'Once every two years',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_X: 'Other frequencies',
    ISIN_EMISE_DLUHOPIS_FREKVENCE_NA: 'Unable to determine',
    ISIN_EMISE_DLUHOPIS_ZARUCENI: 'Issue Guarantee Information',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_VZ: 'Government guarantee',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_SZ: 'Common guarantee',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_Z: 'Secured',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NEZ: 'Unsecured',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NZ: 'Negative warranty',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_S: 'Senior',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_SP: 'Senior Subordinate',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_J: 'Juniory',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_JP: 'Junior Subordinate',
    ISIN_EMISE_DLUHOPIS_ZARUCENI_NA: 'Transnational',
    ISIN_EMISE_LIST_ZISK: 'How to use profit from fund income',
    ISIN_EMISE_LIST_TYP: 'Unit certificate type',
    ISIN_EMISE_CERTIFIKAT_DRUH: 'Certificate Type',
    ISIN_EMISE_CERTIFIKAT_DRUH_PAKOVY: 'Leverage',
    ISIN_EMISE_CERTIFIKAT_DRUH_NEPAKOVY: 'Nonlegal',
    ISIN_EMISE_CERTIFIKAT_SPLATNOST: 'Issue terms allow early maturity',
    ISIN_EMISE_CERTIFIKAT_SAZBA_Z: 'Other',
    ISIN_EMISE_CERTIFIKAT_SAZBA_POPISTE: 'Describe',
    ISIN_EMISE_CERTIFIKAT_ZARUCENI: 'Issue Guarantee Information',
    ISIN_EMISE_CERTIFIKAT_CP_HELP: 'For a certificate without a nominal value, fill in 0',
    ISIN_EMISE_CERTIFIKAT_TYP: 'Certificate type',
    ISIN_EMISE_CERTIFIKAT_TYP_S: 'Followers',
    ISIN_EMISE_CERTIFIKAT_TYP_CNV: 'Certificate with overflow yield',
    ISIN_EMISE_CERTIFIKAT_TYP_B: 'Bonus',
    ISIN_EMISE_CERTIFIKAT_TYP_BNV: 'Bonus with overflow yield',
    ISIN_EMISE_CERTIFIKAT_TYP_CDV: 'Double Benefit Certificate',
    ISIN_EMISE_CERTIFIKAT_TYP_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_VYPLATY: 'Payouts',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_D: 'Dividends',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_Z: 'None',
    ISIN_EMISE_CERTIFIKAT_VYPLATY_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_SPLACENI: 'Repayment',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_SH: 'Cash repayment',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_FS: 'Physical Repayment',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_VV: 'Settlement Choice',
    ISIN_EMISE_CERTIFIKAT_SPLACENI_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_AKTIVA: 'Underlying assets',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_K: 'Trash',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_A: 'Shares',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_DN: 'Debt instruments',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_D: 'Derivatives',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_KOM: 'Commodities',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_M: 'Currencies',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_I: 'Indexes',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_UM: 'Interest rates',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_N_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_K: 'Trash',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_A: 'Shares',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_DNUS: 'Debt instruments/interest rates',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_KOM: 'Commodities',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_M: 'Currencies',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_I: 'Indexes',
    ISIN_EMISE_CERTIFIKAT_AKTIVA_P_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV: 'The type of envy at the barrier',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_PA: 'Barrier based on underlying asset',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_N: 'Tool-based barrier',
    ISIN_EMISE_CERTIFIKAT_TYP_ZAV_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_DK: 'Long/short',
    ISIN_EMISE_CERTIFIKAT_DK_D: 'Long',
    ISIN_EMISE_CERTIFIKAT_DK_K: 'Short',
    ISIN_EMISE_CERTIFIKAT_DK_O: 'Others',
    ISIN_EMISE_CERTIFIKAT_OPCE: 'Option exercise type',
    ISIN_EMISE_WARRANT_DRUH: 'Type of warrant',
    ISIN_EMISE_WARRANT_SAZBA: 'Interest rate',
    ISIN_EMISE_WARRANT_SAZBA_F: 'Fixed',
    ISIN_EMISE_WARRANT_SAZBA_V: 'Variable',
    ISIN_EMISE_WARRANT_SAZBA_Z: 'Other',
    ISIN_EMISE_WARRANT_SAZBA_N: 'Not provided',
    ISIN_EMISE_WARRANT_SAZBA_FIXNI_VYSE: 'Rate Amount',
    ISIN_EMISE_WARRANT_EMISNI_PODMINKY: 'Issue terms include maturity date',
    ISIN_EMISE_WARRANT_PODKLAD: 'Underlying asset',
    ISIN_EMISE_WARRANT_PODKLAD_KA: 'Asset Trays',
    ISIN_EMISE_WARRANT_PODKLAD_A: 'Shares',
    ISIN_EMISE_WARRANT_PODKLAD_DN: 'Debt instruments',
    ISIN_EMISE_WARRANT_PODKLAD_K: 'Commodities',
    ISIN_EMISE_WARRANT_PODKLAD_M: 'Currencies',
    ISIN_EMISE_WARRANT_PODKLAD_I: 'Indexes',
    ISIN_EMISE_WARRANT_PODKLAD_O: 'Others',
    ISIN_EMISE_WARRANT_TYP: 'Type of warrant',
    ISIN_EMISE_WARRANT_TYP_T: 'Traditional',
    ISIN_EMISE_WARRANT_TYP_N: 'Naked',
    ISIN_EMISE_WARRANT_TYP_K: 'Covered',
    ISIN_EMISE_WARRANT_TYP_HELP:
        'Traditional warrants - issued by the issuer of the underlying instrument.Naked warrants - the issuer of a warrant does not hold as many securities as it would need if all warrants were applied. Covered warrants - the issuer of a warrant holds as many securities as it would need if all warrants were applied.',
    ISIN_EMISE_WARRANT_WARR: 'Warrant',
    ISIN_EMISE_WARRANT_WARR_N: 'Shopping',
    ISIN_EMISE_WARRANT_WARR_P: 'Sales',
    ISIN_EMISE_WARRANT_WARR_NP: 'Buying and selling',
    ISIN_EMISE_WARRANT_OPCE: 'Option exercise method',
    ISIN_EMISE_WARRANT_OPCE_E: 'European',
    ISIN_EMISE_WARRANT_OPCE_A: 'American',
    ISIN_EMISE_WARRANT_OPCE_B: 'Bermuda',
    ISIN_EMISE_WARRANT_OPCE_O: 'Others',
    ISIN_EMISE_WARRANT_ZARUCENI: 'Issue Guarantee Information',
    ISIN_EMISE_WARRANT_ZARUCENI_ST: 'State',
    ISIN_EMISE_WARRANT_ZARUCENI_JS: 'Guaranteed by another entity',
    ISIN_EMISE_WARRANT_ZARUCENI_HZL: 'HZL/receivable',
    ISIN_EMISE_WARRANT_ZARUCENI_BEZ: 'No warranty',
    ISIN_EMISE_LIST_ZISK_VF: 'Income funds',
    ISIN_EMISE_LIST_ZISK_AF: 'Accumulation funds',
    ISIN_EMISE_LIST_ZISK_SF: 'Mixed funds',
    ISIN_EMISE_LIST_AKTIVA: 'The types of assets the fund invests in',
    ISIN_EMISE_LIST_AKTIVA_N: 'Real estate',
    ISIN_EMISE_LIST_AKTIVA_DN: 'Debt instruments (the fund invests in debt instruments regardless of their maturity)',
    ISIN_EMISE_LIST_AKTIVA_A: 'Shares',
    ISIN_EMISE_LIST_AKTIVA_VCP: 'Removable securities',
    ISIN_EMISE_LIST_AKTIVA_S: 'Mixed (fund invests in various assets)',
    ISIN_EMISE_LIST_AKTIVA_K: 'Commodities',
    ISIN_EMISE_LIST_AKTIVA_D: 'Derivatives',
    ISIN_EMISE_LIST_AKTIVA_RN: 'Reference instruments excluding commodities',
    ISIN_EMISE_LIST_AKTIVA_U: 'Loans',
    ISIN_EMISE_LIST_AKTIVA_O: 'Other (miscellaneous)',
    ISIN_EMISE_LIST_TYP_O: 'Open',
    ISIN_EMISE_LIST_TYP_U: 'Closed',
    ISIN_EMISE_LIST_ZKRACENY_NAZEV: 'Short Name',
    ISIN_EMISE_LIST_OMEZENI: 'Restrictions for investors',
    ISIN_EMISE_LIST_OMEZENI_RETAIL: 'PL (retail and/or qualified/institutional/professional investors)',
    ISIN_EMISE_LIST_OMEZENI_KVALIF: 'PL for qualified investors (only qualified/institutional/professional investors)',
    ISIN_EMISE_KOLEKTIVNI_ZKRACENY_NAZEV_HELP:
        'It is the name of a SICAV (IFPZK) or SICAV (IFPZK) investment stock and the field is at max. 35 characters including spaces.',
    ISIN_EMISE_KOLEKTIVNI_ZASADY: 'Payroll policy',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_V: 'Income funds (the fund regularly distributes profits from investments)',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_A: 'Accumulation funds (the fund usually reinvests the investment gains)',
    ISIN_EMISE_KOLEKTIVNI_ZASADY_S: 'Mixed funds (investment gains are partly distributed and partly reinvested)',
    ISIN_EMISE_KOLEKTIVNI_TYP: 'Type of security and restrictions for investors',
    ISIN_EMISE_KOLEKTIVNI_TYP_RETAIL: 'Shares (retail and/or qualified/institutional/professional investors)',
    ISIN_EMISE_KOLEKTIVNI_TYP_KVALIF:
        'Shares for qualified investors (only qualified/institutional/professional investors)',
    ISIN_EMISE_KOLEKTIVNI_NAV: 'NAV per share',
    ISIN_EMISE_SOUBORY_AKCIE_HELP: 'Insert an extract from the OR, articles of association, etc.',
    ISIN_EMISE_SOUBORY_DLUHOPIS_HELP: 'Enter the issuance terms or equivalent document describing the security.',
    ISIN_EMISE_SOUBORY_JINY_HELP: 'Enter a document specifying this investment vehicle.',
    ISIN_EMISE_SOUBORY_KOLEKTIVNI_HELP:
        'You can insert a fund status or other document describing the investment vehicle.',
    ISIN_EMISE_SOUBORY_LIST_HELP: 'You can insert, for example, a fund status.',
    ISIN_EMISE_SOUBORY_WARRANT_HELP: 'Enter emission conditions or equivalent document.',
    ISIN_PODPIS_PODNADPIS: 'Please fill in the details of the person submitting the application here.',
    ISIN_PODPIS_PODAL: 'Request filed by',
    SOUBOR_CHYBA_PODPIS: 'Wrong file signature, please sign it the right way',
    /////////////////////////////////////////////////////////////////////// koniec novych textov //////////////////////////////////////////////////////////////////
    NAPOVEDA: 'Help',
    UZIVATEL: 'User',
    PRIHLASIT_SE: 'Log in',
    ODHLASIT: 'Log out',
    ODHLASIT_SE: 'Log out',
    UPOZORNENI: 'Warning',
    ZAVRIT: 'Close',
    EMITENT: 'Issuer',
    ZAPOMENUTE_HESLO: 'Forgotten password',
    ZAPOMENUTE_HESLO_INFO:
        'You will receive password recovery link only if you provided e-mail identical with e-mail used at registration.',
    CHYBA: 'Error',
    ZADOST_O_AMLZ: 'Application for AMLZ',
    ZADOST_O_LEI: 'LEI Application',
    POKRACOVAT: 'Continue',
    ZPET: 'Back',
    ZRUSIT_ZADOST: 'Cancel application',
    ZMENA_EMAIL_FAILED: 'Email adress was not changed.',
    ZMENA_UDAJU_SUCESS: 'Information was changed sucessfully.',
    ZMENA_UDAJU_FAILED: 'Information was not changed.',
    ICO: 'Company Registration Number',
    ICO_ZKRATKA: 'CRN',
    DATUM_UVEREJNENI: 'Date of publication',
    SOUBOR: 'File',
    SOUBOR_DALSI: 'Another file',
    IC_EMITENTA: 'Issuer number',
    NAZEV_EMITENTA: 'Issuer name',
    PREJIT_NA_CDCP: 'Go to cdcp.cz',
    CHYBNY_NID: 'Invalid NID',
    CHYBNE_LEI: 'Invalid LEI',
    CHYBNE_LEI2:
        'Invalid LEI - For this type of application, you must provide the LEI of the parent company that is a Government Entity (Entity Category = RESIDENT GOVERNMENT ENTITY).',
    ZMENA_HESLA: 'Password change',
    ZMENA_EMAILU: 'E-mail change',
    PROFIL: 'Profile',
    DUVOD: 'Description',
    STAHNOUT: 'Download',
    ZRUSIT: 'Cancel',
    NACITANI: 'Loading',
    NACITANI_DAT: 'Loading data from register, please be patient',
    KOMERCNI_CERTIFIKAT: 'Comercial certificate',
    UZIVATELSKE_JMENO: 'Username',
    ODESLAT: 'Send',
    HESLO: 'Password',
    HESLO_OVERENI: 'Password verification',
    DATUM: 'Date',
    PRACOVNI_POZICE: 'Job Position',
    JAKA_OSOBA: 'Applicant is authorized to apply on behalf of this legal entity based on:',
    JMENO: 'First Name',
    PRIJMENI: 'Last Name',
    KONTAKTNI_UDAJE: 'Contact Details',
    KONTAKTNI_UDAJE_INFO: 'Contact e-email is primary contact on which you will receive information.',
    EMAIL: 'E-mail',
    EMAIL_FAKTURACANI: 'E-mail for Invoicing',
    EMAIL_OVERENI: 'E-mail Verification',
    TELEFON: 'Phone Number',
    HESLO_PUVODNI: 'Current password',
    HESLO_PUVODNI_CHYBA: 'The current password is incorrect',
    HESLO_NOVE: 'New password',
    HESLO_NOVE_OVERENI: 'Confirm new password',
    ODEBRAT: 'Remove',
    VYBRAT: 'Choose',
    VYBERTE: 'Choose',
    VYBRAT_SOUBOR: 'Upload file',
    STAT_SIDLA: 'Registered Country',
    STAT: 'Country',
    STAT_SIDLA_REGION: 'Registered Country - Region',
    PRID: 'Assignment',
    ZMEN: 'Change',
    ZRUS: 'Repeal',
    MUJ_DEPOZITAR: 'MY DEPOSITORY',
    ZAKLADNI_UDAJE_O_EMITENTOVI: 'Basic informations about issuer',
    ZAKLADNI_UDAJE: 'Basic informations',
    UDAJE_O_EMITENTOVI: 'Informations about issuer',
    IDENTIFIKACNI_CISLO: 'Identification number (IČ)/NID',
    ISIN: 'ISIN',
    UDALOSTI: 'Events',
    STAV: 'Status',
    ADRESA_ULICE: 'Address (street)',
    ULICE: 'Street',
    ULICE_CP: 'First address line',
    MESTO: 'City',
    PSC: 'ZIP Code',
    DOPLNUJICI_INFORMACE: 'Additional information',
    ANO: 'Yes',
    NE: 'No',
    BUTTON_UPRAVIT: 'Change',
    LEI_CELE: 'Legal Entity Identifier (LEI)',
    IBAN: 'Bank account (IBAN)',
    ZEME_SIDLA_VLASTNIKA_EMITENTA: "Country of the issuer's CEO",
    CZ_NACE: 'CZ NACE',
    PRIDAT_OSOBU: 'Add person',
    FYZICKA_OSOBA: 'Individual',
    PRAVNICKA_OSOBA: 'Legal entity',
    NELZE_UVEST: 'Opt-out',
    UDAJE_OSOBY: "Person's data",
    UDAJE_SPOLECNOSTI: 'Company data',
    FUNKCE: 'Function',
    POPIS: 'Description',
    ZADOST_ODESLANA: 'Application successfully sent',
    NACIST_DALSI_ZAZNAMY: 'Load more records',
    AKTUALIZOVAT: 'Update',
    VYJADRENI_CDCP: 'PSE statement',
    POTVRDIT: 'Confirm',
    PDF: 'PDF',
    UDAJE_PLATI: 'The data are valid',
    MENA: 'Currency',
    VYSTUP_CSV: 'Output to CSV',
    ZOBRAZIT_DETAIL: 'Show detail',
    NEURCENO: 'Not set',
    DORUCENO: 'Received',
    ODESLANO: 'Sent',
    HOTOVO: 'Done',
    TYP: 'Type',
    ZPRAVY: 'Messages',
    DETAIL: 'Detail',
    PRIDAT: 'Add',
    ODSTRANIT: 'Remove',
    PREHLED: 'Overview',
    PRIHLASENI: 'Login',
    OPISTE_SMS: 'Enter the SMS code from your message',
    SMS_KOD: 'SMS code',
    MUJ_PROFIL: 'My profile',
    MUJ_PROFIL_MODAL_ZPET: 'Back',
    UCET_NOVY: 'Create a new account',
    UCET_NOVY_SELECT: 'I am setting up a new account for',
    REGISTRACE_NADPIS: 'User information',
    KONTAKTNI_UDAJE_EMAIL_INFO:
        'Contact email is an primary contact for receiving information. Email is used for loging into My depository.',
    KONTAKTNI_UDAJE_HESLO_INFO: 'Password is used for loging into My depository.',
    OPISTE_TEXT_Z_OBRAZKU: 'Enter the text from the image',
    REGISTROVAT: 'Create account',
    TYP_ZADOSTI: 'Request type',
    STAHNOUT_PDF: 'Download PDF',
    LOGOUT_TITLE: 'Log out from section of My depository was successful',
    LOGOUT_TEXT:
        'Click the "Log in" button to log in to my depository again. If you would like to go to the website of the Central Depository, click the "Go to cdcp.cz" button.',

    RESPONSE_ERROR_400:
        'An error occurred while processing your request. Please contact the administrator or try to get data again.',
    RESPONSE_ERROR_401: 'The page has expired.',
    RESPONSE_ERROR_404: 'No data have met given requirements.',
    RESPONSE_ERROR_409: 'enVaše změna záznamu neproběhla. Záznam byl změněn jiným uživatelem.',
    RESPONSE_ERROR_410: 'enZákazník již na žádosti pracuje.',
    RESPONSE_ERROR_500:
        'An error occurred while processing your request. Please contact the administrator or try to get data again.',
    // RESPONSE_ERROR_500:
    //     'Service temporarily unavailable. Please contact the administrator or try to get data again.',

    NEVALIDNI_ISIN: 'Invalid ISIN',
    NEVALIDNI_LEI: 'Invalid LEI',

    NEVALIDNI_DIC: 'Invalid VAT',
    NEVALIDNI_IBAN: 'Invalid IBAN',
    NEVALIDNI_HESLO: 'The value must have 8-128 chars (must contain capital letter and a digit)',
    NEVALIDNI_HESLO_SHODA: 'Passwords did not match',
    NEVALIDNI_TELEFON:
        "Incorrect phone number – enter 9-17 characters without whitespace, start either with '+' or '00'",
    VALIDACE_GLOBAL_INPUT: 'Only numeric characters, letters, special characters  and a space are allowed in the item',
    NEVALIDNI_POCET_ZNAKU: 'Exceeded maximum number of characters',
    NEVALIDNI_DATUM_MENSI: 'Inserted date is smaller than accepted value',
    NEVALIDNI_URL: 'Invalid URL',

    CHYBA_ULOZENI_DAT: 'Failed to save data',
    CHYBA_NEPLATNY_ODKAZ: 'Invalid link',
    CHYBA_UCET_JIZ_AKTIVOVAN: 'Account is already activated',
    CHYBA_SMS: 'Invalid SMS code',
    CHYBA_REGISTRACE_401: 'Wrong captcha. Please, write the captcha text again.',
    CHYBA_REGISTRACE_404: 'Inserted email is already registered.', // Místo inserted bych spíš dal This

    LOGIN_ROLE_ADMINISTRATOR_EMISE: 'Issue Administrator',

    FORMULARE_DATUM_NAROZENI: 'Birthday',
    FORMULARE_IC: 'ID',
    FORMULARE_PODIL: 'share',
    FORMULARE_ADRESA: 'address',
    FORMULARE_CHYBNE_OPSANY_KOD: 'You entered wrong text. Please enter the text from the image again.',

    CHECK_LEI_MATKASLEI_NEPLATNE_LEI: 'Invalid LEI',
    LEI_ZRIZOVATEL: 'LEI of the Head office',
    NATURAL_PERSONS: 'Natural persons',
    NON_CONSOLIDATING: 'Non-consolidated',
    NON_PUBLIC: 'Non-public',
    NO_KNOWN_PERSON: 'Non-known person',
    LEGAL_OBSTACLES: 'Legal obstacles',
    CONSENT_NOT_OBTAINED: 'Consent is not obtained',
    BINDING_LEGAL_COMMITMENTS: 'Binding legal commitments',
    DETRIMENT_NOT_EXCLUDED: 'Detriment is not excluded',
    DISCLOSURE_DETRIMENTAL: 'Detrimental disclosure',
    TIMER_LOGOUT: 'You will be logged out in {{x}} seconds.',
    EMITENTSKA_AUTOMATICKE_ODHLASENI:
        "You will be logged out for your security soon. Press the 'OK' button to extend the interval.",
    KONTAKT_MAJITEL_UCTU: 'Contact details of the account holder:',
    SPRAVA_MEJTOK_UCTU: 'Contact details of the account holder:',

    LOGIN_INVALID: 'Invalid username or password',
    SPRAVCELEI: 'LEI administrator',
    GLEIF_NEVEDENO: 'Unmanaged',

    EMP_PODANE_ZADOSTI_FORMULAR: 'Form',
    EMP_PODANE_ZADOSTI_STAV: 'Status',

    LEI_AKTUALIZACE_INFORMACE_OPR: 'Identification of Applicant',
    LEI_AKTUALIZACE_INFORMACE_POV: 'Identification of entrusted person',
    PLNA_MOC_VZOR: 'POWER OF ATTORNEY SAMPLE',
    LEI_AKTUALIZACE_OPRAVNENI:
        'The authorisation to represent a company should fundamentally arise from public registers, the Commercial Register in particular, or be accompanied by a power of attorney signed by the person(s) named in those registers. In other cases, the Central Depository reserves the right to ask the Applicant for a proof of authorisation to represent a company or to reject the application.',
    LEI_AKTUALIZACE_PRIHLASOVACI_HESLO: 'Login password',
    LEI_TYP_OSOBY_OPR: 'Authorized Person',
    LEI_TYP_OSOBY_POV: 'Entrusting Person',
    AMLZ_HISTORIE: 'AMLZ history',

    EMISE_NOVY_ISIN: 'New ISIN',
    EMISE_ZMENY_ISIN: 'ISIN changes',
    EMISE_ZRUSENI_ISIN: 'ISIN cancelation',

    EMISE_PODANE_ZADOSTI: 'Submitted applications',

    EMISE_PODZAD_PRID: 'ISIN request - Assign',
    EMISE_PODZAD_ZMEN: 'ISIN request - Change',
    EMISE_PODZAD_ZRUS: 'ISIN request - Cancelation',

    SEZNAM_ISINU_LEI_EMITENTA: 'Issuer LEI',
    SEZNAM_ISINU_INFORMACE_ISIN: 'ISIN informations',
    SEZNAM_ISINU_DATUM_REGISTRACE: 'CSD registration date',
    SEZNAM_ISINU_INFORMACE_EMITENT: 'Issuer informations',
    SEZNAM_ISINU_ID_EMITENTA: 'Issuer ID (CRN)',

    ABST: 'Abstain',
    CAGS: 'Against',
    CHRM: 'Chairman',
    CFOR: 'For',
    NOAC: 'No action',
    WTHH: 'Withhold',
    ONEY: 'One year',
    THRY: 'Three years',
    TWOY: 'Two years',
    BLNK: 'Blank',
    NREC: 'No recommendation',
    AMGT: 'Against management',
    DISC: 'Discretionary',
    WMGT: 'With management',
    LEI_SEZNAM: 'A list of all issued LEIs is available at: ',
    LEI_TYP_ZMENY: 'Type of update',
    LEI_IS_SUBFUND_OF: 'Umbrella Structure',
    LEI_IS_FEEDER_TO: 'Master-Feeder',
    LEI_IS_FUND_MANAGED_BY: 'Fund Management Entity',
    LEI_IS_FUND_MANAGED_BY_ERR: 'Fill in the relationship with the investment company (fund manager)',
    LEI_ROZCESTNIK_TITLE: 'LEI application',
    LEI_AKTUALIZACE_TITLE: 'LEI update application',
    LEI_ROZCESTNIK_TEXT1:
        'Please ensure that the entity you are registering is not already in the database in order to prevent the rejection of your registration request.',
    LEI_ROZCESTNIK_CHOOSE: 'Entity Category Type',
    LEI_ROZCESTNIK_CHOOSE_SUB: 'Select a person subcategory:',
    LEI_DISSOLUTION: 'Dissolution',
    CENTRAL_GOVERNMENT: 'CENTRAL GOVERNMENT',
    STATE_GOVERNMENT: 'STATE GOVERNMENT',
    LOCAL_GOVERNMENT: 'LOCAL GOVERNMENT',
    SOCIAL_SECURITY: 'SOCIAL SECURITY',
    LEI_OSOBA_TITLE: 'Select a person category',
    CENTRAL_GOVERNMENT_SUB:
        'The central government subsector consists of the institutional units plus non-profit institution (NPI) controlled by the central government institutions. Central administration is defined as comprising all institutional units that extend their authority over the entire territory of the country.',
    STATE_GOVERNMENT_SUB:
        'The state government subsector consists of the institutional units that exercise some government functions at a level below that of the central government and above that of the government institutional units existing at a local level. These are institutional units whose fiscal, legislative and executive authority extends over individual states in which the country, as a whole, may be divided. In some countries, especially small countries, individual states and state governments may not exist. The state government usually has the fiscal authority to levy taxes on institutional units that are resident in or engage in economic activities or transactions within its area of competence.',
    LOCAL_GOVERNMENT_SUB:
        'The local government subsector consists of local governments that are separate institutional units. The scope of their authority is generally much less than that of central government or state governments, and they may or may not, be entitled to levy taxes on institutional units resident in their areas.',
    SOCIAL_SECURITY_SUB:
        'Social security schemes are social insurance schemes that cover the community as a whole or large sections of the community and are imposed and controlled by government units. The schemes cover a wide variety of programmes, providing benefits in cash or in kind for old age, invalidity or death, survivors, sickness and maternity, work injury, unemployment, family allowance, health care, etc. When social security schemes are separately organized from the other activities of government units and hold their assets and liabilities separately from the latter and engage in financial transactions on their own account, they qualify as institutional units that are described as social security funds.',
    LEI_GENERAL: 'GENERAL',
    LEI_FUND: 'FUNDS',
    LEI_BRANCH: 'BRANCH',
    LEI_SOLE_PROPRIETOR: 'SOLE PROPRIETOR',
    LEI_RESIDENT_GOVERNMENT_ENTITY: 'RESIDENT GOVERNMENT ENTITY',
    LEI_INTERNATIONAL_ORGANIZATION: 'INTERNATIONAL ORGANIZATION',
    LEI_GENERAL_TEXT: 'Select a category if you do not belong to any of the listed categories.',
    LEI_FUND_TEXT:
        'Investment fund, defined as a collective investment scheme (or pooled investment) beneficially owned by multiple investors and managed on behalf of those investors by an asset manager or by the fund itself.',
    LEI_BRANCH_TEXT2:
        'The BRANCH may apply for an LEI only if the LEI code has been assigned to a (parent) foreign parent company (head office)',
    LEI_BRANCH_TEXT:
        'The Branch is an International Branch defined as a non-incorporated establishment of a Legal Entity, when this establishment is located in a separate jurisdiction from the jurisdiction in which the head office of the (same) Legal Entity is located, i.e., in a host jurisdiction outside of its home jurisdiction. BRANCH is legally dependent on the (head office) Legal Entity it belongs to and cannot exist without its (head office) Legal Entity.',
    LEI_SOLE_PROPRIETOR_TEXT:
        "The entity is a typ of business with just one owner and legally there is no separate existence from its owner. Income and losses are taxed on the individual's personal income tax return.",
    LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT2:
        'A state owned, but independent general Legal Entity or Fund not part of or controlled by the government SHALL NOT be categorized as RESIDENT GOVERNMENT ENTITY but rather as GENERAL or FUND, respectively.',
    LEI_RESIDENT_GOVERNMENT_ENTITY_TEXT:
        'Non-market entity which is part of central, state or local public authority or social security fund, non - profit institution (NPI) controlled by government institution.',
    LEI_INTERNATIONAL_ORGANIZATION_TEXT:
        'An entity established under an international agreement of three or more states to pursue common goals. Has own international subjectivity, acting on behalf of own name and through its established bodies.',
    LEI_SUCCESSOR_ENTITY: 'Lei Successor Entity',
    REJSTRIK_KOD: 'Registartion Authority ID',
    REJSTRIK_NAZEV: 'Registration Authority Name',
    LEI_ICO: 'Business Registry Identifier',
    ZAPATI_OBSAH_CDCP: 'Site content: Central Securities Depository Prague, a.s.',
    ZAPATI_VERZE: 'site version',
    VYBRANE_EMISE: 'Selected issues',
    EMISE_FILTER: 'Emission filter',
    EMISE_NAZEV_CELY: 'Full name of the emission',
    NAZEV_CELY: 'Full name',
    DUVERNE_INFO_PODATUM: 'The highest date of calculation',
    DUVERNE_INFO_POZADOVANY_DEN: 'Effective date of calculation',
    ME_POZADAVKY_CISLO_ZMLUVY: 'Pledgee Reference Number',
    ME_POZADAVKY_IDIC_VERITEL: 'Pledgee Identification Number',
    ME_POZADAVKY_IDIC_DLUZNIK: 'Pledger Identification Number',
    ME_POZADAVKY_CISLO_PPN: 'PPN Number',
    ME_POZADAVKY_IDIC_SUBJPPN: 'PPN Creator Identification Number',
    ME_POZADAVKY_IDIC_MAJITEL_SHORT: 'Owner Identification Number',
    ME_POZADAVKY_PREDCISLI_UCTU: 'Account Prefix',
    CISLO_UCTU: 'Account Number',
    ME_POZADAVKY_IDIC_SPRAVCE: 'Administrator Identification Number',
    ME_POZADAVKY_ID1: 'First Pledge Number',
    ME_POZADAVKY_ID2: 'Second Pledge Number',
    DUVERNE_INFO_DTVP: 'Statement as of',
    ME_POZADAVKY_DATUM2_DUALNI: 'Dual Date',
    ME_POZADAVKY_CISLO_JEDNACI: 'Ref. No.',
    ME_POZADAVKY_KATEGORIE_MAJITELE: 'Category of Owner',
    ME_POZADAVKY_IDIC_MAJITEL2: 'Owner Identification Number',
    ME_POZADAVKY_DRUH_VYPISU: 'Issue Identification',
    ME_POZADAVKY_PRIJMENO: 'Surname/1.part of the subject name',
    ME_POZADAVKY_JMENO: 'Name/2.part of the subject name',
    ME_POZADAVKY_INDENTIFIKACE_SOUDU: 'Court Identification',
    ME_POZADAVKY_KATEGORIE: 'Output Kind',
    ME_POZADAVKY_KATEGORIE_TYP: 'Output Data Type',
    ME_POZADAVKY_IDENTIFIKATOR_OSOBYCDCP: 'Identifier of the person in the CDCP',
    ME_POZADAVKY_ID_SUBJEKTU: 'Subject ID',
    ME_POZADAVKY_INDENTIFIKATOR_SPRAVCE: 'Administrator ID',
    ME_POZADAVKY_ROLE: 'Role of Entity',
    DUVERNE_INFO_BILL_WARNING:
        'Na tuto službu nemáte předplatné. Potvrzením požadavku souhlasíte s fakturováním služby.',
    DUVERNE_INFO_TITLE_F1A:
        'F1A - Calculation of average prices of trades in listed participation securities in 1 month period',
    DUVERNE_INFO_TITLE_F1:
        'F1 - Calculation of average price of trades in listed participation securities in six-month period',
    DUVERNE_INFO_TITLE_F3: 'F3 - Values of securities for the evaluation of portfolio of funds',
    DUVERNE_INFO_TITLE_F5: 'F5 - Statement of liens by a fixed date',
    DUVERNE_INFO_TITLE_F6:
        "F6 - Statement of valid Suspension of Disposal Right (SDR = PPN) relating to securities by a fixed date in the owner's account",
    DUVERNE_INFO_TITLE_F7: 'F7 - Statement of the Custodian(s) of account and accounts in custody by a fixed date',
    DUVERNE_INFO_TITLE_F8:
        'F8 - Extract from the registration of liens and SDRs (PPNs) of pledged securities by a fixed date',
    DUVERNE_INFO_TITLE_F9: "F9 - Statement of the owner's account by a fixed date (including pledges and SDRs (PPNs))",
    DUVERNE_INFO_TITLE_F12: 'F12 - Issue statement (without pledges) by a fixed date',
    DUVERNE_INFO_TITLE_F13: 'F13 - Issue statement (including pledges and SDRs (PPNs)) by a fixed date',
    DUVERNE_INFO_TITLE_F14: 'F14 - Issue statement (including pledges and SDRs II (PPNs II)) by a fixed date',
    DUVERNE_INFO_TITLE_F15: 'F15 - Statement of changes of issue owners between two dates (specifying a counterpart)',
    DUVERNE_INFO_TITLE_F16:
        'F16 - Statement of changes of issue owners between two dates (not specifying a counterpart)',
    DUVERNE_INFO_TITLE_F17:
        'F17 - Statement of changes in owner account/accounts between two dates (specifying a counterpart)',
    DUVERNE_INFO_TITLE_F18:
        'F18 - Statement of changes in owner account/accounts between two dates (not specifying a counterpart)',
    DUVERNE_INFO_TITLE_F20:
        'F20 - Statement of the record of changes in registration data of the account owner between two dates',
    DUVERNE_INFO_TITLE_F24: 'F24 - Finding Account Number',
    DUVERNE_INFO_TITLE_F25: 'F25 - Statement of changes of issue owners between two dates (specifying a counterpart)',
    DUVERNE_INFO_TITLE_F26:
        'F26 - Statement of changes of issue owners between two dates (not specifying a counterpart)',
    DUVERNE_INFO_TITLE_F27: 'F27 - Statement of changes in owner account between two dates (specifying a counterpart)',
    DUVERNE_INFO_TITLE_F28:
        'F28 - Statement of changes in owner account between two dates (not specifying a counterpart)',
    DUVERNE_INFO_TITLE_F37: 'F37 - Issue statement (including pledges, SDRs (PPNs) and bank acount) by a fixed date',
    DUVERNE_INFO_TITLE_F38: 'F38 - Information for managing of premature redemption',
    DUVERNE_INFO_TITLE_F39:
        'F39 - Information about owners for fulfilling of reporting obligation by funds administrators about a fund capital',
    DUVERNE_INFO_TITLE_F50: 'F50 - Statement of personal information on the subject to date',
    DUVERNE_INFO_TITLE_F52: 'F52 - Statement entity in the history of the interval',
    DUVERNE_INFO_TITLE_F53: "F53 - Statement of holder's accounts to date",
    DUVERNE_INFO_TITLE_F56: 'F56 - Statement of the history of the pledge contract in a given interval',
    DUVERNE_INFO_TITLE_F58: 'F58 - Statement of History PPN in the interval',
    DUVERNE_INFO_TOOLTIP_DTVP: 'Effective date of calculation must not be higher then the highest date of calculation',
    DUVERNE_INFO_TOOLTIP_DTDV: '',
    DUVERNE_INFO_NEPOVINNE_ERR: '',
    LEI_VZNIKSPOLECNOSTI_ERR: 'Please fill in Entity Creation Date.',
    LEI_UPDATE_DATA_ERR: 'You cannot send the same values as the values saved in cdcp',
    PREHLED_ZMEN_UDALOSTI: 'Overview of Changes and Corporate Events',
    LEI_DETAIL_JINY_TRANS: 'Legal Entity Name (English)',
    LEI_OSOBA_UPLOAD_TEXT:
        'If you are filling in the application as an entrusting person, please attach a copy of the power of attorney for the purpose of requesting LEI signed by the authorized person.',
    LEI_DETAIL_INFO_TITLE: 'Detailed information about legal entity',
    LEI_DETAIL_INFO_TITLE_TABLE: 'Information about Legal Entity',
    LEI_DETAIL_JINY: 'Other Entity Name',
    LEI_DETAIL_PRAVFORMA: 'Entity Legal Form',
    LEI_DETAIL_PRAV_NENALEZENO: 'Legal form',
    LEI_DETAIL_STATUS: 'Status',
    LEI_DETAIL_ADRESA_HQ_FUND: 'Fund Manager Address',
    LEI_DETAIL_ADRESA_HQ_FUND_UPDATE: 'Fund Manager Address - original',
    LEI_DETAIL_ADRESA_HQ_FUND_VARIANTA: 'Fund Manager Address - language variant',
    LEI_DETAIL_DATUM_SPOL_TOOLTIP:
        'Please fill in the date of incorporation of the company according to the public register.',
    LEI_DETAIL_DATUM_SPOL: 'Entity Creation Date',
    LEI_DETAIL_DATUM_SPOL_FUND: 'Fund Creation Date',
    LEI_DETAIL_ADRESA_TITLE: 'Legal Address',
    LEI_DETAIL_ALT_JAZYK: 'Alternative language variant',
    LEI_DETAIL_ADRESA_SHODUJE: 'Headquarter Address is the same',
    LEI_DETAIL_ADRESA_HQ: 'Headquarter Address',
    LEI_DETAIL_ADRESA_HQ_UPDATE: 'Headquarter Address - original',
    LEI_DETAIL_ADRESA_TITLE_VARIANTA: 'Legal Address - language variant',
    LEI_DETAIL_ADRESA_HQ_VARIANTA: 'Headquarter Address - language variant',
    LEI_DETAIL_KOD_JAZYKA: 'Language',
    LEI_DETAIL_MAT_TITLE: 'Direct Parent Company',
    LEI_DETAIL_MAT_SUBTEXT: 'LEI applicant can not be the direct accounting consolidating parent itself.',
    LEI_DETAIL_MAT_TEXT2:
        'The direct parent is defined as the next higher legal entity that prepares consolidated financial statements (mandatory) in compliance with the accounting rules applicable to the parent and consolidates and indicates the abovementioned entity within these statements.',
    LEI_DETAIL_MAT_TEXT3:
        'bold(Important:) The information is only required if bold(consolidated financial statements) are prepared. A parent that exercises control but does NOT consolidate does NOT need to be stated! Please select “No I do not have a direct parent” in this case -> Non-consolidated',
    LEI_DETAIL_MAT_TEXT:
        'From 1st of May, 2017 it is mandatory for all legal entity category except Branch to fill in the data that identifies the direct and ultimate parent company of the entity requesting the LEI (Level 2 data).',
    LEI_MA_FOND_ID: 'Has the fund been assigned an identifier?',
    LEI_FOND_ID: 'Fund ID',
    LEI_DETAIL_MAT_SELECT: 'Does the legal entity have a direct consolidated parent company?',
    LEI_DETAIL_MAMATKA: 'Does the direct parent company have an LEI?',
    LEI_DETAIL_MATKA_DATUM: 'Relationship Start Date',
    LEI_DETAIL_MATKA_PODIL: 'Percentage Owned',
    LEI_DETAIL_MATKA_KONSOLIDACE: 'Accounting Standard',
    LEI_DETAIL_MATKA_KONSOLIDACE_CONFIRM: 'Validation Documents',
    LEI_DETAIL_REGULATORY: 'Validation Reference - URL',
    LEI_DETAIL_REGULATORY_FUND: 'Please fill in the Link/URL to Prospectus of the Fund',
    LEI_DETAIL_UCETNI_OBDOBY: 'Last Accounting Period',
    LEI_DETAIL_UCETNI_OBDOBY_OD: 'Accounting Start Date',
    LEI_DETAIL_UCETNI_OBDOBY_DO: 'Accounting End Date',
    LEI_DETAIL_PLATNOSTDOKUMENTU: 'Document Validity',
    LEI_DETAIL_PLATNOSTDOKUMENTU_OD: 'Document Start Date',
    LEI_DETAIL_PLATNOSTDOKUMENTU_DO: 'Document End Date',
    LEI_DETAIL_MATER_SPOLOCNOSTI: 'LEI of the Direct Parent Company',
    LEI_DETAIL_MATER_SPOLOCNOSTI_FIN: 'LEI of the Ultimate Parent Company',
    LEI_DETAIL_MATER_NAZEV: 'Name of the Direct Parent Company',
    LEI_DETAIL_MATER_NAZEV_FINAL: 'Name of the  Ultimate Parent Company',
    LEI_DETAIL_JURISDICKE: 'Legal Jurisdiction',
    LEI_DETAIL_REJSTRIK: 'Registration Authority ID',
    LEI_DETAIL_IDMAT: 'Business Register ID',
    LEI_DETAIL_DUVOD_SELECT: 'Exception Reason',
    LEI_DETAIL_NE_TEXT2:
        'If the direct parent company is the same as the final parent company, fill in the information about the Direct parent company and select: "Same data as for the direct consolidated parent company“.',
    LEI_DETAIL_NE_TEXT:
        'If you do not specify a direct consolidated parent company, the data for the final consolidated parent company are set automatically.',
    LEI_DETAIL_NELZEUVEST_INPUT: 'Exception Reason Detail',
    LEI_DETAIL_PRAV_SPOL: 'Legal Entity Name',
    LEI_FINAL_UPLOAD: 'Please upload here the Prospectus of the Fund',
    LEI_DETAIL_UPLOAD:
        'Please upload here the current consolidated financial statement or other documents for validation the parent-child relationship',
    LEI_FINAL_TITLE: 'Ultimate Parent Company',
    LEI_FINAL_SUBTEXT: 'LEI applicant can not be the ultimate accounting consolidating parent itself.',
    LEI_FINAL_TEXT3:
        'If the parent does have an LEI you will be asked to provide this LEI and then select two Relationship Periods at minimum. The Accounting Period and the Relationship Period are both required with any submission that contains parent data. You will also be required to fill Start and End dates for the Accounting Period (Fiscal Year), but only Start date for the Relationship Period, which will not have an end date due to the fact that the relationship between the current parent and respective submission is still ongoing. In addition to the accounting periods, you will be asked to provide the accounting standard under which the relationship exists. The options for this drop down are US GAAP, IFRS, or Other Accounting Standard. See the next page for an example of what the webpage will look like in the case of a parent having an LEI.The authorisation to represent a company should fundamentally arise from public registers, the Commercial Register in particular, or be accompanied by a power of attorney signed by the person(s) named in those registers. In other cases, the Central Depository reserves the right to ask the Applicant for a proof of authorisation to represent a company or to reject the application.',
    LEI_FINAL_TEXT2:
        'bold(Important:) The information is only required if bold(consolidated financial statements) are prepared.',
    LEI_FINAL_TEXT:
        'The ultimate parent is defined as the highest legal entity that prepares consolidated financial statements (mandatory) in compliance with the accounting rules applicable to the parent and consolidates the abovementioned entity within these statements.',
    LEI_FINAL_MASPOL_SELECT: 'Does the legal entity have an ultimate consolidated parent company ?',
    LEI_FINAL_MASPOL_SELECT_ALT: 'Does the company have a ultimate parent company?',
    LEI_FINAL_MASPOL_MALEI: 'Does the ultimate consolidated parent company have an LEI?',
    LEI_FINAL_ID_KONSOL: 'Bussiness Register ID',
    LEI_FINAL_STATSIDLA: 'State of residence of ultimate consolidated parent company',
    LEI_NOVYZADATEL: 'New applicant',
    LEI_AKTUALIZACE: 'LEI Update',
    REGISTROVAT_BUTTON_TEXT: "Don't have an account yet?",
    REGISTROVAT_BUTTON: 'Create account',
    LEI_PRAVNI_FORMA_KOD: 'ELF legal code',
    LEI_JINEID_SUBJ: 'Other subject ID',
    LEI_FONDU: 'LEI fund',
    LEI_DETAIL_NAZEV_TYP: 'Other Entity Name Type',
    LEI_DETAIL_NAZEV_JAZYK: 'Other Entity Name Language',
    LEI_FOND_TITLE: 'Fund structure',
    LEI_FOND_NENI: 'No fund structure was listed',
    LEI_REJSTRIK_INY: 'Other Registration Authority',
    MAIN_PAGE_FILTER_PLACEHOLDER: 'Company name, Company Registration Number, …',
    VYHLEDAT: 'Search',
    TYP_FONDU: 'Fund Type',
    FOND_LEI: 'Fund LEI',
    LEI: 'Lei',
    LEI_VELKE: 'LEI',
    FOND_STATUT: 'Prospectus',
    FOND_NAZEV: 'Fund name',
    DATUM_ZACATEK_VZTAHU: 'Relationship Start Date',
    VZTAH: 'Relationship',
    VZTAH_TYP: 'Fund Type',
    LEI_ICO_CHECK_ERR_DUPL:
        'An application is already in progress for the specified ID. Please cancel the pending request before continuing',
    LEI_ICO_CHECK_ERR:
        'The LEI code has already been assigned for the entered ID. A List of all issued LEIs is available at: www.gleif.org. For further Information, please contact us at lei@pse.cz.',
    LOGIN_JMENOHESLO: 'Log in using username and password',
    LOGIN_PXKLIC: 'Log in using username, password and PX key',
    LOGIN_CERT: 'Log in using comercial certificate',
    LOGIN_BANKID: 'Log in using BankID',
    LOGIN_LEI: 'Log in using LEI (for transfering account)',
    LEI_MIGRACE: 'Migration of LEI account to My depository',
    LEI_LOGIN_ERR: 'The account has already been migrated. Log in to My Depository with your account',
    LEI_LOGIN_SUCCESS: 'The account has already been migrated',
    LEI_LOGIN_SUCCESS_BUTTON: 'Continue to My Depository',
    LEI_LOGIN_SUCCESS_TEXT: 'To manage LEI, only use the login option you chose.',
    LEI_MIGRUJETE_SPOLECNOST: 'Company migration',
    LEI_SPRAVOVANE: 'Managed LEI',
    LEI_MIGRACE_TEXT: 'You can either use an existing account or create a new one to migrate LEI',
    LEI_STAVUCTU_ROZP: 'Application in progress',
    LEI_STAVUCTU_HOTOVO: 'Everything was settled',
    LEI_STAVUCTU_KONTROLA: 'To be checked by CDCP',
    LEI_STAVUCTU_PLACENI: 'Awaiting payment',
    LEI_STAVUCTU_ISSUED: 'ISSUED',
    LEI_STAV_GLEIF: 'GLEIF status',
    LEI_POSLEDNA_ZMENA: 'Date of last edit',
    UCTY: 'Accounts',
    EMP_VYBER_PROFIL_CERTIFIKAT2: 'Select one of the accounts to continue.',
    LEI_NEXT_CERT: 'Date of next certification',
    LEI_PROBIHA: 'Current status',
    LEI_IDENTIFIKATOR: 'Identifier',
    LEI_MENU_NOVY: 'LEI Assignment',
    LEI_MENU_GLEIF: 'Data in GLEIF',
    LEI_MENU_DETAIL: 'Detail LEI',
    LEI_MENU_AKTUALIZACE: 'Update LEI',
    LEI_MENU_AKTUALIZACE_CARD: 'Update LEI',
    LEI_MENU_PLATBA: 'Payment instructions',
    LEI_PLATOBNE_INFO_TITLE: 'Payment instruction information',
    LEI_PLATOBNE_INFO_TITLE_PRIDELENI: 'Payment instruction information - Assignment',
    LEI_PLATOBNE_INFO_TITLE_AKTUALIZACE: 'Payment instruction information - Update',
    LEI_PLATOBNE_INFO_SPECSYMBOL: 'Specific symbol',
    LEI_PLATOBNE_INFO_VARSYMBOL: 'Variable symbol',
    FAILED_ATTEMPTS_ERR: 'Too many failed login attempts, please try again in 5 minutes',
    LEI_PLATOBNE_INFO_TEXTSK: 'If you want to pay the fee in EUR to a CDCP bank account in Slovakia',
    LEI_PLATOBNE_INFO_TEXTCR: 'If you want to pay the fee in CZK to a CDCP bank account in Czech Republic',
    LEI_PLATOBNE_INFO_AMOUNTCR: 'Amount in CZK',
    LEI_PLATOBNE_INFO_AMOUNTSK: 'Amount in EUR',
    LEI_PLATOBNE_INFO_KODBANKY: 'Bank code',
    LEI_PLATOBNE_INFO_ADRESA: 'Name and address of the bank',
    LEI_PLATOBNE_INFO_ADRESA1: 'UniCredit Bank Czech Republic and Slovakia, a.s.,',
    LEI_PLATOBNE_INFO_ADRESA2: 'branch of a foreign bank',
    LEI_PLATOBNE_INFO_ADRESA3: 'Šancová 1/A',
    LEI_PLATOBNE_INFO_ADRESA4: '813 33 Bratislava',
    LEI_PLATOBNE_INFO_PRIJEMCE: 'Name and address of recipient',
    LEI_PLATOBNE_INFO_PRIJEMCE1: 'Centrální depozitář cenných papírů, a.s.,',
    LEI_PLATOBNE_INFO_PRIJEMCE2: 'Rybná 14',
    LEI_PLATOBNE_INFO_PRIJEMCE3: '110 05 Praha 1',
    LEI_TYPZADOSTI_REGISTRACE: 'New registration',
    LEI_TYPZADOSTI_AKTUALIZACE: 'Update',
    LEI_TYPZADOSTI_KONTAKTNIUDAJE: 'Update contact details',
    CHCI_ZMENIT: 'I want to update',
    CHCI_ZMENIT_OSTATNI: 'Corporate Event Type',
    LEI_CHANGE_LEGAL_NAME: 'Change Legal Name',
    LEI_CHANGE_OTHER_NAMES: 'Change Other Entity Name',
    LEI_CHANGE_LEGAL_ADDRESS: 'Change Legal Address',
    LEI_CHANGE_HQ_ADDRESS: 'Change Headquarter Address',
    LEI_CHANGE_LEGAL_FORM: 'Change Legal Form',
    LEI_DIC: 'Change VAT Payer',
    LEI_OSTATNI: 'Corporate Event Announcement',
    LEI_VZNIKSPOLECNOSTI: 'Entity Creation Date',
    LEI_AKTUALIZACE_CHANGE_LEGAL_NAME: 'Change Legal Name',
    LEI_AKTUALIZACE_CHANGE_OTHER_NAMES: 'Change Other Entity Name',
    LEI_AKTUALIZACE_CHANGE_LEGAL_ADDRESS: 'Change Legal Address',
    LEI_AKTUALIZACE_CHANGE_HQ_ADDRESS: 'Change Headquarter Address',
    LEI_AKTUALIZACE_CHANGE_LEGAL_FORM: 'Change Legal Form',
    LEI_AKTUALIZACE_DIC: 'Change VAT Payer',
    LEI_AKTUALIZACE_OSTATNI: 'Corporate Event Announcement',
    LEI_AKTUALIZACE_VZNIKSPOLECNOSTI: 'Change Entity Creation Date',
    LEI_ZOBRAZIT_PROBELHI: 'Show past events',
    LEI_ZMENIT_EVENT_BUTTON: 'Change Company Details',
    LEI_ZMENIT_EVENT_OSTATNI_BUTTON: 'Corporate Event Announcement',
    LEI_DETAIL_MATER_SPOLOCNOSTI_BRANCH: 'LEI of Head Office',
    LEI_DATUM_ZMENY: 'Effective Date',
    LEI_DETAIL_MAT_TITLE_BRANCH: 'Information about Head Office',
    LEI_DATUM_OZNAMENI: 'Date of Notification',
    LEI_DATUM_POTVRDENI: 'Confirmation Date',
    LEI_FUND_TEXT1:
        'Since 1 April 2022, according to the Global Legal Entity Identifier Foundation (GLEIF) regulation, all entities applying for LEI for funds are newly obliged to document the relations between these entities. These include umbrella structure, feeder funds and fund management company.',
    LEI_FUND_TEXT2:
        'The FUND  may apply for an LEI only if the LEI code has been assigned to the fund manager or the fund superior.',
    LEI_FUND_TEXT3:
        'At least one relationship with the Fund management company must be filled in (in the case of a self-managed fund, the LEI applicant will also be listed in the relationship: Fund management company).',
    ACCOUNTS_FILING: 'Accounts filing',
    REGULATORY_FILING: 'Regulatory filing',
    SUPPORTING_DOCUMENTS: 'Supporting documents',
    CONTRACTS: 'Contracts',
    OTHER_OFFICIAL_DOCUMENTS: 'Other official documents',
    LEI_UPDATE_CONFIRM: 'Do you wish to create a new update request?',
    LEI_CONTACT_UPDATE_CONFIRM: 'Do you wish to update contact details?',
    LEI_HLASENA_ZMENA: 'Change to report',
    LEI_ZMENA_PODKLADY: 'Documentation of update',
    LEI_CHECK_ERROR: 'Entered lei was not found in registration authority',
    LEI_COMPLETE_THREEDAYS: 'can only be confirmed three days before implementation',
    LEI_PROFONDY_ERROR: 'One or more items are missing in the highlighted rows',
    LEI_MATKA_NEUVEST: 'No I will not disclose data due to this reason',
    LEI_MATKA_UVEST: 'Yes I will disclose direct parent data',
    LEI_MATKA_KONSOLIDOVANA_UVEST: 'Yes, I will disclose data about ultimate consolidated parent company',
    LEI_MATKA_KONSOLIDOVANA_NEUVEST: 'No I will not disclose ultimate direct parent data',
    UCETNISTANDARDY_JINE: 'Other accounting standards',
    ALTERNATIVE_LANGUAGE_LEGAL_NAME: 'Alternative Language Legal Name',
    PREVIOUS_LEGAL_NAME: 'Previous Legal Name',
    TRADING_OR_OPERATING_NAME: 'Trading or Operating Name',
    LEI_MATKE_STEJNE_HODNOTY: 'Same data as for the direct consolidated parent company',
    LEI_SUBMIT_APPROVAL:
        'I confirm that all filled data are valid and I acknowledge that by confirmation of this LEI assignment form an agreement will be concluded between the applicant and CSD Prague according to the article 3 of LEI Assignment and Record-keeping Rules.',
    LEI_SUBMIT_INFO:
        'Subject providing personal data acknowledges that CSD Prague shall process obtained personal data as a personal data controller. Processing shall be for the purpose of performance of this contractual relationship as well as for the purpose of the legitimate interests pursued by the controller (enforcement of obligations from this contract). More information on processing of personal data is published on websites http://www.cdcp.cz in the part "Personal Data Processing".',

    LEI_VLOZTE_REJSTRIK:
        'Please upload an extract from the Commercial Register not older than 3 months or Power of Attorney.',
    LEI_TYP_OSOBY_OPRAVNENA: 'His / Her Position (Management / Board)',
    LEI_TYP_OSOBY_POVERENA: 'A Written Form of Authorization (Please Attach Document)',
    LEI_TYP_OSOBY_OPRAVNENA_SELECT: 'His / Her Position (Management / Board)',
    LEI_TYP_OSOBY_POVERENA_SELECT: 'A Written Form of Authorization (Please Attach Document)',
    LEI_TYP_OSOBY_PLACEHOLDER: 'Please select your authorization',
    LEI_ENTITYCHECK_ERR: 'Given business register ID already has LEI assigned {{LEI}}',
    LEI_ENTITYSHODNE_ERR: 'LEI of Parent company must be different from LEI of company',
    VYPLNTE_PLACEHOLDER: 'Fill in...',
    VYBERTE_PLACEHOLDER: 'Choose...',
    SOUBOR_NOT_LOADED: 'Please upload a file',
    LEI_OSOBACHECK_ERROR:
        'Please upload an extract from the Commercial Register not older than 3 months or Power of Attorney.',
    SOUBOR_NOT_LOADED_OSOBA:
        'Please upload an extract from the Commercial Register not older than 3 months or Power of Attorney.',
    JINY_PRAVNI_KOD: 'Other Legal Form',
    LEI_ZMENA_KONTAKT: 'Change contact details',
    REGION: 'Region',
    AMLZ_USPECH: 'The AMLZ was successfully send.',
    AMLZ_USPECH_TEXT: 'The submitted application can be found in the list of submitted applications.',
    FORMULARE_ZASTUPUJUCE_OSOBY_TEX:
        'Please fill in the details of any natural person you expect to deal with the CDCP on behalf of the issuer (whether jointly or separately, by proxy by law or by contract)',
    FORMULARE_AMLZ_C1_TITLE: 'C1 - Basic issuer information',
    FORMULARE_AMLZ_C2_TITLE: 'C2 - Data on all natural persons representing the issuer',
    FORMULARE_AMLZ_C3A_TITLE:
        "C3A - Information about the issuer's ownership and management structure - DIRECT ownership",
    FORMULARE_AMLZ_C3A_PODILNIK: 'Direct Shareholder',
    FORMULARE_AMLZ_C3_PODILNIK_JE: 'The shareholder is',
    FORMULARE_AMLZ_C3A_PODILNIKTEXT: 'Provide details of unitholders that directly own more than 10% of the issuer',
    FORMULARE_AMLZ_C3A_PODIL: 'Share of ownership structure in %',
    FORMULARE_AMLZ_C3B_TITLE:
        "C3B - Information about the issuer's ownership and management structure - INDIRECT ownership",
    FORMULARE_AMLZ_C3B_SELECT: 'Provide details of unitholders that indirectly own more than 10% of the issuer',
    FORMULARE_AMLZ_C4_TITLE: 'C4 - Information about the actual owner of the issuer',
    FORMULARE_AMLZ_C5_TITLE: "C5 - Issuer's statement to identify a politically exposed person (PEP)",
    FORMULARE_AMLZ_C5_SUBTITLE: 'PEP means',
    FORMULARE_AMLZ_C5_TEXTA:
        "a) a natural person who is or has been in a prominent public office with national or regional significance, such as in particular the head of state, the prime minister, the head of the central government authority and his deputy (deputy, secretary of state), a member of parliament, a member of the governing body of a political party, the head of a territorial authority, a judge of the supreme court, the constitutional court or any other supreme judicial body against whose decisions in general and with exceptions Appeals may not be exercised, a member of the central bank's bank board, a senior officer in the armed forces or corps, a member or a representative of a member if it is a legal person, the statutory body of a state-controlled commercial corporation, an ambassador or the head of a diplomatic mission, or a natural person who performs or has performed a similar function in another state, a European Union institution or an international organisation,",
    FORMULARE_AMLZ_C5_TEXTB: 'b) a natural person who is',
    FORMULARE_AMLZ_C5_TEXTB1: '1. a person close to the person referred to in point a',
    FORMULARE_AMLZ_C5_TEXTB2:
        '2. partner or beneficial owner of the same legal person or trust fund or other legal arrangement without legal personality, as the person referred to in (a), or is known to the obliged entity to be in any other close business relationship with the person referred to in (a), or',
    FORMULARE_AMLZ_C5_TEXTB3:
        '3. beneficial owner of the legal person or trust fund or other legal arrangement without legal personality, as the case may be  Known to the obliged entity that they were created for the benefit of the person referred to in point (a).',
    FORMULARE_AMLZ_C5_SELECT_DOPLN_INFO1:
        'Is the person to whom the Czech Republic applies international sanctions under the Act on the Implementation of International Sanctions',
    FORMULARE_AMLZ_C5_SELECT_DOPLN_INFO2:
        'It is from a state that does not adequately or at all enforce measures against money laundering and terrorist financing',
    FORMULARE_AMLZ_C6_ZHRNUTI: 'AMLZ Data Summary',
    FORMULARE_AMLZ_C6_TITLE: 'C6 - Issuer commits',
    FORMULARE_AMLZ_C6_TEXTA: 'a) provide the CDCP with assistance in carrying out the check,',
    FORMULARE_AMLZ_C6_TEXTB: 'b) notify changes in the data contained in this document,',
    FORMULARE_AMLZ_C6_TEXTC:
        'c) provide, upon request, an explanation of the meaning and purpose of a specific operation at the CDCP,',
    FORMULARE_AMLZ_C6_TEXTD:
        'd) in the case of identification of the PEP at the issuer, the issuer undertakes to provide data for the examination of the sources of funds used in the transaction',
    FORMULARE_AMLZ_C6_SUBTITLE: 'Questionnaire for issuer submits',
    FORMULARE_AMLZ_C6_SUBTEXT:
        'Select from the list the person who sends a questionnaire for the issuer to check the issuer against the AMLZ.',
    FORMULARE_AMLZ_ROZCESTNIK_TITLE: 'Questionnaire to check issuer by AMLZ',
    FORMULARE_AMLZ_ROZCESTNIK_A: 'The questionnaire AMLZ DOES NOT COMPLETE an issuer that is:',
    FORMULARE_AMLZ_ROZCESTNIK_B:
        'credit or financial institution headquartered in a European Union country or a country applying requirements equivalent to AMLZ; (bank, investment company, insurance company)',
    FORMULARE_AMLZ_ROZCESTNIK_C:
        'an issuer whose securities are admitted to trading on a regulated market; (BCPP, RM-S, MTS) ',
    FORMULARE_AMLZ_ROZCESTNIK_D:
        'issuer whose securities are admitted to trading on a regulated market; (BCPP, RM-S, MTS)',
    FORMULARE_AMLZ_ROZCESTNIK_VYPLNUJE:
        "an issuer that does NOT belong to either of the above groups, and is assigned an ISIN or will apply for an ISIN for a security (book-entry, immobilized or collectable) where the person leading the record is a CDCP. To complete the questionnaire, be prepared with: LEI code, details of individuals representing the issuer, details of the issuer's ownership and management structure, details of the actual owner of the issuer and details to identify the politically exposed person.",
    FORMULARE_AMLZ_ROZCESTNIK_VPRIPADE: `If you do not identify the persons representing the issuer by electronic signature - a commercial certificate, prepare duplicate TWO identity documents and a copy of the proof of existence of the issuer's bank account for each person representing the issuer. For detailed identification, see also "Help."`,
    FORMULARE_AMLZ_ROZCESTNIK_VPRUBEHU:
        'During completion, the questionnaire can be saved by logging into the issuer area and returning for completion later.',
    FORMULARE_PROVOZOVNA_STATY:
        'Add all states in which the issuer has a branch, organisational entity or establishment',
    FORMULARE_C2_VLOZTE_DOKLAD_TOOLTIP:
        'In the case of multiple accounts, indicate the bank account that is held in the name of the issuer from which the CDCP fees will be paid.',
    FORMULARE_JMENA: 'All names',
    FORMULARE_PRIJMENI: 'All Surnames',
    FORMULARE_MISTO_NAROZENI: 'Place of birth',
    FORMULARE_ADRESA_POBYTU: 'Permanent address',
    LEI_GLEIF_STAV_LAPSED: 'Lapsed',
    LEI_GLEIF_STAV_MERGED: 'Merged',
    LEI_GLEIF_STAV_RETIRED: 'Retired',
    LEI_GLEIF_STAV_ANNULLED: 'Annulled',
    LEI_GLEIF_STAV_CANCELLED: 'Cancelled',
    LEI_GLEIF_STAV_TRANSFERRED: 'Transferred',
    LEI_GLEIF_STAV_PENDING_TRANSFER: 'Pending transfer',
    LEI_GLEIF_STAV_PENDING_ARCHIVAL: 'Pending archival',
    LEI_GLEIF_STAV_PENDING_VALIDATION: 'Unmanaged',
    LEI_GLEIF_STAV_ISSUED: 'Issued',
    LEI_UPLOAD_FILLIN: 'Fill in all the required information before uploading file',
    LEI_AKTUALIZACE_MATKA_ERR: 'Parent company data is incomplete, please edit the data',
    TRANSFORMATION_SUBSIDIARY_TO_BRANCH: 'Transformation subsidiary to branch',
    REVERSE_TAKEOVER: 'Reverse takeover',
    ABSORPTION: 'Absorption',
    BANCRUPTCY: 'Bancruptcy',
    BREAKUP: 'Breakup',
    DEMERGER: 'Demerger',
    INSOLVENCY: 'Insolvency',
    DISSOLUTION: 'Dissolution',
    VOLUNTARY_ARRANGEMENT: 'Voluntary arrangement',
    LIQUIDATION: 'Liquidation',
    ACQUISITION_BRANCH: 'Acquisition branch',
    TRANSFORMATION_UMBRELLA_TO_STANDALONE: 'Transformation umbrella to standalone',
    MERGERS_AND_ACQUISITIONS: 'Mergers and acquisitions',
    TRANSFORMATION_BRANCH_TO_SUBSIDIARY: 'Transformation branch to subsidiary',
    VYDAL: 'Issued',
    ZOBRAZIT: 'Show',
    PROFIL_UDAJE_CHYBA: 'Contact CDCP to update contact details',
    ZADOST_O_ISIN_AMLZ: 'To submit an ISIN request, you must submit an AMLZ request and wait for approval',
    PREJIT_NA_AMLZ: 'Go to AML',
    POKRACOVAT_NA_ZHRNUTI: 'Continue to Summary',
    PREJIT: 'Continue',
    ZMENIT: 'Change',
    ZRUSIT_ZADOST_SUCCESS: 'Cancellation request successful',
    ZMENA_EMAIL_SENT: 'An email has been sent to you to confirm the email change.',
    ZADNE_EMISE: 'There are no Issues',
    ZADNE_LEI: 'There are no LEIs',
    DATUM_ZALOZENI: 'Creation Date',
    NEPLATNY_DATUM: 'Invalid date',
    SOUBOR_200: 'File has been successfully uploaded',
    UDALOST: 'Event',
    POZADAVKY: 'Requests',
    NEVALIDNI_IDENTIFIKATOR: 'Invalid identifier',
    NEVALIDNI_XSD_SOUBOR: 'XSD file not valid',
    SEZNAM_EMISI_TEXT: 'List of book-entry issues held in CDCP',
    INFORMACE_ZA_UPLATU: 'Paid information',
    VSTOUPIT: 'Enter',
    UPLOAD_MAX_SIZE: 'File is too large',
    UPLOAD_MAX_SIZE_TEXT: 'Maximum file size is 20 MB',
    ZADNE_UDAJE: 'No data',
    PREHLED_UDALOSTI: 'Event Overview',
    DUVERNE_INFORMACE: 'Confidential information',
    CERTIFIKAT: 'Certificate',
    DATUM_CET: 'Date (CET/CEST)',
    EMISE: 'Issue',
    VYPISY: 'Statements',
    HLASOVANI: 'Voting',
    UPRAVIT_HLASOVANI: 'Edit vote',
    PODANO: 'Submitted',
    ISB_ID: 'Id in ISB',
    SLUZBA: 'Service',
    PODAL: 'Submitted',
    ZOBRAZENO: 'Viewed',
    CEKAJICI: 'Pending',
    NEDORUCEN: 'Undelivered',
    DORUCEN: 'Delivered',
    ZODPSCHYBOU: 'Answered with error',
    ZODPOVEZEN: 'Answered',
    PRIPRAVEN: 'Resend',
    POZRUCNE: 'Request handled manually',
    CEKANAZPRAC: 'Awaiting processing',
    ZRUSEN: 'Cancelled',
    HESLO_ZMENA_401: 'The link sent has expired. Please send a new password change request.',
    HESLO_NOVE_NADPIS: 'New password for My Depository',
    HESLO_ZMENA_TEST_ALT: 'Please enter your new password to access My Depository.',
    HESLO_ZMENA_TEXT: 'Please enter your original and new password to access My Depository.',
    HESLO_NESPRAVNE: 'The password you entered is incorrect.',
    ZADAT_HESLO_PUVODNI: 'Enter Original Password',
    LOGIN_WRONG: 'Different user information. Unable to log in',
    ZADAT_HESLO: 'Enter password',
    ZADAT_HESLO_NOVE: 'Enter new password',
    ZAPSAT: 'Log in',
    BUTTON_DEAKTIVOVAT: 'Deactivate',
    BUTTON_AKTIVURAV: 'Activate and Edit',
    ELEKTRONICKY_PODPIS: 'Electronic signature',
    DVA_DOKLADY_TOTOZNOSTI: 'Copy of two identity documents',
    OSOBA: 'Person',
    ULOZIT: 'Save',
    POPIS_EN: 'Description - en',
    HLASOVAT: 'Vote',
    UCASTNIK: 'Participant',
    MUJ_CERTIFIKAT: 'My certificate',
    VSE: 'All',
    URL: 'URL',
    BIC: 'BIC',
    MAJITEL: 'Owner',
    PREHLED_ZPRAV: 'Message overview',
    UCET_NOVY_ERR: 'The entered ID is registered under another account',
    NOVA_REGISTRACE_DEPOZITAR: 'New registration in My Depository',
    SLUZBA_NEDOSTUPNA: 'The service is unavailable. Please repeat the action later.',
    SEZNAM_UDALOSTI: 'List of events',
    ZADOSTI_ISIN: 'Submitted ISIN requests',
    SPRAVCE_MAJETKOVEHO_UCTU: 'Asset Manager',
    SPRAVCE_UCTU: 'Account Manager',
    RESPONSE_ERROR_503: 'Server unavailable. Repeat the action again.',
    NEVALIDNI_PROCENTA_100_0: 'Item may only contain numbers (with max 2 decimal places) less than or equal to 100',
    NEVALIDNI_PROCENTA_CELKEM: 'Maximum sum of shares cannot be greater than 100%',
    ULOZENI_DAT_200: 'Data save was successful',
    ULOZENI_DAT: 'Saving form data',
    CHYBA_AMLZ_NEVEDENO: 'There is no AMLZ',
    LOGIN_OBNOVENI_HESLA_TEXT: 'Please enter your email to communicate with CDCP.',
    CHYBA_RESTORE_TOKEN: 'Token recovery error',
    FORMULARE_RODNE_CISLO_MALE: 'birth number',
    FORMULARE_DATUM_NAROZENI_MALE: 'date of birth',
    FORMULARE_STAT_NAROZENI: 'State of birth',
    FORMULARE_ZEME_PUVODU_MALE: 'Country of origin',
    FORMULARE_SKUTECNI_MAJITELE: 'Beneficial owners',
    FORMULARE_RODNE_CISLO_CR: 'Birth number assigned in the Czech Republic',
    FORMULARE_STATNI_OBCANSTVI: 'Nationality',
    FORMULARE_DRUH_DOKLADU: 'Type of document',
    FORMULARE_CISLO_DOKLADU: 'Document number',
    FORMULARE_DATUM_PLATNOSTI: 'Date of validity until',
    FORMULARE_ZASTUPUJICI_OSOBA: 'Person representing the issuer is',
    FORMULARE_IDENTIFIKACE_OSOBA: 'Method of identification of the person',
    FORMULARE_STAHNOUT_KPODPISU: 'Download form to sign',
    FORMULARE_PLNA_MOC: 'Insert Power of Attorney',
    FORMULARE_JINE_OPRAVNENI: 'Insert other authorization',
    FORMULARE_PODEPSANY_SOUBOR: 'Insert signed file',
    FORMULARE_DOKLADY_TOTOZNOSTI: 'Insert two forms of identification',
    FORMULARE_AMLZ_C2_VALIDATION1: 'Need to upload a method of identification for these individuals',
    FORMULARE_AMLZ_C2_VALIDATION2: 'Need to correct the expiry date for these individuals',
    FORMULARE_AMLZ_C3A_TOOLTIP: `"Shareholders" means natural and legal persons who hold shares in the company. Primarily, the issuer shall fill in all shareholders who own more than 10% of the issuer, i.e. in particular partners for LLCs and shareholders for JSCs. If a legal entity shareholder reaches 10% together with another (sister) legal entity that is controlled by the same person (parent company or natural person), this parent company or natural person shall be listed as an indirect shareholder in Part C3B.`,
    FORMULARE_AMLZ_C3A_SELECT: 'There is a shareholder that directly owns more than 10% of the issuer',
    FORMULARE_AMLZ_C3B_TEXT: 'Provide details of the shareholders that indirectly own more than 10% of the issuer',
    FORMULARE_AMLZ_C3B_TOOLTIP:
        "Provide details of a natural or legal person who controls direct shareholders who are not listed as a direct shareholder in Part C3A but whose aggregate holdings exceed 10% of the issuer's share capital.",
    FORMULARE_AMLZ_C4_TEXT:
        'bold(Beneficial owner) means a person as defined in Law No. 37/2021 on the registration of beneficial owners ("ESM"). Simply, under this law, bold(any natural person who is the ultimate beneficiary or person with ultimate influence. An ultimate beneficiary) is a person who may, directly or indirectly through another person or legal arrangement, have a substantial part of the total property benefit created in the operation or liquidation of a legal entity or created in the administration or dissolution of a legal arrangement (hereinafter referred to as "benefit") and does not pass on that benefit. bold(person with ultimate influence) a person who, without the direction of another, can directly or indirectly exercise a decisive influence in the legal person or on the administration of the legal arrangement.',
    FORMULARE_AMLZ_C4_TEXT_A:
        'bold(The ultimate beneficiary) of a legal person is any person who may directly or indirectly receive more than bold(25% of the total property benefit) generated in the operation or liquidation of the legal person and does not pass on that benefit; it shall be deemed not to be passed on. The ultimate beneficiary of a corporation is any person who is entitled, directly or indirectly, to a share of the profits, other equity or liquidation proceeds of the corporation (hereinafter bold("beneficial interest"))bold( more than 25%,) and does not pass on that beneficial interest; the beneficial interest shall be deemed not to be passed on.For the purpose of calculating the amount of an indirect beneficial interest, in the case of',
    FORMULARE_AMLZ_C4_TEXT_A1:
        '(a) chaining, the shares of the benefit to which the tied persons or legal arrangement are entitled shall be multiplied and',
    FORMULARE_AMLZ_C4_TEXT_A2:
        '(b) branching, the sums of the beneficial interests in the individual chains shall be added together.',
    FORMULARE_AMLZ_C4_TEXT_B:
        'bold(A person with ultimate influence) in a business corporation is any natural person who is a controlling person under the law governing the legal relations of business corporations. A person with ultimate influence in a corporation other than a business corporation and in a housing or social cooperative shall be deemed to be any natural person who is a member of their governing body. The fact that a natural person is a person with ultimate influence in a corporation is indicated by his direct or indirect share of the voting rights which significantly exceeds the shares of the voting rights of other persons, in particular if it is greater than 25 %. For the purposes of calculating the amount of the indirect share of the voting rights, in the case of',
    FORMULARE_AMLZ_C4_TEXT_B1:
        '(a) chaining, the shares of voting rights held by the related persons or legal arrangements shall be multiplied, except that, in the case of a share of voting rights in a corporation that is the subject of the calculation, the share of voting rights held by the related persons or legal arrangements shall be treated as',
    FORMULARE_AMLZ_C4_TEXT_B2:
        '1. 100% shall be counted as voting interests giving rise to a presumption of control under the law governing the legal relations of corporations; and',
    FORMULARE_AMLZ_C4_TEXT_B3: '(2) 0 % shall be counted as shares not included in paragraph (1),',
    FORMULARE_AMLZ_C4_TEXT_C: '(b) the branching aggregates of the voting rights interests from the individual chains.',
    FORMULARE_AMLZ_C4_TEXT_C1:
        "It is true that the bold(each person in the corporation's senior management) is the corporation's beneficial owner,",
    FORMULARE_AMLZ_C4_TEXT_C2:
        '(a) if no beneficial owner can be determined even after the exercise of all efforts that may reasonably be required of the person of record; or',
    FORMULARE_AMLZ_C4_TEXT_C3:
        '(b) if the person with ultimate influence in the corporation is a corporation that does not have a beneficial owner under section 7.',
    FORMULARE_AMLZ_C4_TEXT_C4:
        'If a person with ultimate influence in a corporation is a corporation that does not have a beneficial owner under section 7 and another person is an ultimate beneficiary of the corporation, the beneficial owners of the corporation are each person in the senior management of the corporation and each individual who is an ultimate beneficiary of the corporation.',
    FORMULARE_AMLZ_C4_TEXT_C5:
        'If the ultimate beneficial owner is a corporation whose beneficial owner is determined pursuant to the preceding two paragraphs, each person in the ultimate management of the corporation shall also be the beneficial owner of any corporation in a subordinate relationship structure to the corporation.',
    FORMULARE_AMLZ_C4_TEXT_C6: 'Section 7 of the ESM lists entities that do not have a beneficial owner.',
    FORMULARE_AMLZ_C4_RADIO_UV:
        'bold(A.) The following provides information on the individual or individuals who are beneficial owners under the Beneficial Owners Registration Act',
    FORMULARE_AMLZ_C4_RADIO_NEUV:
        'bold(B.) The following lists each person in the senior management of the corporation (or in the senior management of the ultimate controlling person) because no beneficial owner can be identified or the ultimate controlling person is a legal entity without a beneficial owner under Section 7 of the ESM.',
    FORMULARE_AMLZ_C4_RADIO_NENI:
        'bold(C.) Declares that it is unable to identify the natural person who is the beneficial owner under the Beneficial Owners Registration Act for the following reasons (e.g. that it does not have a beneficial owner within the meaning of Section 7 of the ESM)',
    FORMULARE_AMLZ_C4_OSOBA_TRUE: 'IS a statutory body or a member of a statutory body',
    FORMULARE_AMLZ_C4_OSOBA_FALSE: 'IS NOT a statutory body or a member of a statutory body',
    FORMULARE_AMLZ_C4_OSOBA_MAJITEL: 'Beneficial owner',
    FORMULARE_AMLZ_C4_OSOBA_TEXT:
        'If the beneficial owner is a member of the senior management, all identifying information below must be completed unless it is already included above in the details of the natural persons authorised to represent the issuer.',
    FORMULARE_AMLZ_C4_OSOBA_PUVOD: 'Country of origin of beneficial owner',
    FORMULARE_AMLZ_C5_TEXT_PROHLASENI:
        'The issuer represents that the natural person acting for the client and its beneficial owner',
    FORMULARE_AMLZ_C5_SELECT_ANO: 'the following persons are PEPs',
    FORMULARE_AMLZ_C5_SELECT_NE: 'are not PEPs',
    DOTAZNIK_AMLZ: 'AMLZ Questionnaire',
    FORMULARE_AMLZ_ROZCESTNIK_SUBJEKT:
        'The entity providing the personal data acknowledges that CDCP will process as a controller the personal data provided. The processing will be carried out for the purposes of the performance of this contractual relationship and, where applicable, for the protection of the legitimate interests of the controller (enforcement of obligations under this contract). Further necessary information on the processing of personal data is provided on the website http',
    FORMULARE_AMLZ_ROZCESTNIK_ZAKON:
        'In accordance with Bold(Act No. 253/2008 Coll., on certain measures against the legalization of the proceeds of crime and terrorist financing) (bold(hereinafter referred to as "AMLZ"))bold(, Czech National Bank Decree No. 67/2018 Coll. ), on Certain Requirements for a System of Internal Policies, Procedures and Control Measures against the Legalization of the Proceeds from Crime and the Financing of Terrorism (hereinafter referred to as the "Decree"), and the System of Internal Policies, Procedures and Control Measures established on the basis thereof to fulfil the obligations arising from the AMLZ and the Decree, the Central Securities Depository, a.s. (hereinafter referred to as the "CSD") is obliged to carry out identification and control of its clients - issuers. Completion of this form is a condition for concluding a contract or providing a service.',
    FORMULARE_AMLZ_ROZCESTNIK_ZAKL_UDAJE1: `In order to complete the questionnaire, you will need to know information about the natural persons representing the issuer, information about the ownership and management structure of the issuer, information about the beneficial owner of the issuer, information to identify politically exposed persons. Once completed, the questionnaire must be signed with an electronic signature or a qualified certificate (signed by persons authorised to act for the issuer on the basis of a register entry or power of attorney). Instructions on how to sign the questionnaire with an electronic signature can be found in the help section next to the field Method of identification of the person - selection "electronic signature". If you will not be signing by electronic signature, please prepare double-sided copies (in electronic form) of at least two identity documents for each person representing the issuer and confirmation of the existence of the issuer's bank account before you start filling in the questionnaire.`,
    FORMULARE_AMLZ_ROZCESTNIK_INVALID_LEI: `No LEI was found for the ID number entered. If you do not have an LEI code assigned, further information can be found at www.cdcp.cz in the Other Services section. You can check whether you have been assigned an LEI code at www.gleif.org.`,
    FORMULARE_ZADOST_PRID: "Issuer's application for ISIN allocation",
    FORMULARE_ZADOST_ZMEN: "Issuer's Application for Change of ISIN",
    FORMULARE_ZADOST_ZRUS: "Issuer's request for cancellation of ISIN",
    FORMULARE_NACE_TOOLTIP:
        "Enter the two-digit numeric code of the issuer's principal activity according to ARES (first two numbers from the RES tab). For more information, please also see www.nace.cz",
    FORMULARE_LEI_LAPSED_FO:
        'The ID entered does not have a paid LEI renewal fee. You can extend the validity by updating the LEI data (available at https',
    FORMULARE_C2_VLOZTE_DOKLAD: "Insert proof of existence of a bank account in the issuer's name",
    EMP_POTVRZENI_EMAIL_SENT: 'The email change request was successfully sent.',
    EMP_PODANE_ZADOSTI_ODESLANO: 'Accepted into CDCP.',
    EMP_PODANE_ZADOSTI_KEKONTROLE: 'To be checked.',
    EMP_PODANE_ZADOSTI_ZRUSENO: 'Cancelled',
    EMP_PODANE_ZADOSTI_KDOPLNENI: 'To be completed',
    EMP_PODANE_ZADOSTI_ROZPRACOVANO: 'In progress',
    EMP_PODANE_ZADOSTI_KODESLANI: 'In progress',
    EMP_PODANE_ZADOSTI_DOPLENO: 'Completed',
    AMLZ_NOVE: 'New AMLZ',
    AMLZ_PREHLED_NADPIS: 'Current AMLZ data',
    AMLZ_PREHLED_DATUM: 'Last updated',
    AMLZ_PREHLED_OSOBY: 'Persons authorised to represent the issuer',
    EMISE_PODZAD_STAV_AKCEPTOVANO: 'Accepted',
    EMISE_PODZAD_STAV_ZAMITNUTO: 'Rejected',
    EMISE_PODZAD_STAV_KDOPLNENI: 'To be completed',
    EMISE_PODZAD_STAV_KODESLANI: 'To be sent',
    EMISE_PODZAD_STAV_DOPLENO: 'Completed',
    EMISE_PODZAD_STAV_ODESLANO: 'Accepted by CDCP',
    EMISE_PODZAD_STAV_AKTUALIZOVAT: 'To be updated',
    EMISE_PODZAD_STAV_ROZPRACOVANO: 'In progress',
    EMISE_PODZAD_STAV_ZRUSENO: 'Cancelled',
    EMISE_PODZAD_STAV_ZNEPLATNENO: 'Cancelled',
    ISIN_ZASTUPUJE_NADPIS_F: 'Issuer represented by an individual',
    ISIN_ZASTUPUJE_NADPIS_P: 'Issuer represented by a legal entity',
    ISIN_EMISE_CERTIFIKAT_SAZBA_Z2: 'Zero bond',
    SRD_DLAZDICE_NADPIS_SEZNAM: 'List of general meetings and other events',
    SRD_DLAZDICE_DATUM_KONANI: 'Date held',
    SRD_DLAZDICE_ROZHODNY_DEN: 'Record date',
    SRD_DLAZDICE_VYPIS_AKCIONARU: 'Statement of Shareholders',
    SRD_NOVA_NADPIS: 'Issuer submits notification (application)',
    SRD_NOVA_OZNAMENI: 'Notice of',
    SRD_NOVA_OZNAMENI_HROMADA: 'General Meeting',
    SRD_NOVA_OZNAMENI_JINA: 'Other action',
    SRD_NOVA_OZNAMENI_ZADOST: 'Request for disclosure of shareholder identity information',
    SRD_NOVA_ZPUSOB: 'Method of entry',
    SRD_NOVA_ZPUSOB_PRUVODCE: 'Guide',
    SRD_NOVA_ZPUSOB_PRUVODCE_BUTTON: 'Go to guide',
    SRD_STAHNOUT_XML: 'Download XML',
    SRD_NOVA_ZPUSOB_XML: 'XML',
    SRD_XML_ERR_NENALEZENO: 'Verify that you are responsible for the correct event.',
    SRD_XML_ERR_PO_TERMINU: "It's past the voting deadline",
    SRD_XML_ERR_CHYBNY_UCET: 'Voting contains an incorrect account',
    SRD_XML_ERR_CHYBNA_OSOBA: 'Wrong person for account',
    SRD_XML_ERR_CHYBNE_HLASOVANI: 'Erroneous vote (e.g. number of votes does not match)',
    SRD_CIS_UDALOST_VH: 'Notice of General Meeting',
    SRD_CIS_UDALOST_VYPIS: 'Request for statement',
    SRD_DETAIL_VYSLEDEK_VH: 'Result of the AGM',
    SRD_DETAIL_TL_VYPISODP: 'Download Statement',
    SRD_DETAIL_TL_VYPISZRUS: 'Cancel Listing',
    SRD_DETAIL_TL_VHZRUS: 'Cancel AGM',
    SRD_DETAIL_TL_VH: 'Change AGM',
    SRD_DETAIL_TL_VYPIS: 'Submit a request for an extract',
    SRD_DETAIL_TL_VHODP: 'Withdraw a resolution',
    SRD_DETAIL_TL_VHODPZRUS: 'Cancel resolution',
    SRD_DETAIL_TL_POT: 'Submit confirmation of authorisation to attend the general meeting',
    SRD_DETAIL_TL_STR: 'Submit a receipt for voting at the general meeting',
    SRD_DETAIL_TL_ZAP: 'Submit confirmation of vote count',
    SRD_DETAIL_TL_VYSL: 'Submit notice of the result of the vote at the general meeting',
    SRD_DETAIL_TL_JINA: 'Update',
    SRD_DETAIL_INFO_VH:
        'Input is the notice of the general meeting according to ISO 20022 report seev.001.001.11 MeetingNotification',
    SRD_DETAIL_INFO_VHZRUS:
        'Input is the cancellation of the notice of the general meeting according to ISO 20022 report seev.002.001.09 MeetingCancellation',
    SRD_DETAIL_INFO_VYPIS:
        'Input is a request for disclosure of shareholder identity information according to ISO 20022 report seev.045.001.04 ShareholdersIdentificationDisclosureRequest',
    SRD_DETAIL_INFO_VYPISZRUS:
        'Input is the cancellation of a request for disclosure of shareholder identity according to ISO 20022 message seev.046.001.01 ShareholdersIdentificationDisclosureRequestCancellationAdvice',
    SRD_DETAIL_INFO_POT:
        'Input is the confirmation of authorization to attend the meeting according to ISO 20022 report seev.003.001.09 MeetingEntitlementNotification',
    SRD_DETAIL_INFO_STR:
        'Input is a receipt for voting at the general meeting according to ISO 20022 report seev.006.001.10 MeetingInstructionStatus',
    SRD_DETAIL_INFO_ZAP:
        'Input is the confirmation of the vote count according to ISO 20022 message seev.007.001.10 MeetingVoteExecutionConfirmation.',
    SRD_DETAIL_INFO_VYSL:
        'Input is the notification of the result of the vote at the general meeting according to ISO 20022 message seev.008.001.08 MeetingResultDissemination',
    SRD_DETAIL_INFO_JINA:
        'Input is a notification of another corporate action according to ISO 20022 message seev.031.001.14 CorporateActionNotification',
    SRD_DETAIL_INFO_HLAS:
        'Input is a notice of attendance and voting according to ISO 20022 message seev.004.001.09 MeetingInstruction',
    SRD_DETAIL_INFO_ZRUS: 'Input is the seev.005.001.09 MeetingInstructionCancellationRequest message.',
    SRD_PRUVODCE_VH_A: 'A. Issuer Specifications',
    SRD_PRUVODCE_VH_B: 'B. Message Specification',
    SRD_PRUVODCE_VH_B_ID: 'Unique event identifier',
    SRD_PRUVODCE_VH_C: 'C. General Meeting Specification',
    SRD_PRUVODCE_VH_C_DATUM: 'Date of General Meeting (CET/CEST)',
    SRD_PRUVODCE_VH_C_TYPVH: 'Type of General Meeting',
    SRD_PRUVODCE_VH_C_TYPVH_XMET: 'Extraordinary',
    SRD_PRUVODCE_VH_C_TYPVH_GMET: 'General',
    SRD_PRUVODCE_VH_C_TYPVH_MIXD: 'Mixed',
    SRD_PRUVODCE_VH_C_TYPVH_SPCL: 'Special',
    SRD_PRUVODCE_VH_C_TYPVH_BMET: 'BondHolderMeeting',
    SRD_PRUVODCE_VH_C_TYPVH_CMET: 'CourtMeeting',
    SRD_PRUVODCE_VH_C_URLSCHUZKY: 'Uniform Resource Locator (URL)',
    SRD_PRUVODCE_VH_C_MISTOKONANIVH: 'General Meeting Venue',
    SRD_PRUVODCE_VH_D: 'D. Attendance at General Meetings',
    SRD_PRUVODCE_VH_D_PRIDAT: 'Add method of attendance',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB: 'Shareholder Participation Method',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_MAIL: 'Correspondence',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHYS: 'InPerson',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PHNV: 'NotVoting',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_PRXY: 'Proxy',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_VIRT: 'Virtual',
    SRD_PRUVODCE_VH_D_PRIDAT_ZPUSOB_EVOT: 'ElectronicVoting',
    SRD_PRUVODCE_VH_D_PRIDAT_TYPFYZUCASTI: 'Method of physical participation in the General Meeting',
    SRD_PRUVODCE_VH_D_PRIDAT_MASH: 'AllowedForShareholder',
    SRD_PRUVODCE_VH_D_PRIDAT_MAPO: 'AllowedOnBehalf',
    SRD_PRUVODCE_VH_D_PRIDAT_MAAL: 'AllowedWithAttendeeList',
    SRD_PRUVODCE_VH_D_PRIDAT_MALR: 'AllowedWithLetterOfRepresentation',
    SRD_PRUVODCE_VH_D_PRIDAT_MAHI: 'AllowedWithProof',
    SRD_PRUVODCE_VH_D_PRIDAT_MATK: 'AllowedWithTicket',
    SRD_PRUVODCE_VH_D_PRIDAT_MANP: 'NotPossible',
    SRD_PRUVODCE_VH_D_PRIDAT_PROXYTYPE: 'proxy type',
    SRD_PRUVODCE_VH_D_PRIDAT_CHRM: 'Chairman Chairman of the meeting is the proxy.',
    SRD_PRUVODCE_VH_D_PRIDAT_DISC: 'Discretionary Any type of proxy is allowed.',
    SRD_PRUVODCE_VH_D_PRIDAT_HLDR: 'SecurityHolder',
    SRD_PRUVODCE_VH_E: 'E. Agenda',
    SRD_PRUVODCE_VH_E_PRIDAT: 'Add agenda item',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT: 'Quorum',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT_PROCENTA: 'Quorum percentage',
    SRD_PRUVODCE_VH_E_KVORUM_SELECT_POCET: 'Quorum number ',
    SRD_PRUVODCE_VH_E_KVORUM_NE: 'No',
    SRD_PRUVODCE_VH_E_KVORUM_PROCENTA: 'Percentage',
    SRD_PRUVODCE_VH_E_KVORUM_POCET: 'Number',
    SRD_PRUVODCE_VH_E_PRIDAT_ISSSRLABL: 'Unique agenda item identifier',
    SRD_PRUVODCE_VH_E_PRIDAT_TITL: 'Title of agenda item',
    SRD_PRUVODCE_VH_E_PRIDAT_TITL_EN: 'Title of agenda item - en',
    SRD_PRUVODCE_VH_E_PRIDAT_INF: 'Item information',
    SRD_PRUVODCE_VH_E_PRIDAT_FORINFOONLY: 'Informative item',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP: 'Vote',
    SRD_PRUVODCE_VH_E_SUCCESS: 'Vote successful',
    SRD_PRUVODCE_VH_E_CHYBA_HODNOTY: 'Value error',
    SRD_PRUVODCE_VH_E_CHYBA_MAX: 'Unable to enter higher than maximum number',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_HLASOVANO: 'Voted',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_ROZP: 'In progress',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_ADVI: 'Advisory vote',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_BNDG: 'Binding vote',
    SRD_PRUVODCE_VH_E_PRIDAT_VOTETP_OPTIONS: 'Voting options',
    SRD_PRUVODCE_VH_E_HLASOVAT_OD: 'You can vote from',
    SRD_PRUVODCE_VH_E_TERMIN: 'Voting deadline',
    SRD_PRUVODCE_VH_E_PRIDAT_HLASOVANI: 'Alternative voting methods',
    SRD_PRUVODCE_VH_E_PRIDAT_NOSUBMIT: 'Not all fields have been entered. Are you sure you want to continue?',
    ADVI: 'Advisory vote',
    BNDG: 'Binding vote',
    NULL: 'No Value',
    SRD_PRUVODCE_VYPIS_MEZNIDATUM: 'Latest Issuer Deadline',
    SRD_PRUVODCE_VYPIS_MEZNIDATUM_CET: "Issuer's earliest deadline",
    AKCIONAR: 'Shareholder',
    AKCIONAR_PRIPOJENI: 'Equity account attachment',
    AKCIONAR_PRIPOJENI_TXT:
        "On an SRD2 basis, you have the right to be notified by the issuer of the shares you own. You must log into My Deposit to gain access. If you don't have an account, you can create one. Confirmation of the linking of a given asset to a given account will be done via SMS.",
    AKCIONAR_PRIPOJENI_400: 'Invalid link. You cannot log in to an asset account for the specified URL.',
    AKCIONAR_PRIPOJENI_401: 'The asset account has already been activated.',
    AKCIONAR_PRIPOJENI_USPECH: 'The asset account was successfully added.',
    AKCIONAR_REGISTRACE_ERROR_TITLE: 'Waiting for email confirmation',
    AKCIONAR_REGISTRACE_ERROR_TEXT1:
        'To successfully complete the registration, you need to activate the account using the link that was sent to the email you provided during registration.',
    AKCIONAR_REGISTRACE_ERROR_TEXT2: 'Once activated, it will continue further in the process. Do not leave the page.',
    AKCIONAR_SMS_ZNOVU: 'Send SMS again',
    AKCIONAR_SMS_ODESLAT_ERR: 'Failed to send SMS',
    AKCIONAR_PROFIL_MAJETKOVY_UCET: 'Property account',
    AKCIONAR_ZADNE_UDALOSTI: 'No events available',
    AKCIONAR_HLASOVANI_POCET: 'Voted / Total',
    AKCIONAR_HLASOVANI_MAXPOCET: 'Vote total',
    AKCIONAR_MAXPOCET_ZMENA_ERR: 'Value must be greater than 1 and less than {{maxPocet}}',
    AKCIONAR_MAXPOCET_SUBMIT_ERR: 'One or more points exceed the maximum number of votes',
    AKCIONAR_PREDANO: 'Forwarded to issuer',
    AKCIONAR_POTVRDZENO: 'Confirmed by the issuer',
    VH: 'General Meeting',
    VYSL: 'Results of voting at the general meeting',
    JINA: 'Other corporate action',
    VYPIS: 'Listing of shareholders',
    KORPORATNI_AKCE: 'Corporate actions',
    KORPORATNI_AKCE_ROZHODNY_DEN: 'Record Date',
    KORPORATNI_AKCE_ROZPRACOVANO: ' - In progress',
    NOVA_UDALOST: 'New Event',
    DORUCENO_ODESLANO: 'Delivered/Submitted',
    TYPE_VH: 'Notice of General Meeting',
    TYPE_VHODP: 'Response to Notice of General Meeting',
    TYPE_VHZRUS: 'Cancellation of Notice of General Meeting',
    TYPE_VYPIS: 'Listing Request',
    TYPE_VYPISODP: 'Response to Listing',
    TYPE_VYPISZRUS: 'Cancellation of listing',
    TYPE_POT: 'Confirmation of entitlement to attend the general meeting',
    TYPE_STR: 'Receipt for voting at the general meeting',
    TYPE_ZAP: 'Confirmation of counting of votes',
    TYPE_VYSL: 'Notice of the result of the vote at the General Meeting',
    TYPE_JINA: 'Notice of other corporate action',
    MEPOZADAVKY: 'My Requests',
    NEUSPREVODY: 'Unsuccessful transfers',
    NEUSUPISY: 'Failed subscriptions',
    NEUSNAVYSENI: 'Failure to raise',
    NOVENAVYSENI: 'New raise',
    NOVYPREVOD: 'New transfer',
    NOVYUPIS: 'New subscription',
    USPESNEPREVODY: 'Successful transfers',
    USPESNENAVYSENI: 'Successful transfers',
    USPESNEUPISY: 'Successful subscriptions',
    DOSUDNEODESLANE: 'Not yet sent',
    EVIDOVANEVCDCP: 'Registered in CDCP',
    SPECIALNI: 'Special Services',
    DUVERNAOBLAST: 'Confidential information',
    EMISECENNYCHPAPIRU: 'Issuance of securities',
    INFORMACEZAUPLATU: 'Information for consideration',
    NAVYSENI: 'Increase',
    PRVOTNIUPIS: 'Initial subscription',
    PREVODZTECHUCTU: 'Transfer from technical account',
    SLUZBYPRONE: 'Downstream registry services',
    UCTYVLASTNIKA: "Owner's accounts",
    WRSPRAVA: 'Managing users of the confidential area',
    WRUZIVATELE: 'Users',
    WRNOVYUZIVATEL: 'New user',
    WRSEZNAMUZIVATELU: 'User list',
    F15: 'F15',
    F16: 'F16',
    F17: 'F17',
    F18: 'F18',
    F24: 'F24',
    F5: 'F5',
    F6: 'F6',
    F7: 'F7',
    F8: 'F8',
    F20: 'F20',
    F50: 'F50',
    F52: 'F52',
    F53: 'F53',
    F56: 'F56',
    F58: 'F58',
    DALSIINFOMRACE: 'Other information',

    PXKLIC: 'PX Key',
    PXKLIC_TITLE: 'Failed to confirm login to My Depository at the required time using PX Klic.',
    PXKLIC_TEXT1:
        'If no notification was displayed in the PX Key app, check your internet connection and log in again.',
    PXKLIC_TEXT2:
        'If the internet is working, verify that the PX Key is listed in the Applications section of the Applications with Authorization',
    PXKLIC_TEXT3: 'If it is not, it can use the "Continue" button to request an authorization code to be sent.',
    PXKLIC_SMS_ODESLAN: 'An SMS code has been sent to your phone number',
    PXKLIC_ODELSAT_CONFIRM:
        'Are you sure you want to send a new authorization code to authorize the PX Key mobile app?',
    ME_POZADAVKY_DATUM1_POZADOVANE: 'Requested statement date',
    ME_POZADAVKY_PREHLED: 'Overview of access to reply',
    ME_POZADAVKY_DATUM1: 'Date from',
    ME_POZADAVKY_DATUM_VYPIS2: 'Date for dual listing',
    ME_POZADAVKY_DATUM2: 'Date by',
    ME_POZADAVKY_IDENTIFIKATOR_MAJITELE: 'Owner ID',
    ME_POZADAVKY_KATEGORIE_A: 'Administrators',
    ME_POZADAVKY_KATEGORIE_B: 'Owners and administrators',
    ME_POZADAVKY_CISLO_ZNACKA: 'Filing label',
    ME_POZADAVKY_CISLO_JEDNACI_ZNACKA: 'Reference number / File number',
    ME_POZADAVKY_IDIC_MAJITEL: 'Owner Id./Birth Number',
    ME_POZADAVKY_TITLE: 'Selected requirements',
    ME_POZADAVKY_DETAIL_TITLE: 'Specified input parameters',
    ME_POZADAVKY_DETAIL_POZADAVEK: 'Request',
    ME_POZADAVKY_JEN_MOJE: 'My requests only',
    ME_POZADAVKY_ZADOST_TYP_1: 'Request to view responses in XML format',
    ME_POZADAVKY_ZADOST_TYP_2: 'Request to view responses in PDF format',
    ME_POZADAVKY_ZADOST_TYP_3: 'Request to view responses in HTML format',
    ME_POZADAVKY_ZADOST_TYP_4: 'Request to view responses in ZIP format',
    ZRUSENI_POZADAVKU: 'Cancel request',
    ZRUSENI_POZADAVKU_OK: 'Cancellation successful',
    STAHNOUT_ZIP: 'Download ZIP',
    VYMAZAT_FILTR: 'Clear filter',
    FILTROVAT: 'Filter',
    PODANO_OD: 'Submitted by',
    PODANO_DO: 'Submitted by',
    KOD_SLUZBY: 'Service Code',
    STAHNOUT_HTML: 'Download HTML',
    IDENTIFIKATOR: 'Identifier',
    VYJADRENI: 'Expression',
    LEI_OSOBA_UPLOAD_TOOLTIP:
        'Please provide a link or attach a document proving the authority of the named person to act on behalf of the company. The document must state the name and position of the authorised person. In the event that the attached document does not contain the required information, the LEI Assignment/LEI Update Application cannot be processed.',
    LEI_OZIVENI: 'Revival',
    AKTIVNI: 'Active',
    AUTH_PRVEK: 'Authentication element',
    CENTRAL_GOVERNMENT_SUB_NAPR: 'E.g.: ministries,  NBÚ, ČTÚ, ÚOHS, ERÚ, RRTV, SÚJB, atp.',
    CISLO_ZASTAVNI_SMLOUVY: 'Pledge agreement number',
    DALSI_UDAJE: 'Other data',
    DATUM_PRIDELENI: 'Date of assignment',
    DATUM_REGISTRACE: 'Date of registration',
    EMISE_CP: 'Issue of CP',
    EMP_PODANE_ZADOSTI_DATUM_AKTUALIZACE: 'Date of last update',
    EMP_PODANE_ZADOSTI_DATUM_AKTUALIZACE_DALSI: 'Date of next update',
    EMP_PODANE_ZADOSTI_DATUM_CERTIFIKACE: 'Date of next certification',
    EMP_VYBER_PROFIL_VYBERTE_SUBJEKT_NONE: 'Create a new account',
    EVIDENCNI_UDAJE: 'Registration details',
    FORMULARE_ZASTUPUJUCE_OSOBY_TEXT:
        'Fill in details of all individuals you expect to deal with the CDCP on behalf of the issuer (whether jointly or separately, by legal or contractual representation)',
    CHYBA_SOUBOR_DUPLICITNI: 'Duplicate input file',
    CHYBA_SOUBOR_NEVALIDNI: 'Invalid input file',
    ID_OSOBY: 'Person ID',
    ID_NABYVATELE: 'Person ID',
    ID_PREVODU_V_CDCP: 'Transfer ID in CDCP',
    ID_UCTU: 'User ID',
    IDNID_OSOBY: 'Person ID / NID',
    INFORMACNI_SLUZBA: 'Services processed',
    ISIN_EMISE_DRUH_TYP: 'Type',
    ISIN_EMISE_DRUH_OSTATNI: 'Other',
    ISIN_EMISE_DRUH_PRAVOUPSANI: 'Right of subscription',
    ISIN_EMISE_DRUH_PREDNOSTNIPRAVO: 'Pre-emptive right',
    ISIN_EMISE_DRUH_ZATIMNILISTY: 'Provisional certificates',
    ISIN_EMISE_NE: 'No (e.g. perpetual investment vehicle)',
    ISIN_MENU_TOOLTIP:
        'The ISIN assigned to the issue remains the same, only some of the ISIN parameters change, e.g. nominal value, number of units, maturity date, etc.',
    ISIN_ROZCESTNIK_PRIDELENI_OSOBA_JINY_ALT: 'Other person',
    ISIN_ZMENA_SOUBOR:
        'Insert an updated document that reflects the change you are requesting to correct on the ISIN already assigned',
    ISIN_ZRUSENI_SOUBOR: "Insert issuer's decision or other document supporting the request to cancel the issue",
    TYP_PRIHLASENI_UZIV: 'Name and password',
    KOD_UCASTNIKA: 'Participant code',
    KORPORATNI_SRD: 'SRD II Services',
    LEI_AKTUALIZACE_OPRAVNENI_SUB:
        'If the named person cannot be automatically verified, you must insert an attachment with authorisation (extract from the register of companies, power of attorney, etc.).',
    LEI_AKTUALIZACE_OPRAVNENI2:
        'The authorisation of the natural person acting on behalf of a legal entity must be supported by a signed (by the authorised person or persons listed in the public registers) power of attorney authorising a specific person to act on behalf of a specific legal entity.',
    LEI_AKTUALIZACE_ZMENA_IC: 'Has there been a change of registration number?',
    LEI_AKTUALIZACE_ZMENA_NAZVU: 'Has the company name changed?',
    LEI_DETAIL_MAMATKA_BRANCH: 'Does the International branch of the company have an LEI',
    LEI_DETAIL_MAT_SELECT_BRANCH: 'Does the International branch of?',
    LEI_DETAIL_MATER_NAZEV_BRANCH: 'Name of International branch of',
    LEI_FOND_UPLOAD_TEXT:
        "Insert: Fund's Articles of Association, KIID or other documents by which the structure of the fund can be verified",
    LEI_KOD: 'LEI code',
    LEI_SUBCATEGORY: 'Subcategory',
    LEI_SUCCESSOR_ENTITY_NAME: 'Successor company name',
    LEI_U_OPRAVNENE_POVERENE: 'Authorised / authorised persons',
    LEI_VLOZTE_MAT:
        "Insert: Parent company's annual report, consolidated financial statements or other documents from which the relationship between parent and subsidiary can be verified",
    LISTINE_CP: 'Documentary CP',
    LOCAL_GOVERNMENT_SUB_NAPR: 'E.g.: counties, cities or municipalities.',
    MATERSKA_SPOLECNOST: 'Parent company',
    MATERSKA_SPOLECNOST_FINAL: 'Final parent company',
    NEVALIDNI_DATUM_MIMO_INTERVAL: 'Date entered is outside the allowed interval',
    NEVALIDNI_HODNOTA: 'Non-valid value',
    NEVALIDNI_PROCENTA_100_06: 'Item may only contain numbers (with max 6 decimal places) less than or equal to 100',
    NEVALIDNI_RC_ICO: 'Non-valid birth number or ico',
    NEVALIDNI_LEI_VS: 'Non-valid LEI or variable symbol',
    NOVA_ZADOST: 'New event',
    OVERIT: 'Check',
    POCET_CP: 'Number of CP',
    POCET_CP_ODKUP: 'Number of CP - redemption',
    POCET_CP_PRODEJ: 'Number of CPs - subscription',
    POCET_CP_ZAEVIDOVANO: 'Number of CP - successfully registered',
    POCET_NEUSPESNYCH: 'Number of unsuccessful',
    POCET_UCTU_OVERENE_2: 'Number of accounts - verified',
    POCET_USPESNYCH: 'Number of successful',
    PODROBNOSTI: 'Details',
    POSLEDNI_PRIHLASENI: 'Last login',
    POZNAMKA: 'Note',
    PREDPOKLADANE_DATUM: 'Estimated date',
    PREHLED_EMITENT: 'Issuer',
    PREHLED_POZADAVKU: 'Summary of requirements',
    PREHLED_ZAKAZNIK: 'Customer',
    PRIDELENE_ISIN: 'Assigned ISIN',
    PSC_ERROR: 'Non-valid postcode',
    SLUZBY_ISIN: 'ISIN Services',
    SMAZANI_POZADAVKU: 'Delete requests',
    SMAZAT: 'Delete',
    SOCIAL_SECURITY_SUB_NAPR: 'E.g.: health insurance companies, ČSSZ, etc.',
    SOUBOR_POVINNY: 'No file attached',
    SPRAVA_UCTU: 'Account management',
    SS_DATUM_NAVYSENI: 'increase',
    SS_DATUM_PREVOD: 'transfer',
    SS_DATUM_SICAV: 'SICAV/OPF',
    SS_DATUM_UPIS: 'subscription',
    SS_DETAIL_FILTR_NAKUP: 'Underwriting',
    SS_DETAIL_FILTR_PRODEJ: 'Redemption',
    SS_DETAIL_FILTR_TYP: 'Transaction type',
    SS_DETAIL_NEUSPESNE_POZADAVKY: 'Unsuccessful requests',
    SS_DETAIL_POCET_UCTU_ZAEVIDOVANO: 'Number of accounts - successfully registered',
    SS_DETAIL_POZADAVEK: 'Request for',
    SS_DETAIL_STAV_U001: 'New',
    SS_DETAIL_STAV_U002: 'New with serious error',
    SS_DETAIL_STAV_U003: 'New with informative error',
    SS_DETAIL_STAV_U005: 'Sent for processing',
    SS_DETAIL_STAV_U006: 'check in progress',
    SS_DETAIL_STAV_U007: 'verified',
    SS_DETAIL_STAV_U008: 'check in progress - account not yet verified',
    SS_DETAIL_STAV_U700: 'Pending',
    SS_DETAIL_STAV_U750: 'Rejected',
    SS_DETAIL_STAV_U800: 'Marked for cancellation',
    SS_DETAIL_STAV_U801: 'Sent for cancellation',
    SS_DETAIL_STAV_U850: 'Cancelled',
    SS_DETAIL_STAV_U900: 'Transfer settled',
    SS_DETAIL_STAV_U950: 'Transfer not settled',
    SS_DETAIL_TAB_PORIZENI_CDCP: 'CDCP',
    SS_DETAIL_TAB_PORIZENI_D: 'Acquired by file',
    SS_DETAIL_TAB_PORIZENI_R: 'Acquired manually',
    SS_DETAIL_USPESNE_POZADAVKY: 'Successful requests',
    SS_DETAIL_VYBRANY: 'Detail of the selected request',
    SS_DETAIL_VYBRANY_LZE_ZAEVIDOVAT_OD: 'Can be registered from',
    SS_DETAIL_VYBRANY_MEZNI_DATUM_ZRUSENI: 'Cut-off date for cancellation',
    SS_DETAIL_VYBRANY_SMAZAT: 'Delete selected',
    SS_DETAIL_VYBRANY_ZMENIT: 'Change selected',
    SS_ERR_ISIN_PRAVO: 'You are not entitled to this ISIN',
    SS_HISTORICKE_POZADAVKY: 'Historical requirements',
    SS_MENU_TITLE: 'Issuance operations',
    SS_NOVE_NAVYSENI: 'New Increase',
    SS_NOVE_SICAV: 'New SICAV/OPF',
    SS_NOVY_POZADAVEK_NA: 'New request for ',
    SS_NOVY_POZADAVEK_NA_NAVYSENI: 'Increase',
    SS_NOVY_POZADAVEK_NA_NAVYSENISNIZENI: 'Increase/Decrease',
    SS_NOVY_POZADAVEK_NA_PREVOD: 'Transfer',
    SS_NOVY_POZADAVEK_NA_SICAV: 'SICAV/OPF',
    SS_NOVY_POZADAVEK_NA_UPIS: 'subscription',
    SS_NOVY_POZADAVEK_S_CHYBOU: 'with error',
    SS_NOVY_PREVOD_Z_TECH_UCTU: 'New transfer from technical account',
    SS_NOVY_RUCNI_ID_C_VLASTNIKA: "Owner's id. no.",
    SS_NOVY_RUCNI_JMENO: 'Name/2.part of name',
    SS_NOVY_RUCNI_MODAL_RESP_DUPLICITA: 'A request already exists for the account entered.',
    SS_NOVY_RUCNI_MODAL_RESP_CHYBNEICO: 'Assignee ID is incorrect for the account and subscriber code entered.',
    SS_NOVY_RUCNI_MODAL_RESP_PREKROCENO:
        'The number of CPs entered for transfer is more than the number that can be subscribed.',
    SS_NOVY_RUCNI_MODAL_ZAPIS: 'Request entry',
    SS_NOVY_RUCNI_PRIJMENI: 'Surname/1.part of the name',
    SS_NOVY_RUCNI_UVEDTE: 'Indicate the owner here if different from the transferee.',
    SS_NOVY_RUCNI_VALIDACE_CP: 'The number of CPs must be greater than 0',
    SS_NOVY_RUCNI_VALIDACE_IDNABYVATELE_CISLA: 'Must be between 1 and 10 digits',
    SS_NOVY_RUCNI_VALIDACE_UCET: 'Item requires 12 digits and must start with 808, 909 or 100',
    SS_NOVY_RUCNI_VALIDACE_ZASTAVNI: 'Item requires 12 digits and must start with 6',
    SS_NOVY_SOUBOR_EXPORTOVAT_CHYBNE: 'Export incorrect',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_HEAD: 'Delete entire batch',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_RESP: 'The requests have been successfully deleted.',
    SS_NOVY_SOUBOR_MODAL_SMAZANI_TEXT: 'Do you really want to delete the entire batch?',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_HEAD: 'Write error-free requests',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_RESP: 'Error-free batch requests have been successfully written.',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_RESP2:
        'You can find the enrolled requests in the active requests overview after viewing the request details.',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_TEXT: 'Erroneous requests will be deleted. Do you wish to continue?',
    SS_NOVY_SOUBOR_MODAL_ZAPSAT_TEXT_2: 'Do you wish to enroll the selected error-free requests?',
    SS_NOVY_SOUBOR_NAZEV_DAVKY: 'Batch name',
    SS_NOVY_SOUBOR_NAZEV_SOUBORU: 'Input file name',
    SS_NOVY_SOUBOR_OBSAH_DAVKY: 'Input Batch Content',
    SS_NOVY_SOUBOR_POCET_BEZCHYBNYCH: 'Number of error-free requests',
    SS_NOVY_SOUBOR_POCET_CHYBNYCH: 'Number of faulty requests',
    SS_NOVY_SOUBOR_SEZNAM_BEZ_CHYBY: 'List of error-free requests',
    SS_NOVY_SOUBOR_SEZNAM_NA: 'List of requests for',
    SS_NOVY_SOUBOR_SEZNAM_NADPIS_OVERENI: 'List of requests for account verification',
    SS_NOVY_SOUBOR_SEZNAM_NADPIS_SMAZANI: 'List of requests to delete',
    SS_NOVY_SOUBOR_SMAZAT_DAVKU: 'Delete entire batch',
    SS_NOVY_SOUBOR_CHYBNE: 'Erroneous requests',
    SS_NOVY_SOUBOR_ZAPSAT_BEZCHYBNE: 'Write error-free requests',
    SS_NOVY_UPIS: 'New subscription',
    SS_OVERENI_UCTU: 'Account Verification',
    SS_PREHLED_AKTIVNICH_POZADAVKU: 'Overview of active requests',
    SS_PREHLED_OVERENE: 'Verified',
    SS_PREHLED_POCET_UCTU: 'Number of accounts',
    SS_PREHLED_POZADAVEK_NAVYSENI: 'Increase',
    SS_PREHLED_POZADAVEK_PREVOD: 'Transfer from technical account',
    SS_PREHLED_POZADAVEK_SICAV: 'SICAV/OPF',
    SS_PREHLED_POZADAVEK_UPIS: 'Initial subscription',
    SS_PREHLED_STAV_LZE_PRIDAVAT: 'Requests can be added',
    SS_PREHLED_STAV_NELZE_PRIDAVAT: 'Registered in CDCP - cannot add requests',
    SS_PREHLED_STAV_VYRIZENO: 'Handled by',
    SS_PREHLED_USPESNYCH_NEUSPESNYCH: 'Number of successful / unsuccessful',
    SS_PRIDAT_POZADAVEK: 'Add request',
    SS_PRIDAT_ZE_SOUBORU: 'Add from file',
    SS_SEZNAM_MODAL_USPESNE: 'Selected accounts have been successfully',
    SS_SEZNAM_MODAL_USPESNE_OVERENY: 'sent for verification',
    SS_SEZNAM_MODAL_USPESNE_POZADAVKY: 'Selected requests were successful',
    SS_SEZNAM_MODAL_USPESNE_SMAZANY: 'deleted',
    SS_SEZNAM_MODAL_USPESNE_ZAEVIDOVANY: 'sent for processing',
    SS_SEZNAM_MODAL_ZAEVIDOVAT_TEXT:
        'Please note that this step has not been taken to transfer from a technical account and it is necessary to check that the transfer instructions you have entered have been received by the CSD for settlement on the date you have specified. You will find this request status result in the details of each request in the Active Request Overview section.',
    SS_SEZNAM_ZAEVIDOVAT_LZE: 'List of requests that can be registered',
    SS_SEZNAM_ZAEVIDOVAT_NELZE: 'List of requests that cannot be registered',
    SS_VYBER_ISIN_FILTR_EMISI: 'Emission filter',
    SS_VYBER_ISIN_NAZEV_EMISE: 'Full name of the issue',
    SS_ZAEVIDOVAT_V_CDCP: 'Register in CDCP',
    STATE_GOVERNMENT_SUB_NAPR: 'E.g.: federal states in Germany or Austria.',
    STATUS: 'Status',
    STAV_ZADOSTI: 'Application status',
    TABULKA_ZADNE_ZAZNAMY: 'Table contains no entries',
    TYP_PRIHLASENI_CERT: 'Certificate',
    TYP_PRIHLASENI_PXKLIC: 'Name and password (PX Key)',
    UCET: 'Account',
    UCET_NOVY_SELECT_LEI: 'LEI Applicant / LEI Holder',
    UPRAVIT_UDAJE: 'Edit data',
    UZIVATELE: 'Users',
    VSECHNY: 'All',
    VYBRAT_ISIN: 'Select ISIN',
    WRSPRAVATITL: 'Manage users',
    ZADNA_DATA: 'No data to display',
    ZAKNIHOVANE_CP: 'Book-entry securities',
    ZMENIT_HESLO: 'Change password',
    ZPRACOVANE_ZADOSTI: 'Processed requests',
    ZPUSOB_PORIZENI: 'Acquisition method',
    EMITENTA: 'Issuer',
    ELEKTRONICKE_SLUZBY: 'Electronic services',
    ROZPRACOVANE_ZADOSTI: 'Applications in progress',
    SPINOFF: 'Spin-off',
    LEI_AKTUALIZACE_SUCCESSOR_ERR: 'Name or LEI must be filled in',
    IN_PROGRES: 'In Progress',
    IN_PROGRESS: 'In Progress',
    COMPLETED: 'Completed',
    WITHDRAWN_CANCELLED: 'Withdrawn Cancelled',
    UPLOAD_INVALID_FORMAT: 'The file format you are trying to upload is invalid',
    UPLOAD_INVALID_NAME: 'The file name is too long or contains forbidden characters',
    LEI_PRIHLASENI_SUB1:
        'My Depository, is a web portal through which services are provided to LEI applicants/holders electronically. Registration is required to access the services.',
    LEI_PRIHLASENI_SUB2:
        'A user who has already registered and has access to the My Depository portal can log in below.',
    LEI_PRIHLASENI_SUB3: 'If you have not yet registered, click on the "Register" button and first register as a user.',
    LEI_PRIHLASENI_SUB4:
        'If you do not have access to the existing user account that maintains the LEI, please contact CSD Prague at lei@pse.cz.',
    LEI_LOGIN_TITLE: 'My depository - information portal',
    LEI_LOGIN_REGISTER: 'Create account',
    LEI_AKTUALIZACE_LOGIN_SUB: 'Please enter your LEI code here.',
    LEI_MIGRACE_ERR:
        'This LEI is not managed by our company. If you wish to transfer your LEI under our management, please contact us at lei@pse.cz',
    LEI_PORTAL_TITLE: 'LEI Renewal',
    LEI_PORTAL_SUB: 'Enter your login credentials to manage your LEI.',
    ZAPOMENUTE_HESLO_LEI_SUB:
        'Please enter your company LEI and your contact email to communicate with CDCP. You will only receive a link to reset your password if you have provided an email identical to the email provided in your LEI registration request',
    ZAPOMENUTE_HESLO_LEI_SENT:
        'You will only receive a password reset link if you have provided an email for LEI that is identical to the email provided for LEI.',
    ZAPOMENUTE_HESLO_LEI_TITLE: 'Request a new password',
    LEI_MENU_AKTUALIZACE_LOGIN: 'Verification of LEI',
    ZAPOMENUTE_HESLO_LEI: 'New / Forgotten password',
    LEI_AKTUALIZACE_PRIHLASOVACI_UDAJE: 'Login',
    LEI_PORTAL_SUCCESS_SUB: 'Continue via email',
    LEI_UKTUALIZACE_LOGIN_ZADAJTE_LEI: 'Enter the LEI at CDCP',
    LEI_PORTAL_SUB_JINY: 'Another account',
    LEI_REGISTRACE_TEXT:
        'In an effort to ensure that your account is as secure and protected as possible, we have changed the scope of the mandatory registration information that each user must provide to us as of the same date. For this reason, we would like to ask you to fill in the short registration form which can be found below. If you do not provide the required registration information, you will not be able to access the CDCP online services offered in the MD Portal. We thank you in advance for your willingness and helpfulness.',
    LEI_PORTAL_SUCCESS:
        'bold(Note:) Change of the login credentials of your LEI account.  For security reasons, it is no longer possible for one of your login credentials to be an LEI code. The new login will be the username you specify, which is your email. Please change and confirm your new login details using the form below.',
    DASHBOARD_CARD_PROFIL_EMITENT: 'Profile Issuer',
    DASHBOARD_CARD_PROFIL_LEI: 'Profile LEI',
    DASHBOARD_CARD_PROFIL_AKCIONAR: 'Profile Property account',
    DASHBOARD_CARD_PROFIL_CDCPSRD: 'Profile CDCP SRD',
    DASHBOARD_CARD_PROFIL_ADMEMIT: 'Profile Issue Administrator',
    DASHBOARD_CARD_PROFIL_UCASTNIK: 'Profile Participant',
    DASHBOARD_CARD_PROFIL_SPRAVCEUCTU: 'Profile Asset Manager',
    DASHBOARD_CARD_PROFIL_SPRAVCELEI: 'Profile LEI administrator',
    DASHBOARD_CARD_PROFIL_ADMINISTRATOR: 'Profile Profil Administrator',
    DASHBOARD_CARD_PROFIL_2: 'Profile CNB',
    DASHBOARD_CARD_PROFIL_39: 'Profile Borrower',
    DASHBOARD_CARD_PROFIL_5: 'Profile Issuer',
    DASHBOARD_CARD_PROFIL_6: 'Profile Notary',
    DASHBOARD_CARD_PROFIL_40: 'Profile Notary-internal',
    DASHBOARD_CARD_PROFIL_41: 'Profile Executor-internal',
    DASHBOARD_CARD_PROFIL_9: 'Profile System',
    DASHBOARD_CARD_PROFIL_10: 'Profile Other public authorities',
    DASHBOARD_CARD_PROFIL_28: "Profile Public Prosecutor's Office",
    DASHBOARD_CARD_PROFIL_29: 'Profile Court',
    DASHBOARD_CARD_PROFIL_26: 'Profile Tax office',
    DASHBOARD_CARD_PROFIL_42: 'Profile Tax office-internal',
    DASHBOARD_CARD_PROFIL_43: 'Profile Ins.spr.,spr.bankruptcy,liquidator-internal',
    DASHBOARD_CARD_PROFIL_45: 'Profile Contract customer',
    DASHBOARD_CARD_PROFIL_100: 'Profile Testing downstream records',
    DASHBOARD_CARD_PROFIL_46: 'Profile Insolvency proceedings, liquidator',
    DASHBOARD_CARD_PROFIL_49: 'Profile Issuer with subscription rights',
    DASHBOARD_CARD_PROFIL_25: 'Profile Executor',
    DASHBOARD_CARD_PROFIL_50: 'Profile Issue administrator with subscription rights',
    DASHBOARD_CARD_PROFIL_38: 'Profile Issue administrator',
    DASHBOARD_CARD_PROFIL_34: "Profile CDCP's override",
    DASHBOARD_CARD_PROFIL_35: 'Profile Central Depository',
    DASHBOARD_CARD_PROFIL_3: 'Profile Administration of administrators',
    DASHBOARD_CARD_PROFIL_44: 'Profile Customer user management',
    DASHBOARD_CARD_PROFIL_52: 'Profile Investment Fund Administrator',
    DASHBOARD_CARD_PROFIL_70: 'Profile SRD Issuer',
    DASHBOARD_CARD_PROFIL_53: 'Profile Retired profile 46 - ins.spr.,insolvency administrator,liquidator',
    DASHBOARD_CARD_PROFIL_56: 'Profile Issuer Area Officer',
    DASHBOARD_CARD_PROFIL_71: 'Profile SRD Administrator',
    DASHBOARD_CARD_PROFIL_72: 'Profile CDCP SRD',
    DASHBOARD_CARD_PROFIL_M: 'Profile Property Account',
    PRISTUPY_ELSLUZBY: 'Electronic Services (Subscriptions)',
    PRISTUPY_EMISNIOP: 'Issuance Operations (Statements)',
    PRISTUPY_SRDKORPAKCE: 'SRD (Corporate Actions)',
    PRIDAT_UCET: 'Add Account',
    BUTTON_UPRAVIT_DOTAZNIK: 'Edit Questionnaire',
    MENU_LEI_SPRAVA: 'LEI update / Assign LEI to my Administration',
    PREHLED_LEI: 'List of LEI',
    PREHLED_UCTU: 'List of accounts',
    NAZEV_EMISE: 'Name of the issue',
    IDVCDCP: 'Account holder / account manager ID in CSD Prague',
    POCET_CP_PREPSANO: 'Number of CP - successfully credited',

    EMAIL2: 'E-mail 2',
    FORMULARE_AMLZ_C4A_TITLE: 'C4A - Issuer beneficial owner details',
    FORMULARE_AMLZ_C4B_TITLE: 'C4B - Details of person in senior management',
    ME_POZADAVKY_KATEGORIE_S: 'Owner/Manager',
    ME_POZADAVKY_IDIC_OBECNY_SUBJ: 'General entity',
    DUVERNE_INFO_ISIN_BUTTON: 'Select ISIN',
    LEI_DETAIL_ADRESA_TITLE_UPDATE: 'Registered office address - original',
    LEI_AKTUALIZACE_OPRAVNENI_SUB_ZAHRANICNI: 'Insert attachment with given authorization.',
    LEI_IS_SUBFUND_OF_SELECT:
        'Applicant is a sub-fund of an investment fund,I further state the LEI of the umbrella investment fund (Umbrella structure)',
    LEI_IS_FEEDER_TO_SELECT:
        'Applicant is a subordinated standard fund, I further state the LEI of the master fund (Master-Feeder structure)',
    LEI_IS_FUND_MANAGED_BY_SELECT:
        'Applicant is an investment fund, I further state the LEI of the investment company (fund manager)',
    LEI_LOGIN_SUB1: 'Only a registered user may submit an LEI request.',
    LEI_LOGIN_SUB2: 'A user who has already registered and has access to the My Depository portal can apply.',
    LEI_LOGIN_SUB3: 'If you have not yet registered, please click on the "Register a new user" button below.',
    LEI_AKTUALIZACE_LOGIN_ZADAJTE_LEI: 'Enter the LEI you have on file with the CDCP',
    ZAPOMENUTE_HESLO_LEI_TITLE2: 'New password for LEI',
    ZAPOMENUTE_HESLO_LEI_SUB2: 'Please enter your new password to access the LEI portal',
    VYPIS_REGISTER: "Extract from the issuer's register",
    INFORMACNI_SLUZBY: 'Information Services',
    SLUZBY_LEI: 'LEI - LEI allocation and maintenance',
    SLUZBY_EMITENT: 'ISSUER - Overview, Maintenance, Services',
    ZADOST_NOVY_LEI: 'Application for a new LEI',
    SPRAVA: 'Administration',
    SPRAVA_LEI: 'LEI maintenance',
    UCET_NOVY_EMITENT: 'New user account for Issuer',
    PREDANI_LEI_DO_SPRAVY: 'Transfer of administration of LEI',
    LEI_NEEVIDOVANE: 'Given LEI is not under administration of CSD Prague.',
    LEI_NEEVIDOVANE_PARAGRAPH:
        'If you wish to transfer the LEI to the CSD Prague please contact us at lei@pse.cz. Download the LEI Transfer Request Form',
    LEI_SPRAVA_UCTU_ZADOST_NEZNAM:
        'Would you like to submit a request to transfer maintenance of  LEI under your administration?',
    LEI_SPRAVA_UCTU_ZADOST:
        'The LEI is under the administration of another user. Do you want to send a request to transfer maintenance of  LEI under your administration?',
    LEI_SPRAVA_UCTU_PREVODHESLO: 'Do you know the password to the LEI user account?',
    ODESLAT_ZADOST: 'Send request',
    LEI_SPARAVA_ZADOST_SUCCESS_TITLE: 'The request has been successfully submitted',
    ZNAM_HESLO: 'Yes, I know the password.',
    NEZNAM_HESLO: 'No, I dont know the password.',
    LEI_SPRAVA_UCTU_PW_NESPRAVNE:
        'The password you entered is incorrect. Do you still want to send a request to transfer LEIs under your administration?',
    UCEL_NOVEHO_UCTU: 'Select  a purpose for creating a new account',
    ZVOLTE_UCET: 'Select an account',
    LEI_PRIDELENI_TITLE: 'Assign LEI under your administration',
    LEI_PRIDELENI_TEXT: 'Are you sure you want to add LEI {{lei}} under your administration?',
    LEI_ZADOST_SPRAVA_TITLE: 'Add an LEI under your administration request',
    LEI_ZADOST_SPRAVA_TEXT: 'After approving the application, you will find the LEI in the My Depository portal',
    DUVERNE_INFO_TITLE_F42:
        'F42 -Issue statement including rights, ESM(beneficial owner record) and bank account numbers as of the date entered',
    DOTAZNIK_PEP: 'PEP (Politically exposed person) Questionnaire',
    DOTAZNIK_PEP_TEXT:
        'With respect to the inclusion of a Politically Exposed Person (PEP) in the AML Questionnaire, the CDCP, as an obligated person under the AMLZ, must obtain sufficient assurance that it knows and understands the actions of its client and that no illegal activity within the meaning of the AMLZ is occurring in the context of this business relationship. The existence of a PEP at the issuer will not have a negative impact on the business relationship with the CDCP, except that the CDCP may request more additional information about its actions. Confidential information provided to the CDCP is protected by a strict duty of confidentiality. However, we must refuse to execute a trade if you do not provide cooperation. Thank you for your understanding,',
    DOTAZNIK_PEP_TEXT2: 'Therefore, we respectfully request that you answer the following additional questions',
    DOTAZNIK_PEP_FUNKCE:
        'What specific function gives rise to the designation of a person acting for a client or beneficial owner as a PEP? Please indicate according to the wording of the law below.',
    DOTAZNIK_PEP_PUVODMAJETKU: "What is the origin of the PEP's property (select up to 3 options)",
    DOTAZNIK_PEP_ROZSAHMAJETKU:
        'Approximate total extent of property? This is not the origin of the finances used in the transaction in the context of the relationship with the CDCP, but in general (Select one option)',
    DOTAZNIK_PEP_MAJETKOVEPOMERY:
        'Does the PEP have an obligation to disclose its property in the Register of Notifications within the meaning of Act No. 159/2006 Coll. on Conflict of Interest?',
    DOTAZNIK_PEP_PREVZDROJMAJETKU:
        "Furthermore, please indicate the predominant source of the issuer's assets and their expected amount in the next three years.",
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO1: 'Own resources',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO2: 'Salary or wage',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO3: 'Income from business',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO4: 'Lottery winnings',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO5: 'State or private pension',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO6: 'Income from investments and funds',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO7: 'Settlement of community property',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO8: 'Inheritance',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO9: 'Real estate income',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO10: 'Social benefits',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO11: 'Study grants and scholarships',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO12: 'Trust fund income',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO13: 'Direct investments in companies',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO14: 'Foreign sources',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO15: 'Loan',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO16: 'Income of partner(s)',
    DOTAZNIK_PEP_PUVODMAJETKU_RADIO17: 'Other (please specify)',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO1: 'up to CZK 5 000 000',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO2: 'up to CZK 10 000 000',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO3: 'up to 50 000 000 CZK',
    DOTAZNIK_PEP_ROZSAHMAJETKU_RADIO4: 'over CZK 50 000 000',
    DOTAZNIK_PEP_PREVZDROJMAJETKU_RADIO1: 'Income from own business activities',
    DOTAZNIK_PEP_PREVZDROJMAJETKU_RADIO2: 'Foreign sources',
    DOTAZNIK_PEP_PREDPVYSEMAJETKU: 'Please provide information on the expected amount of sources of property',
    EMITENT_PREHLED_ISINY: 'List of ISINs issued in CDCP',
    UPOZORNENI_CHYBNYCERT: 'Certificate issuer or owner name does not match',
    UPOZORNENI_NENIPREDPLATNE:
        'You do not have a subscription to this service. By confirming the request you agree to be invoiced for the service.',
    UPOZORNENI_ODESLANO: 'The request has been successfully registered.',
    UPOZORNENI_NOTIFIAKCE: 'You will be notified by email when the service has been processed.',
    UPOZORNENI_KLICZAMITNUTO: 'The registration of the request has not been confirmed. Repeat the action.',
    UPOZORNENI_BUDENOTIFIKACE: 'You will be notified by email when the service has been processed.',
    UPOZORNENI_BUDEODESLANO: 'The service will be sent for processing the day after the day(s) specified.',
    LEI_NESHODNE_UDAJE: 'The data does not match the information in the Commercial Register',
    LEI_NESHODNE_LEGAL_FORM: 'The legal form does not match the information in the Commercial Register',
    LEI_NESHODNE_LEGAL_ADDRESS:
        'The registered office address does not match the information in the Commercial Register',
    LEI_NESHODNE_LEGAL_NAME: 'Name of the legal entity does not match the information in the Commercial Register',
    LEI_PREHLED_ODESLANO_NOVY_TITLE: 'Legal Entity Identifier (LEI) allocation request has been sent',
    LEI_PREHLED_ODESLANO_AKTUALIZACE_TITLE: 'Legal Entity Identifier (LEI) update/renewal request has been sent',
    LEI_NEPLATNY_KOD: 'Invalid LEI code',
    LEI_MAT_SOUBOR_STEJNY: 'Identical file as the direct parent company',
    SPRAVOVANE_EMITENT: 'Accounts under administration - Issuer',
    SPRAVOVANE_ADMEMIT: 'Accounts under administration - Issue administrator',
    SPRAVOVANE_UCASTNIK: 'Accounts under administration - Participant SRD II',
    SPRAVOVANE_AKCIONAR: 'Accounts under administration - Shareholder',
    SPRAVOVANE_SPRAVCEUCTU: 'Accounts under administration - Issue administrator SRD II',
    SPRAVOVANE_STATNISPRAVA: 'Accounts under administration - Public authority',
    SPRAVOVANE_CDCPSRD: 'Accounts under administration - CDCPSRD',
    PREHLED_EMITENTU: 'List of issuers',
    DUVERNE_INF_ERR_401: 'Incorrectly selected certificate',
    CHYBA_SLUZBY: 'Service error, please try again later',
    CHYBA_SLUZBY_DATUM: 'The date that you enter is outside the allowed time range',
    DASHBOARD_CARD_UCTY_ADMEMIT: 'Issue Administrator - Overview, maintenance, Services',
    DASHBOARD_CARD_UCTY_UCASTNIK:
        'Participant - list of maintenance securities accounts, corporate event overview, services',
    DASHBOARD_CARD_UCTY_AKCIONAR:
        'Shareholder -  list of maintenance securities accounts, corporate event overview, services',
    DASHBOARD_CARD_UCTY_SPRAVCEUCTU:
        'Administrator -  list of maintenance securities accounts, coroporate event overview, services',
    DASHBOARD_CARD_UCTY_STATNISPRAVA: 'Public authority -list of user accounts, administration, services',
    DASHBOARD_CARD_UCTY_CDCPSRD: 'CDCPSRD Profile',
    DASHBOARD_CARD_ZADOST_PRIDELENI: 'Application for new LEI',
    DASHBOARD_CARD_ZADOST_PRODLOUZENI: 'Application for renewal LEI',
    DASHBOARD_CARD_LEI_PRODLOUZENI: 'LEI Renawal',
    DASHBOARD_CARD_OZNAMENI_UDALOSTI: 'Corporate Event Notification',
    DASHBOARD_CARD_AKTUALIZACE_KONTAKT: 'Contact Person Update',
    DASHBOARD_CARD_PREVOD_LEI: 'Transfer of LEI under administration',
    DASHBOARD_CARD_REGISTER_VYPIS: 'Statements from the issuer register',
    DASHBOARD_CARD_SPRAVA_EMITENTA: 'Maintenance',
    DASHBOARD_CARD_INFORMACE_UPLATU: 'Securities Issues information (for a fee)',
    DASHBOARD_CARD_UCTY_VLASTNIKU: "Confidential information - Owners' securites accounts",
    DASHBOARD_CARD_EMISE_CP: 'Issues of securities',
    DASHBOARD_CARD_MAJETKOVE_UCTY: 'List of securities accounts ',
    DASHBOARD_CARD_SLUZBY_ACKIONAR: 'Services for shareholders',
    DASHBOARD_CARD_SLUZBYVH: 'General Meeting Information Services',
    DASHBOARD_CARD_HLASOVANI: 'Voting services',
    DASHBOARD_CARD_PREHLED_MU: 'List of securities accounts under maintenance',
    LOGIN_NAVOD_LEI_PRIDELENI: 'HOW TO: How to apply for an LEI?',
    LOGIN_NAVOD_LEI_AKTUALIZACE: 'HOW TO: How do I extend my LEI and update my data?',
    LOGIN_ERR_409: 'User account is deactivated',
    C4_ESM_STAV_ESMDOPL: 'Načteno z ESM',
    C4_ESM_STAV_ESMOK: 'Načteno z ESM',
    C4_ESM_STAV_ESMODEB: 'Odebráno uživatelem',
    C4_ESM_STAV_RUCNE: 'Přidáno uživatelem',
    LEI_PRIHLASENI_LEI_MENO:
        'Please note that as of 1 April 2022, there has been a change in the login to the LEI account and it is now necessary to access the LEI management via the My Depository portal user account. The login details are bold(email) and bold(password). If you have not yet created a user account in the My Depository portal, please register using the Register button.',
    LEI_ZADOST_DUPLICITA:
        'Request for „Assign LEI to my Administration“ has already been sent, please wait. Information about the processing of the request will be sent to you by email.',
    PRIDAT_LEI_KUCTU_TOOLTIP:
        'Select if you would like to Update an already existing LEI that does not appear in the Managed LEI overview.',
    LOGIN_LEI_INVALID:
        'Invalid username or password. As of April 1, 2022, there has been a change in the way users log in to LEI services. Online services are now only available to registered users of the My Depository portal.',
    LEI_NONE_INFO:
        'To update an existing LEI that does not appear in the "Managed LEIs" report, you first need to convert the LEI into user´s administration. Select "Assign LEI to my administration" and follow the instructions.',
    LEI_CARD_TRANSFERED: 'LEI is currently under another LOU if you wish to continue, transfer this LEI to CDCP',
    PREVEST: 'Transfere ',
    ZNEAKTIVNIT: 'Deactivate',
    ZAPLATIT: 'Submit Order With Obligation To Pay',

    SUBJEKT: 'Entity',
    DOPLNIT: 'Add',
    FORMULARE_OSOBY: 'Persons in senior management',
    NEVALIDNI_NUM_LAT: 'Field shall contain only numbers and letters',
    RODNE_CISLO_DATUM_NAR: 'Birth number / Date of birth',
    LEI_CANCELLED_CARD_TEXT: 'LEI application has been cancelled, please create a new application',
    DUVOD_ODSTRANENI_OSOBY: 'Indicate the reason for removal of person',
    VLOZTE_DOKUMENT: 'Insert document',
    SRD_PRUVODCE_VH_D_PRIDAT_NEPR:
        'Neutral proxy nominated by the issuer to execute votes on behalf of investors at the meeting.',
    SRD_PRUVODCE_VH_E_PRIDAT_PRAH: 'Threshold ',
    SRD_PRUVODCE_VH_E_PRAH_ALSH: 'Total number of shares issued ',
    SRD_PRUVODCE_VH_E_PRAH_ALSM: 'Total number of shares represented at the general meeting by participants',
    SRD_PRUVODCE_VH_E_PRAH_ALVO: 'Total number of votes cast in favour of the resolution',
    BANK_ID: 'Bank ID',
    VYPIS_Z_UCTU: 'Unclassified account statement',
    NEZARAZENY_UCET: 'Unclassified account',
    PRIHLASIT_SE_PPRES_BANKID: 'Login via Bank ID',
    PODMINKY_PRO_ZISKANI_VYSTUPU: 'Conditions for obtaining a statement:',
    PROVEDENI_OBJEDNAVKY: 'Placing an order',
    PREDANI_RODNEHO_CISLA: 'Providing the birth number using BANK ID',
    CELE_JMENO: 'Full name',
    ZADAM_O_VYPIS: 'I am requesting a statement from an unclassified account',
    CELKOVA_CASTKA: 'Total amount',
    SOUHLASIM_S_OBCHODNIMI_PODMINKAMI: 'I agree to the terms and conditions',
    SOUHLASIM_S: 'I agree to',
    OBCHODNIMI_PODMINKAMI: 'terms and conditions',
    ZADOST_BYLA_ODESLANA: 'The request for a statement for your person has been successfully sent.',
    O_ZPRACOVANI_BUDETE_INFORMOVANI: 'You will be notified by email when your request has been processed.',
    POTVRDIT_SOUHLAS: 'Please confirm that you agree',
    ID_SUBJEKTU: 'Subject ID',
    LEI_ICO_CHECK_ERR_JINY: 'A request has already been submitted/processed by another user for the entered ID',
    TYP_PRIHLASENI_PXKL: 'PX Key (PX Klic)',
    UPOZORNENI_NEVALIDNIISIN: 'Note: CDCP does not record the issue entered. Please check its correctness.',
    UPOZORNENI_NEVALIDNIRC:
        'The entered birth number/ID number/NID may be incorrect. Please check it for accuracy and do not fill in the slash character in the case of a birth number',
    INVALID_RCMA: 'item requires 1 to 12 characters (digits, capital letters, -,/)',
    PRBL_SELECT_0: 'search for accounts in all status',
    PRBL_SELECT_1: 'search for accounts with a change of blocking status',
    ADMINISTRATOR_EMISE: 'Issue Administrator',
    SPRAVCE_EMISE: 'Issue Administrator',
    SPISOVA_ZNACKA: 'File number',
    DLUZNIK_MSG:
        'Access to the My Depository electronic services has been blocked due to the registration of overdue invoices. For more information, please contact us at fakturace@pse.cz',
    PREHLED_UZIVATELU: 'Overview of users',
    POZADAVKY_OSTATNYCH_PRAVO: 'Allowed to see requests from other users',
    DETAIL_UZIVATELE: 'User detail',
    VYSTAVITEL_CERTIFIKATU: 'Certificate issuer',
    STAV_UZIVATELE: 'User Status',
    UZIVATEL_STAV_A: 'Active',
    UZIVATEL_STAV_B: 'Inactive',
    CERT_POUZITY_U: 'Certificate is already in use for accounts',
    ZNEAKTIVNIT_MSG: 'Are you sure you want to deactivate this account?',
    ZNEAKTIVNIT_SUCCESS: 'Account deactivation was successful',
    USER_EDIT_SUCCESS: 'User detail modification was successful',
    C4_OSOBY_RELOAD:
        'The list of beneficial owners is not current and will be reloaded with the current values from the register of Beneficial owners',
    C4_C_ERR:
        'In the Register of Beneficial Owners, data on the beneficial owner of the entity was found and therefore it is not possible to select this option. Please select option A or B.',
    PXKLIC_NOT_SETUP: 'Please complete the pairing of the PX Key(PX Klic) mobile app',
    C4_AB_PRAVNIFORMA_ERR:
        'If you are not subject to the obligation to register the real owner, please select option C.',
    NEPLATNE_AML_ERR:
        "Access to the portal's electronic services - Issue registration statement has been blocked due to a missing AML. You must submit an AML application.",
    LEI_PAYMENT_BUTTON: 'Proceed to select the payment method',
    LEI_PAYMENT_TITLE: 'Select payment method',
    LEI_PAYMENT_ONLINE: 'Online payment',
    LEI_PAYMENT_TRANSFER: 'Bank transfer',
    PLATEBNI_BRANA_REDIRECT: 'You will be redirected to a payment gateway',
    LEI_VYSTAVENE_FAKTURY: 'Issued invoices',
    REGISTRACNI_POPLATEK: 'Registration fee',
    LEI_PAYMENT_SUCCESS: 'Payment was successful',
    LEI_PAYMENT_PENDING:
        'Payment must be completed. You will be redirected to the payment gateway. If you wish to pay by another method, please select the Cancel Payment option on the payment gateway.',
    ZRUSIT_UCET_TITLE: 'Cancel account',
    ZRUSIT_UCET: 'account cancelled',
    ZRUSIT_UCET_SUCCESS: 'The account has been successfully canceled',
    ZNEAKTIVNIT_UCET_SUCCESS: 'Account has been successfully deactivated',
    ZRUSENI_UCTU: 'Cancel account',
    ZRUSIT_UCET_MSG: 'Are you sure you want to cancel your account?',
    ZADOST_O_LEI_UPDATE: 'LEI update application',
    ZADOST_ODESLANA_LEI: 'The LEI request has been submitted',
    ZADOST_ODESLANA_LEI_AKTUALIZACE: 'The LEI update request has been submitted',
    C5_DOTAZNIK_ERROR: 'Please edit the questionnaires for the highlighted lines before proceeding',
    LEI_MATKA_STEJNE_ERR: "LEI of mother's company can't be the same as your LEI",
    LEI_FUND_STEJNE_ERR: "LEI of fund can't be the same as your LEI",
    FUND_SELFMANAGED: 'Is the fund self-managing?',
    LANG_SELECT: 'Language',
    NASTAVENI: 'Settings',
    AMLZ_TYPZADOSTI_AMLZ: 'Amlz',
    CESTINA: 'Czech',
    ENGLISH: 'English',
    ROZCESTNIK_LOGIN_EMITENT_TITLE: 'My Depository - Issuer / DLT Issuer',
    ROZCESTNIK_LOGIN_EMITENT_TEXT:
        'My Depository is a web portal through which services are provided to issuers electronically. Registration is required to access the services.',
    ROZCESTNIK_LOGIN_SRD_TITLE: 'My Depository - Exercise of shareholder rights under SRD II',
    ROZCESTNIK_LOGIN_SRD_TITLE_SHORT: 'Exercise of shareholder rights under SRD II',
    ROZCESTNIK_LOGIN_SRD_TEXT:
        'My Depository, is a web portal through which a shareholder of a company traded on a regulated EU market can exercise their shareholder rights, provided that the issuer allows this option. To access the services, registration is required, which you will do through the CSD participant with whom you have an asset account.',
    ROZCESTNIK_LOGIN_STATNISPRAVA_TITLE: 'My depository - State Administration',
    ROZCESTNIK_LOGIN_STATNISPRAVA_TEXT:
        'My Depository is a web portal through which services are provided to public authorities electronically. Access to the services requires a contract with the CDCP.',
    ROZCESTNIK_LOGIN_SUBTITLE: 'Chci se přihlásit v roli /k online službám:',
    ROZCESTNIK_LOGIN_NU: 'Výpis z nezařazeného účtu online',
    ROZCESTNIK_LOGIN_NU_TEXT:
        'Služba umožňuje majiteli účtu v nezařazené evidenci získat online výpis k aktuálnímu datu',
    ROZCESTNIK_LOGIN_MU: 'Zjištění nezařazeného majetkového účtu zemřelého',
    ROZCESTNIK_LOGIN_MU_TEXT:
        'Zjištění majetkového účtu v nezařazené evidenci pro účely dodatečného projednání dědictví umožňuje dědici zjistit, zda v evidenci nezařazených účtů (tzv. nezařazený účet převzatý po zaniklém Středisku cenných papírů) je nebo není veden účet zůstavitele (zemřelého). Služba je určena těm, kteří již mají ukončeno dědické řízení.',
    ROZCESTNIK_LOGIN_NUE: 'Změny údajů u majitele nezařazeného účtu',
    ROZCESTNIK_LOGIN_NUE_TEXT:
        'Služba umožňuje majiteli nezařazeného účtu aktualizovat osobní, či adresní údaje a zapsat nebo změnit číslo bankovního účtu (např. pro účely výplaty výnosů. Údaje lze změnit pouze údaji evidovanými o majiteli účtu v základních registrech a předanými bankovní identitou.)',
    ROZCESTNIK_LOGIN_EMITENT: 'Issuer / Issuer DLT',
    ROZCESTNIK_LOGIN_EMITENT_SUB: "Contract, Issue registration / Issuer's orders",
    ROZCESTNIK_LOGIN_DLT: 'DLT account holder',
    ROZCESTNIK_LOGIN_LEI: 'LEI identifier',
    ROZCESTNIK_LOGIN_LEI_SUB1: 'LEI assignment',
    ROZCESTNIK_LOGIN_LEI_SUB2: 'LEI renewal',
    ROZCESTNIK_LOGIN_LEI_SUB3: 'LEI transfer',
    ROZCESTNIK_LOGIN_LEI_SUB4: 'LEI update',
    MAJITEL_NU: 'Unclassified account owner',
    AMLZ: 'AML',
    PRIMARNI_UPIS: 'IPO',
    VYPIS_Z_EMISE: 'Issue statement',
    ZALOZENI_UCTU: 'Create account',
    VSTUP_UCET: 'Access Account',
    VYPIS_Z_UCTU_SIMPLE: 'Statement',
    ZAPIS_ZMENY_UDAJU: 'Change of owner acount data',
    ZJISTENI_UCTU: "Deceased's account finding",
    MAJITEL_UCTU: 'Account Owner',
    UCASTNIK_CDCP: 'CDCP Participant',
    STATNI_SPRAVA: 'State administration',
    STATNI_SPRAVA_1: 'Notaries',
    STATNI_SPRAVA_2: 'Insolvency practitioners',
    STATNI_SPRAVA_3: 'Liquidators',
    STATNI_SPRAVA_4: 'Courts',
    STATNI_SPRAVA_5: 'Public Prosecution',
    STATNI_SPRAVA_6: 'Others',
    DOKUMENT_DODATEK_DETAIL_DATUM_REHGISTRACE_TEXT:
        'The Issue Registration Date means the Business Day specified by agreement between the Issuer and the CSD or the Business Day which is the earliest of 5 Business Days after the delivery of a duly filed draft of this Supplement to the CSD. The issue registration date must precede the date of delivery of the book-entry securities to the accounts of the purchasers by at least two business days.',
    PRIKAZ_DRUH_ZMENY_ZEMAILFAKT: 'Change contact e-mail',
    PRIKAZ_ZRUSENI_DATE_TOOLTIP:
        'If you choose a day other than a business day, the operation will be performed on the next business day.',
    PRIKAZ_VYTESNENI_DATUM: 'Date of publication of the decision of the General Meeting in the Commercial Register',
    PRIKAZ_VYTESNENI_PODMINKY_TEXT3:
        'This date must be set no earlier than the fifth (5th) business day after the receipt of this order by the CSD. The order shall be executed no earlier than the date of its approval by the CSD.',
    AGENDA_FORMULAR_OPPAS: 'Fill in Citizenship document type ID card or passport',
    AMLZ_AGENDA_MODAL_TEXT: 'Want to save the changes you have made?',
    AMLZ_AGENDA_MODAL_TITLTE: 'Data change detected',
    AMLZ_AGENDA_ZADOST_CONFIRM: 'Do you really want to apply?',
    AMLZ_AKTUALIZACE: 'AML update',
    AMLZ_C2_ADRESA_ERR:
        'Bank Identity did not provide us with the required personal identification information. Please contact your bank.',
    AMLZ_C2_CHECKBOXERR_AML: 'To apply, a person must have completed an AML authorization or all.',
    AMLZ_C2_CHECKBOXERR_OSOBY: 'To submit a request, a person must have User Management or All permissions completed.',
    AMLZ_C2_DISABLED:
        "One person representing the issuer must have the All entry completed in the person's authorization.",
    AMLZ_C2_DUPLICITA: 'Duplicate occurrence',
    AMLZ_C2_ISIN_PRAVA:
        'This user can only submit an ISIN request for your company. If you do not want the user to continue submitting requests, contact the user.',
    AMLZ_C2_OBCANSTVI_ERR: 'Valid documents not provided. Contact your bank.',
    AMLZ_C2_PLATINSTRUKCE_ERR: 'Insert payment confirmation',
    AMLZ_C2_PUT_SUCCESS: 'Data has been saved',
    AMLZ_C2_UCTY_MSG_NOVYVSECHNYUCTY: 'All managed user accounts will be moved to the new login method.',
    AMLZ_C2_UCTY_MSG_UZIVJEDENUCET:
        'Only the given issuer account will be moved. Other managed accounts will remain under the current login method. If you need to move other accounts, you need to update the relevant AML.',
    AMLZ_C2_UCTY_MSG_UZIVVSECHNYUCTY: 'All managed user accounts will be moved to the new login method.',
    AMLZ_C5_PEP_DEL_ERR:
        'The person cannot be removed because the information provided by BankdId indicates that the person is a PEP.',
    AMLZ_C6_DISABLED: 'Not all persons in C2 are processed',
    AMLZ_C6_DISABLED_C2:
        "One person representing the issuer (C2) must have the All entry completed in the person's authorization.",
    AMLZ_C6_DISABLED_C2DLT:
        'Error loading the person representing the legal entity. The questionnaire for checking the legal entity according to AMLZ cannot be sent.',
    AMLZ_C6_DISABLED_C2_DUPLICITA: 'Due to duplicate persons, it is not possible to proceed',
    AMLZ_CERT_TEXT: 'The certificate must be completed by the person via the link.',
    AMLZ_DLT_POTVRZENI_CHECKBOX: 'I agree with the terms of the account agreement in the DLT Register',
    AMLZ_DLT_POTVRZENI_I: 'I. Rights and obligations',
    AMLZ_DLT_POTVRZENI_I1:
        '(1) By this agreement, CDCP undertakes to establish an account for the account holder of dematerialized securities in the DLT Register maintained by the central depository and subsequently provide the account holder with services related to its management.',
    AMLZ_DLT_POTVRZENI_I2:
        '(2) Based on this agreement, CDCP will allow the account holder to give instructions for the registration or change of account holder data, for the settlement of transfers or transitions of dematerialized securities, for the issuance of a asset account statement, and for the provision of other services related to dematerialized securities, as provided by legal regulations or DLT register rules.',
    AMLZ_DLT_POTVRZENI_I3:
        '(3) The account holder is responsible for the accuracy and completeness of the instructions given to the central depository. The account holder gives instructions to CDCP in accordance with the DLT register rules and in accordance with the facts entitling them to request the execution of the instruction. Upon request, the account holder is obliged to prove the legitimacy of the instruction to CDCP and provide documents.',
    AMLZ_DLT_POTVRZENI_I4:
        '(4) CDCP and the account holder have agreed that the account holder will submit requests for the issuance of statements, instructions for registrations, and settlement of transfers through the DLT Depository application. Based on the agreement between CDCP and the account holder, the instruction can be provided based on a written request, accompanied by documents proving the requested registration.',
    AMLZ_DLT_POTVRZENI_II: 'II. Price and payment terms',
    AMLZ_DLT_POTVRZENI_II1:
        '(1) The account holder undertakes to pay CDCP for the services provided in the amount and manner specified by the DLT Price List of the central depository (hereinafter referred to as the "price list"), published on the CDCP website.',
    AMLZ_DLT_POTVRZENI_II2:
        '(2) The account holder is also obliged to pay CDCP the fees specified in the price list for violations of the relevant obligations arising from the DLT Register rules or the price list.',
    AMLZ_DLT_POTVRZENI_II3:
        '(3) CDCP is entitled to change the prices specified in the price list. CDCP notifies the account holder of changes to the price list through the DLT Register web and mobile application. If the account holder does not reject the changes to the price list concerning their position before the proposed effective date of the changes, the new wording becomes binding for both parties, otherwise, the changes can be rejected by a written termination of the agreement.',
    AMLZ_DLT_POTVRZENI_III: 'III. Other arrangements',
    AMLZ_DLT_POTVRZENI_III1:
        '(1) The mutual rights and obligations of the contracting parties not regulated by this agreement are also governed by the DLT register rules, ZPKT, and Regulation (EU) 858/2022 on a pilot regime for market infrastructures based on distributed ledger technology and amending Regulations (EU) No 600/2014 and (EU) No 909/2014 and Directive 2014/65/EU (hereinafter referred to as "DLTR").',
    AMLZ_DLT_POTVRZENI_III2:
        '(2) CDCP is entitled to change the DLT register rules. The changes become effective upon publication on the website www.cdcp.cz (hereinafter referred to as the "website"), unless otherwise specified by the central depository. If the account holder does not reject the changes to the DLT register rules concerning their position before the proposed effective date of the changes, the new wording becomes binding for both parties, otherwise, the changes can be rejected by a written termination of the agreement.',
    AMLZ_DLT_POTVRZENI_III3:
        '(3) The account holder acknowledges that the DLT Register is maintained in a pilot regime according to DLTR, has a temporary character, and can be terminated at any time. In the event of the termination of the pilot regime, issuers in the DLT Register will be offered the possibility of a free transfer of their records to the central register, which is not maintained on DLT. Opening an account in the central register requires the services of a central depository participant.',
    AMLZ_DLT_POTVRZENI_III4:
        '(4) The agreement is concluded for an indefinite period and can be terminated by either party with a one-month notice period, which begins on the first day of the calendar month following the month in which the notice was delivered to the other party. The termination of the agreement by the account holder does not have legal effects against CDCP until the dematerialized securities are transferred to a new account, and the account holder undertakes to pay CDCP for the services according to the valid price list even after the termination of the agreement. The termination of this agreement also occurs in the event of a decision to terminate the pilot regime.',
    AMLZ_DLT_POTVRZENI_III5:
        '(5) The account holder acknowledges that CDCP will process the provided personal data as a controller. The processing will be carried out for the purposes of fulfilling the contractual relationship and possibly for the purposes of protecting the legitimate interests of CDCP. Further information on the processing of personal data is provided on the CDCP website.',
    AMLZ_DLT_POTVRZENI_SUB: 'Contractual agreement terms',
    AMLZ_DLT_POTVRZENI_TITLE: 'Agreement with the terms of the account agreement in the DLT Register',
    AMLZ_OSOBA_PODPIS_TEXT: 'If you want to change the data you have entered, first remove the signed file.',
    AMLZ_OSOBY_MENU: 'List of persons acting on behalf of the issuer',
    AMLZ_OSOBY_MENU_LEGALENTITY: 'List of persons acting on behalf of the legal entity',
    AMLZ_OSOBY_TEXT: 'If you want to edit persons, update the amlz request.',
    AMLZ_POSLAT_EMAIL: 'Send a link to complete the data',
    AMLZ_TYPZADOSTI_AMLZPO: 'Amlz',
    AMLZ_TYPZADOSTI_C2AKTAM: 'Administrator of the issue updates the person',
    AMLZ_TYPZADOSTI_C2AKTEM: 'Issuer updates the person',
    AMLZ_TYPZADOSTI_C2AKTEM_PO: 'Legal entity updates the person',
    AMLZ_TYPZADOSTI_C2NOVYAM: 'Administrator of the issue establishes a new person',
    AMLZ_TYPZADOSTI_C2NOVYEM: 'Issuer establishes a new person',
    AMLZ_TYPZADOSTI_C2NOVYEM_PO: 'Legal entity establishes a new person',
    AMLZ_TYPZADOSTI_C2ZRUSAM: 'Access revoked',
    AMLZ_TYPZADOSTI_C2ZRUSAMPO: 'Access revoked',
    AMLZ_TYPZADOSTI_C2ZRUSEM: 'Access revoked',
    AMLZ_TYPZADOSTI_C2ZRUSEMPO: 'Access revoked',
    AMLZ_TYPZADOSTI_PRISTUPAMLZ: 'Access to AMLZ',
    AMLZ_TYPZADOSTI_PRISTUPAMLZPO: 'Access to AMLZ',
    AMLZ_TYPZADOSTI_PRISTUPC2AMLZ: 'Access to administrator of the issue persons management',
    AMLZ_TYPZADOSTI_PRISTUPC2EM: 'Access to issuer persons management',
    AMLZ_TYPZADOSTI_PRISTUPC2EMPO: 'Access to legal entity persons management',
    AMLZ_ZADOST_MENU: 'Request for access to AML',
    AMLZ_ZADOST_TEXT:
        'You are not allowed to update AMLZ. If you are authorized to submit AMLZ, use the Authorization to submit AMLZ.',
    AUTENTIZACE: 'Authentication',
    AUTH_NOVY: 'New login',
    AUTH_PUVODNI: 'Original login',
    BANKOVNI_UCET: 'Bank account',
    BANKSIGN_ERR: 'BankID failed to complete the requested action. Try again later or contact the administrator.',
    BANK_UCET_EMITENT: "Issuer's bank account",
    BANK_USEDTO_LOGIN: 'Bank used for login',
    BIC_BANKY: 'Bank BIC',
    BIC_BANKY_INVALID: 'Invalid Bank BIC',
    BISIGN: 'BankID SIGN',
    C2_BANKID_LOGIN_ERR: 'To use BankID for new authentication, you must choose the BankID identification method.',
    C2_OSOBA_DOKLADY_TOTOZ_TEXT:
        'Notice: The fee for verifying each person acting on behalf of the issuer through two identity documents is 150 CZK. To complete the identification within AML, it is necessary to attach proof of payment of the fee from an account held in the name of the issuer. You can use the free identification option through Bank Identity or through a certificate.',
    C2_OSOBA_PODEPSAT_BANKID: 'Sign with BankID',
    CASTKA_MENA: 'Amount in currency',
    CENA_CP: 'Price for securities',
    CENNE_PAPIRY_BLOCKCHAIN: 'SECURITIES ON BLOCKCHAIN TECHNOLOGY',
    CENTRALNI_DEPOZITAR: 'CENTRAL SECURITIES DEPOSITORY',
    CENTRAL_GOVERNMENT_BR: 'CENTRAL GOVERNMENT',
    CHYBA_SLUZBY_NELZEISIN: "Invalid ISIN'84.",
    CISLO_BANKY: 'Bank code.',
    CISLO_MAJETKOVEHO_UCTU: 'Asset account number',
    CISLO_ZASTAVNI_SMLOUVY_ROW: 'Pledge contract number/PPN',
    CODE: 'Code',
    DASHBOARD_CARD_PROFIL_ADMINVFO: 'Profile Administrator of the investment fund',
    DASHBOARD_CARD_UCTY_ADMINVFO: 'Administrator of the investment fund – Overview, management, services',
    DASHBOARD_CARD_UCTY_TEXTY: 'Administrator – application text',
    DATUM_EMISE: 'Issue date in the issue conditions',
    DATUM_EX_JISTANA: 'Ex-principal date',
    DATUM_EX_KUPONU: 'Ex-coupon date',
    DATUM_SPALTNOSTI_DLOUHOPISU: 'Bond maturity date',
    DATUM_SPLACENI_EMISE: 'Date of gradual repayment of the issue',
    DATUM_VYPLATA_KOUPONU: 'The record date for coupon payment precedes the payment date by a number of days',
    DATUN_UHRADY_LATEST: 'Latest payment date',
    DELETE_CONFIRM_C2_TEXT: 'Do you really want to remove this person?',
    DELETE_CONFIRM_C2_TEXT_ALT: 'Do you really want to cancel this request?',
    DELETE_CONFIRM_TEXT: 'Do you really want to delete',
    DFP_TEXT1: 'DFP - Delivery free of payment',
    DFP_TEXT2: "Payments are made to the issuer's account specified during registration",
    DLT_MENU_PRAVNICKE_OSOBY_DETAIL: 'Legal entity management',
    DLT_MENU_PRAVNICKE_OSOBY_PREHLED: 'Overview of legal entities',
    DOTAZNIK_PEP_ZRIZOVATELMAJ:
        'The origin and extent of the property are not stated because the client is a legal entity established by state institutions, territorial self-governing units, or controlled by them.',
    EMITENT_PREHLED_TEXT_ADMEMIT:
        'To view the list of persons, you must have the right to Persons acting on behalf of the issue administrator (user management) or AMLZ. If you have the right to act on behalf of the issuer, please submit a request for completion.',
    EMITENT_PREHLED_TEXT_EMITENT:
        'To view the list of persons, you must have the right to Persons acting on behalf of the issuer (user management) or AMLZ. If you have the right to act on behalf of the issuer, please submit a request for completion.',
    EMITENT_PREHLED_TEXT_LEGALENTITY:
        'You currently do not have access to the legal entity. If you are authorized to access the legal entity, use the option bold(Request for access to the legal entity).',
    EMITENT_PREHLED_TITLE_ADMEMIT: 'Persons authorized to represent the issue administrator',
    EMITENT_PREHLED_TITLE_EMITENT: 'Persons authorized to represent the issuer',
    EMITENT_PREHLED_TITLE_LEGALENTITY: 'Persons authorized to represent the legal entity',
    EMITENT_UCET_ZRUSENI_SUCC: 'The account has been successfully deactivated',

    EMITENT_ZASTUPUJICI_OSOBY_BEZPRAVA:
        'To view the list of persons, you must have the right to act on behalf of the issuer (user management) or AMLZ. If you have the right to act on behalf of the issuer, please submit a request for addition.',
    EMITENT_ZASTUPUJICI_OSOBY_ROZP: 'Authorization to submit AMLZ',
    EMP_PODANE_ZADOSTI_CEKA: 'Pending request processing',
    EMP_PODANE_ZADOSTI_KDOPL: 'To be completed',
    EMP_PODANE_ZADOSTI_NAZEV_PO: 'Name of the legal entity',
    EMP_PODANE_ZADOSTI_ROZP: 'In progress',
    EMP_POTVRZENI_EMAIL_200_AUTENTIZACE: 'Invalid username or password.',
    EMP_POTVRZENI_EMAIL_200_DUPLICITA: 'Change cannot be made, user already exists.',
    EMP_POTVRZENI_EMAIL_200_OK: 'Email change request was successfully sent.',
    ERR_BOUNDARY_HEAD: 'Application error',
    ERR_BOUNDARY_TEXT: 'We apologize, but an unexpected error occurred in the application:',
    ERR_BOUNDARY_ZNOVU: 'Go to the home page and try the action again.',
    FORMULARE_AMLZ_C1_TITLE_LEGALENTITY: 'C1 - Basic information about the legal entity',
    FORMULARE_AMLZ_C2_TITLE_LEGALENTITY: 'C2 – Information about all individuals representing the legal entity',
    FORMULARE_AMLZ_C3A_PODILNIKTEXT_LEGALENTITY:
        'C3A – Information about the ownership and management structure of the legal entity – DIRECT ownership',
    FORMULARE_AMLZ_C3A_SELECT_LEGALENTITY: 'There is a shareholder who directly owns more than 10% of the legal entity',
    FORMULARE_AMLZ_C3A_TITLE_LEGALENTITY:
        'C3A – Information about the ownership and management structure of the legal entity – DIRECT ownership',
    FORMULARE_AMLZ_C3A_TOOLTIP_LEGALENTITY:
        'Shareholders are understood to be natural and legal persons who hold a share in the company. Primarily, the legal entity fills in all shareholders who own more than 10% of the legal entity, i.e., especially partners in s.r.o. and shareholders in a.s. If a shareholder, a legal entity, reaches 10% together with another (sister) legal entity controlled by the same person (parent company or natural person), this parent company or natural person is listed as an indirect shareholder in part C3B.',
    FORMULARE_AMLZ_C3B_PODILNIK: 'Indirect shareholder',
    FORMULARE_AMLZ_C3B_SELECT_LEAGLENTITY:
        'There is a shareholder who indirectly owns more than 10% of the legal entity',
    FORMULARE_AMLZ_C3B_TEXT_LEGALETITY:
        'Provide information about shareholders who indirectly own more than 10% of the legal entity',
    FORMULARE_AMLZ_C3B_TITLE_LEGALENTITY:
        'C3B – Information about the ownership and management structure of the legal entity – INDIRECT ownership',
    FORMULARE_AMLZ_C3B_TOOLTIP_LEGALENTITY:
        "Provide information about the natural or legal person who controls the direct shareholders who are not listed as direct shareholders in part C3A, but whose combined shares exceed 10% of the legal entity's capital.",
    FORMULARE_AMLZ_C4_TITLE_LEGALENTITTY: 'C4 – Information about the actual owner of the legal entity',
    FORMULARE_AMLZ_C5_TEXT_PROHLASENI_LEGALENTIY:
        'The legal entity declares that the natural person acting on behalf of the client and its actual owner',
    FORMULARE_AMLZ_C5_TITLE_LEGALENTITY:
        'C5 – Declaration of the legal entity for the identification of a politically exposed person (PEP)',
    FORMULARE_AMLZ_C6_SUBTITLE_LEGALENTITY: 'The questionnaire for the legal entity is submitted by',
    FORMULARE_AMLZ_C6_TITLE_LEGALENTITY: 'C6 – The legal entity commits',
    FORMULARE_BISIGN_PODPIS: 'Sign with BankSign',
    FORMULARE_DOKLADY_TOTOZNOSTI_DISABLED: 'Two identity documents',
    FORMULARE_DRUH_DOKLADU_JINY: 'Another type of document',
    FORMULARE_JINE_OPRAVNENI_DISABLED: 'Other authorization',
    FORMULARE_PLNAMOC: 'Power of attorney',
    FORMULARE_PLNA_MOC_DISABLED: 'Notarized power of attorney with electronic conversion',
    FORMULARE_PODEPSANY_SOUBOR_DISABLED: 'Signed file',
    FORMULARE_PROVOZOVNA_STATY_LEGALENTITY:
        'Complete all countries where the legal entity has a branch, organizational unit, or establishment',
    FORMULARE_ZASTUPUJICI_OSOBA_LEGALENTITY: 'The person representing the legal entity is',
    FORMULARE_ZASTUPUJUCE_OSOBY_PRIDAT_TEXT: 'Users who do not have the right to act on behalf of the issuer',
    FORMULARE_ZASTUPUJUCE_OSOBY_TEXT_LEGALENTITY:
        'Fill in the details of all individuals authorized to represent the legal entity independently in dealings with CDCP in relation to the DLT asset account (based on legal representation or power of attorney)',
    IDENTIFIKACE_OSOBY: 'Person identification',
    IDENTIFIKACE_OSOBY_KOD: 'Enter the code you received in the SMS message',
    IDENTIFIKACE_OSOBY_LEGALENTITY: 'Questionnaire for the control of the legal entity according to AMLZ',
    IDENTIFIKACE_OSOBY_TEXT: 'To access the request, you will be sent an SMS with a code.',
    IDENTIFIKACE_OSOBY_ZADOST_LEGALENTITY_TEXT:
        'Your person does not have the right to access the legal entity DLT. Identify yourself and provide your authorization.',
    IDENTIFIKACE_OSOBY_ZADOST_TEXT:
        'Your person does not have the right to the AMLZ agenda. Identify yourself and provide your authorization.',
    IDENTIFIKACE_TEXT: 'To verify your phone number, you will be sent an SMS with a code',
    INVALID_CISLOUCTU: 'Invalid bank account number',
    INVALID_KODBANKY: 'Invalid bank code',
    INVALID_PREDCISLI: 'Invalid bank account prefix',
    JINY_DRUH_AKCIE_POPIS: 'Description of another type of share',
    KONTROLA: 'Control in progress',
    LOADING_PXKLIC: 'Waiting for approval in the PX Key application',
    NELZE_POKRACOVAT_NELZEAML: 'Cannot continue due to AMLZ update, performed by user:',
    NELZE_POKRACOVAT_NELZEC2: 'Cannot continue due to update of persons, performed by user:',
    NEVALIDNI_POVINNA_POLOZKA_UPLOAD: 'Upload file',
    NEVALIDNI_PROCENTA_100_06_0: 'Value must be greater than 0',
    NEVALIDNI_TEL: 'Invalid phone number',
    NEVALIDNI_UCET: 'Invalid account number',
    NOTFOUND_TEXT: 'We apologize, but the requested page was not found',
    NOTFOUND_TITLE: 'Page not found',
    NOVA_JMENOVITAHODNOTA: 'New nominal value',
    NOVA_OSOBA: 'New person',
    NOVA_PRAVNICKA: 'New legal entity',
    NOVA_PRILOHA: 'New attachment',
    NOVY_ADMIN: 'New issue administrator',
    NOVY_DOKUMNET: 'New document',
    NOVY_UCET_CERTIFIKAT: 'Invalid certificate',
    NOVY_UCET_DUPLICITA: 'Account for the given customer already exists',
    NOVY_UDAJ: 'New data',
    NOVY_UDAJE: 'New data',
    OBCANSTVI_DOKLAD_JINE: 'Another document',
    OBCANSTVI_DOKLAD_OBCANKA: 'Identity card',
    OBCANSTVI_DOKLAD_PAS: 'Passport',
    OBCANSTVI_DOKLAD_RIDICAK: "Driver's license",
    ODHLASIT_PRO_NEAKTIVITU: 'Logout in',
    ODSTRANIT_OSOBU: 'Remove person',
    OSOBA_JE: 'The person is',
    OSOBY: 'Persons acting on behalf of the issuer',
    OSOBY_ADMIN: 'Persons acting on behalf of the issue administrator',
    OSOBY_LEGALENTITY: 'Persons acting on behalf of the legal entity',
    PLATEBNI_INSTRUKCE: 'Payment instructions',
    PODANE_DOKUMENTY: 'Submitted documents',
    PODEPISUJICI_OSOBA: 'Signing person',
    PODEPSAT: 'Sign',
    PODEPSAT_BISIGN: 'Sign with BankID SIGN',
    PODEPSAT_CERT: 'Upload signed document',
    PODEPSAT_CERT_BTN: 'Download document for signing with certificate',
    PODPIS: 'Signature',
    PODPIS_CONFIRM_SUCC: 'Signature was successful',
    POTVRDENI: 'Confirmation',
    POTVRDIT_UDAJE: 'Confirm data accuracy',
    PRAVO_ZADOST_EXPIRED: 'This link has expired',
    PREDCISLI_UCTU: 'Account prefix',
    PREDVOLBA_VAL_ERR: 'Please select a prefix',
    PRISTUPDEPOZITAR_ANO: 'Yes',
    PRISTUPDEPOZITAR_NE: 'No',
    PRISTUPDEPOZITAR_POZDEJI: 'Later',
    RESPONSE_ERROR_403:
        'An error occurred during processing, you can try to get the output again or contact the application administrator.',
    RESPONSE_ERROR_408:
        'An error occurred during processing, you can try to get the output again or contact the application administrator.',
    SMS_INVALID: 'Invalid SMS code',
    SMS_RESEND_BTN: 'Resend SMS code',
    SMS_RESEND_TXT: "Didn't receive an SMS?",
    SOUBOR_CERTOSOBA_PODPIS: 'The attached certificate does not match the specified person.',
    SOUBOR_JINAOSOBA_PODPIS: 'Different data are recorded for the user at another company. Please check',
    SOUBOR_JINYSOUBOR_PODPIS: 'A different file was uploaded, download the form for signing and upload the signed form',
    SPRAVCE_TEXTY_TEXT: 'Here you can change the application texts in edit mode',
    SPRAVOVANE_ADMINVFO: 'Managed accounts Investment fund',
    SPRAVOVANE_PODLT: 'Legal entities',
    SPRAVOVANE_PRAVICKE_ZADNE_TEXT:
        'You currently do not have access to any DLT asset account for a legal entity. If you are authorized to access the DLT asset account for a legal entity, use the option bold(New legal entity).',
    STAVZADOSTI_SIMPLE_AUTKONTROLA: 'Processing in progress',
    STAVZADOSTI_SIMPLE_CDCPCEKA: 'Waiting for CDCP processing',
    STAVZADOSTI_SIMPLE_CDCPDOPL: 'Returned for completion',
    STAVZADOSTI_SIMPLE_CDCPKDOPL: 'To be completed',
    STAVZADOSTI_SIMPLE_CDCPKEKONTR: 'Processing in progress',
    STAVZADOSTI_SIMPLE_CDCPKEKONTR_ALT: 'Processed',
    STAVZADOSTI_SIMPLE_CDCPKONTR: 'Processing in progress',
    STAVZADOSTI_SIMPLE_CEKA: 'Processing in progress',
    STAVZADOSTI_SIMPLE_DOPL: 'In progress',
    STAVZADOSTI_SIMPLE_HOTOVO: 'Processed',
    STAVZADOSTI_SIMPLE_HOTOVOIIS: 'Processed',
    STAVZADOSTI_SIMPLE_INI: 'To be completed',
    STAVZADOSTI_SIMPLE_KDOPL: 'Waiting for completion',
    STAVZADOSTI_SIMPLE_PRIDAT: 'Possible persons',
    STAVZADOSTI_SIMPLE_ROZP: 'In progress',
    STAVZADOSTI_SIMPLE_UZIVCEKA: 'Waiting for data completion',
    STAVZADOSTI_SIMPLE_UZIVDOPL: 'Check the data',
    STAVZADOSTI_SIMPLE_UZIVEMAIL: 'Resend email',
    STAVZADOSTI_SIMPLE_UZIVEMAIL_ALT: 'Send link to complete data',
    STAVZADOSTI_SIMPLE_UZIVKDOPL: 'Waiting for data completion',
    STAVZADOSTI_SIMPLE_ZAMITNUTO: 'Rejected',
    STAV_ZPRACOVANI: 'Processing status',
    TYP_PRIHLASENI_BANKID: 'Bank ID',
    TYP_PRIHLASENI_BI: 'Bank identity',
    TYP_PRIHLASENI_DLT: 'Bank identity',
    TYP_ZADOSTI_TITLE: 'Request type',
    UCET_EMITENT: 'Issuer account',
    UCET_LEGALENTITY: 'Legal entity bank account',
    UCET_LEGALENTITY_TOOLTIP:
        'Bank account for the purpose of settlement of transfers against payment and for the purpose of paying out yields.',
    UCET_NEEXISTUJE: 'No user access is recorded for you.',
    UCET_NOVY_ADMEMIT: 'New issue administrator account',
    UZIVATELSKE_JMENO_NOVE: 'New username (email)',
    UZIVATEL_STAV_N: 'Inactive',
    ZADOST_C2_BANKUCET: "Issuer's bank account number",
    ZADOST_O_DOPLNENI_OSOBY: 'Request for access to person management',
    ZADOST_O_KOMUNIKACI: 'Person identification for communication with CDCP',
    ZADOST_PRAVO_AMLZ: 'AML manager',
    ZADOST_PRAVO_AMLZ_TOOLTIP:
        'submits/updates AML and manages persons acting on behalf of the issuer. If the issuer is not required to submit AML, it only identifies persons acting on behalf of the issuer (C2)',
    ZADOST_PRAVO_IDENTIFIKACE_BI: 'BankID',
    ZADOST_PRAVO_IDENTIFIKACE_DOC_TEST: 'First fill in all the details and then download the document and sign it',
    ZADOST_PRAVO_IDENTIFIKACE_EL: 'Signature - qualified certificate',
    ZADOST_PRAVO_IDENTIFIKACE_SC: 'Copy of two identity documents',
    ZADOST_PRAVO_OPRAVNENI: 'Person authorization',
    ZADOST_PRAVO_PRIKAZY: "Issuer's orders/notifications",
    ZADOST_PRAVO_PRIKAZY_TOOLTIP:
        'Change of issuer data, reduction/increase of share capital, splitting, merging, squeezing out and other operations',
    ZADOST_PRAVO_SMLOUVY: 'Contracts/amendments',
    ZADOST_PRAVO_SMLOUVY_TOOLTIP:
        'Conclusion of a contract for the management/registration of an issue, reduction/increase in the number of securities in the issue',
    ZADOST_PRAVO_SRD: 'Services according to SRD II',
    ZADOST_PRAVO_SRD_TOOLTIP:
        'The issuer sends information, e.g., about the annual meeting (for the issuer on the regulated market of the EU, it is obligatory to inform about the VH in this way)',
    ZADOST_PRAVO_TEXT: 'For other authorizations, it is necessary to change the authentication method',
    ZADOST_PRAVO_TEXT2:
        'A person authorized to represent the issuer may submit an ISIN request. For this request, CDCP does not require proof of representation authorization.',
    ZADOST_PRAVO_UPIS: 'Primary subscription right (reduction/increase)',
    ZADOST_PRAVO_UPISSICAV: 'Primary subscription SICAV/OPF (reduction/increase)',
    ZADOST_PRAVO_UPIS_TOOLTIP: 'Entering subscription instructions – list of acquirers',
    ZADOST_PRAVO_UZIVATELE: 'Persons acting on behalf of the issuer (user management)',
    ZADOST_PRAVO_VIDETVYPIS: 'Right to see statements submitted by other issuer users',
    ZADOST_PRAVO_VIDETVYPIS_TOOLTIP:
        'The user can see and download the issue statement submitted by another issuer user (representation of multiple persons)',
    ZADOST_PRAVO_VYPIS: 'Issue statement and services for calculating average prices',
    ZADOST_PRISTUP: 'Can access the My Depository application?',
    ZADOST_PRISTUP_AUTH: 'New authentication method for My Depository',
    ZADOST_PRISTUP_AUTH_NEMA: 'Authentication method for My Depository',
    ZADOST_PRISTUP_AUTH_TEXT:
        'The change in the login method will occur after the AMLZ questionnaire is approved by the officer',
    ZADOST_PRISTUP_BAKIND_BTN: 'Continue with BankID',
    ZAKLADNI_UDAJE_O_PRAVNICKE_OSOBE: 'Questionnaire for the control of the legal entity according to AMLZ',
    ZASLAT_SMS_KOD: 'Send SMS code',
    ZKONTROLUJTE: 'Check',
    ZMENA_UCTU: 'Account change',
    ZMENIT_LOGIN: 'Change username (email)',
    JINA_OSOBA: 'Other person',
    JINA_OSOBA_TEXT:
        'Persons other than those expressly mentioned above who are entitled to request registration in the register in special cases, such as a liquidator or successor of the issuer in the event of a merger, provided that the legitimacy of the request is proven.',
    DOKUMENTY_PRIKAZ_EMISELIKV: 'Order by another person to cancel the issue – liquidation',
    DOKUMENTY_PRIKAZ_EMISEFUZE: 'Order by another person to cancel the issue – merger',
    DOKUMENTY_PRIKAZ_ZMENFUZE: 'Order by another person for another change',
    DOKUMENTY_PRIKAZ_VYPIS: 'Request for an extract from the issue as of the date of cancellation',
    PW_STRENGTH_TOO_WEAK: 'Too Weak',
    PW_STRENGTH_WEAK: 'Weak',
    PW_STRENGTH_MODERATE: 'Moderate',
    PW_STRENGTH_STRONG: 'Strong',
    PW_STRENGTH_VERY_STRONG: 'Very Strong',
    PW_CHECKING: 'Checking password against breaches...',
    PW_CHECK_FAIL: '⚠️ This password has appeared in known data breaches. Choose a more secure one.',
    PW_CHECK_SUCCESS: '✅ This password has not been found in known breaches.',
    CZK: 'Czech Koruna',
    EUR: 'Euro',
    CRS_AKTUALIZACE: 'Update CRS',
    CRS_HISTORIE: 'Historical CRS',
    ISIN_IDENTIFIKACE_FIRMA_LEGALENTITY: 'Trade name or other name of the legal entity',
    ISIN_IDENTIFIKACE_ADRESA_LEGALENTITY: 'Registered office address of the legal entity',
    ISIN_IDENTIFIKACE_ADRESA_LEGALENTITY_ALT:
        "The shipping address is different from the legal entity's registered office",
    DOTAZNIK_CRS: 'CRS Entity Self-Certification Form',
    CRS_STAT_TAX: "Entity's country of tax residence",
    CRS_OSOBY_CR: 'All Controlling Persons are tax resident in the Czech Republic',
    CRS_STATUS: 'CRS Entity Classification',
    CRS_STATUS_1_INFO: '1. Financial Institution – Investment Entity',
    CRS_STATUS_1A_INFO_TITLE:
        'a) Investment Entity located in a Non-Participating Jurisdiction and managed by another Financial Institution',
    CRS_STATUS_1A_INFO:
        'Select this option if the Entity qualifies as an Investment Entity (i.e. its activities or gross income are primarily attributable to investing, reinvesting, trading in financial assets or portfolio management), is tax resident in a Non-Participating Jurisdiction and is managed by another Financial Institution.',
    CRS_STATUS_1B_INFO_TITLE: 'b) Other Investment Entity',
    CRS_STATUS_1B_INFO:
        'Select this option if the entity is an investment entity (i.e. its activities or income consist predominantly of investing, reinvesting or trading in financial assets, or portfolio management), and the country of its tax residence is a participating jurisdiction.',
    CRS_STATUS_2_INFO_TITLE:
        '2. Financial Institution – Depository Institution, Custodial Institution or Specified Insurance Company',
    CRS_STATUS_2_INFO:
        'Select this option if the Entity accepts deposits, maintains deposit accounts, holds financial assets for the account of customers, provides custody services, or is a bank, custodian or specified insurance company.',
    CRS_STATUS_3_INFO: '3. Active Non-Financial Entity',
    CRS_STATUS_3B_INFO_TITLE:
        'b) Non-Financial Entity that is a Related Entity of an Entity whose shares are regularly traded on an established securities market',
    CRS_STATUS_3B_INFO:
        'Select this option if the Entity is related to another Entity through ownership exceeding 50%.',
    CRS_STATUS_3E_TITLE: 'e) Other Active Non-Financial Entity – other than under point 3 a)–d).',
    CRS_STATUS_3E_INFO:
        "Select this option if less than 50% of the Entity's gross income for the preceding calendar year or other appropriate reporting period is passive income and less than 50% of the assets held by the Entity during such period are assets that produce, or are held for the production of, passive income.",
    CRS_STATUS_4_INFO_TITLE: '4. Passive Non-Financial Entity',
    CRS_STATUS_4_INFO:
        'Select this option if the Entity predominantly derives passive income and holds passive assets (typically investment income, interest, dividends or rental income) and does not qualify as an Active Non-Financial Entity. More than 50% of its gross income is passive income.',
    CRS_STATUS_STS1A:
        '1a) Investment Entity located in a Non-Participating Jurisdiction and managed by another Financial Institution',
    CRS_STATUS_STS1B: '1b) Other Investment Entity',
    CRS_STATUS_STS2:
        '2. Financial Institution – Depository Institution, Custodial Institution or Specified Insurance Company',
    CRS_STATUS_STS3A: '3a) Non-Financial Entity whose shares are regularly traded on an established securities market',
    CRS_STATUS_STS3B:
        '3b) Non-Financial Entity that is a Related Entity of an Entity whose shares are regularly traded on an established securities market',
    CRS_STATUS_STS3C: '3c) Governmental Entity or Central Bank',
    CRS_STATUS_STS3D: '3d) International Organisation',
    CRS_STATUS_STS3E: '3e) Other Active Non-Financial Entity – other than under point 3a) – d)',
    CRS_STATUS_STS4: '4) Passive Non-Financial Entity',
    CRS_STATUS_INFO_BLIZSIE: 'Further information: Annex No. 1, Part D, to Act No. 164/2013 Coll., as amended',
    CRS_OSOBA: 'Type of Controlling Person',
    CRS_OSOBA_CRS801: 'Controlling Person of a Legal Entity – Control through Ownership',
    CRS_OSOBA_CRS802: 'Controlling Person of a Legal Entity – Control by Other Means',
    CRS_OSOBA_CRS803: 'Controlling Person of a Legal Entity – Senior Managing Official',
    CRS_OSOBA_CRS804: 'Settlor of a Trust',
    CRS_OSOBA_CRS805: 'Trustee of a Trust',
    CRS_OSOBA_CRS806: 'Protector of a Trust',
    CRS_OSOBA_CRS807: 'Beneficiary of a Trust',
    CRS_OSOBA_CRS808: 'Other Controlling Person of a Trust',
    CRS_OSOBA_CRS809: 'Settlor Equivalent',
    CRS_OSOBA_CRS810: 'Trustee Equivalent',
    CRS_OSOBA_CRS811: 'Protector Equivalent',
    CRS_OSOBA_CRS812: 'Beneficiary Equivalent',
    CRS_OSOBA_CRS813: 'Other Equivalent Controlling Person',
    CRS_OSOBY: 'Controlling Persons',
    CRS_OSOBA_BYDLISTE_DAN_INFO1: 'Please specify all jurisdictions in which the Controlling Person is tax resident.',
    CRS_OSOBA_BYDLISTE_DAN_INFO2:
        'If you indicate a country other than the Czech Republic, you must provide the TIN or state the reason why no TIN has been assigned.',
    CRS_DOTAZNIK_PROHLASENI: 'DECLARATION',
    CRS_DOTAZNIK_PROHLASENI_TEXT1:
        '1. I declare that all information provided in this form is, to the best of my knowledge and belief, true, accurate and complete.',
    CRS_DOTAZNIK_PROHLASENI_TEXT2:
        '2. I acknowledge that the information provided may be reported to the tax authority, which may transmit such information to the tax authorities of the countries in which the account holder is a tax resident.',
    CRS_DOTAZNIK_PROHLASENI_TEXT3:
        '3. I declare that I am authorised to act and sign this form on behalf of the account holder or, where relevant, on behalf of the controlling person, and that I will inform the controlling persons that their information is being provided to CDCP and may be transmitted to the Specialised Tax Office.',
    CRS_DOTAZNIK_PROHLASENI_TEXT4:
        '4. I undertake to notify CDCP of any change in the information provided within 30 days.',
    POTVRZENI_CHECKBOX: 'I agree to the terms and conditions',
    CRS_GIIN: 'Enter your GIIN, if assigned',
    CRS_OSOBY_ADRESA_ALT: 'The shipping address is different from the permanent residence address',
    CRS_STAT_TAX_OSOBY: 'Country of residence for tax purposes',
    ZEME: 'Country',
    DIC: 'TIN (Tax Identification Number)',
    CRS_NEVYPLNENI_DIC_DUVOD: 'Reason for not filling in the TIN',
    CRS_DICDUVOD_A:
        'The country where the account holder pays income tax as a resident does not issue tax identification numbers',
    CRS_DICDUVOD_B: 'The account holder is otherwise unable to obtain a tax identification number or equivalent number',
    CRS_DICDUVOD_C: 'A tax identification number is not required'
};

/*
FUNKCIA KTORA POROVNA CESKE A ANGLICKE PREKLADY A VRATI CESKE KTORE NEMAJU PREKLAD V EN

    const englishKeys = Object.keys(english);
    const resObj = {};
    Object.keys(czech)
        .filter(e => !englishKeys.includes(e))
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .map(u => ((resObj as any)[u] = _getKeyValue_(u)(czech)));
    console.log(resObj);
*/
